import defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.array.find.js';
import 'regenerator-runtime/runtime.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/es.string.search.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/web.url.js';
import Vue from 'vue';
import Vuex, { mapGetters, mapActions } from 'vuex';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.array.find-index.js';
import 'core-js/modules/es.array.for-each.js';
import 'core-js/modules/es.array.index-of.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.array.splice.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.string.sub.js';
import 'core-js/modules/web.dom-collections.for-each.js';
import arrayWithoutHoles from '@babel/runtime/helpers/esm/arrayWithoutHoles';
import iterableToArray from '@babel/runtime/helpers/esm/iterableToArray';
import unsupportedIterableToArray from '@babel/runtime/helpers/esm/unsupportedIterableToArray';
import nonIterableSpread from '@babel/runtime/helpers/esm/nonIterableSpread';
import axios from 'axios';
import cookies from 'vue-cookies';
import Vue2Storage from 'vue2-storage';
import 'core-js/modules/es.array.slice.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.string.includes.js';
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import 'core-js/modules/es.function.name.js';
import { v4 } from 'uuid';
import 'core-js/modules/es.number.constructor.js';
import 'core-js/modules/es.string.starts-with.js';
import 'core-js/modules/es.string.link.js';
import 'core-js/modules/es.string.split.js';
import 'core-js/modules/es.array.join.js';
import { InfiniteScroller, Loader, Popover, Toast, Modal, ProfileImage, Badge } from 'vue-dms-ui-components';
import 'core-js/modules/es.symbol.js';
import 'core-js/modules/es.symbol.description.js';
import 'core-js/modules/es.string.ends-with.js';
import Draggable from 'vuedraggable';
import 'core-js/modules/es.regexp.to-string.js';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var propsMixin = {
  props: {
    apiService: {
      type: Object,
      default: function _default() {}
    }
  }
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

var SET_USER_INFO = 'SetUserInfo';
var SET_USER_TOKEN = 'SetUserToken';
var LOGOUT_USER = 'LogoutUser';
var SET_PAGE_TITLE = 'SetPageTitle';
var SET_MENU_OPEN = 'SetMenuOpen';
var SET_MENU_EXPANDED = 'SetMenuExpanded';
var SET_LAST_MENU_ITEM_OPEN_ID = 'SetLastMenuItemOpenId';
var SET_APP_NAME = 'SetAppName';
var SET_USER_READY = 'SetUserReady';
var SET_API_SERVICE = 'SetApiService';
var SET_USER_API_SERVICE = 'SetUserApiService';
var CLEAR_LOCAL_STORAGE = 'ClearLocalStorage';
var SET_MENU_RESULTS = 'SetMenuResults';
var SET_PROFILE_MENU_RESULTS = 'SetProfileMenuResults';
var SET_COMPANIES_RESULTS = 'SetCompanies';
var COMPANIES_RESULTS_KEY = 'companiesResults';
var SET_FAVORITES = 'SetFavorites';
var SET_MENU_RESULTS_STORAGE = 'SetMenuResultsStorage';
var SET_MAIN_ITEM_CLICKED = 'SetMainItemClicked';
var SET_LAST_ITEM_CLICKED = 'SetLastItemClicked';
var SET_VUE_API_SERVICE = 'SetVueApiService';
var SET_NOTIFICATION_MODAL_CONTENT = 'SetNotificationModalContent';
var SET_NOTIFICATION_MODAL_VISIBLE = 'SetNotificationModalVisible';
var SET_ACTIVE_NOTIFICATIONS = 'SetActiveNotifications';
var SET_DISMISSED_NOTIFICATIONS = 'SetDismissedNotifications';
var SET_UNSHOWN_NOTIFICATIONS = 'SetUnShownNotificationItems';
var REMOVE_SHOWN_NOTIFICATIONS = 'RemoveShownNotifications';
var REMOVE_FROM_ACTIVE_NOTIFICATIONS = 'RemoveFromActiveNotifications';
var ADD_UNSHOWN_ALERT = 'AddUnshownAlert';
var ADD_TO_ACTIVE_NOTIFICATIONS = 'AddToActiveNotifications';
var ADD_TO_DISMISSED_NOTIFICATIONS = 'AddToDismissedNotifications';
var SET_PAGE_VERSION_CONFIGKEY_ID = 'SetPageVersionConfigKeyId';
var SET_REQUEST_VERIFICATION_TOKEN = 'SetRequestVerificationToken';
var SET_IFRAME_SOURCE = 'SetIframeSource';
var SET_CURRENT_COMPANY_ID = 'SetCurrentCompanyId';
var SET_CURRENT_ROUTE_MENU_ID = 'SetCurrentRouteMenuId';
var SET_LAST_MAIN_ITEM_CLICKED = 'SetLastMainItemClicked';
var SET_APP_CONFIGS = 'SetAppConfigs';
var SET_ZONE_WARNING = 'SetZoneWarning';
var SET_AUTOLOGOFF_STATUS = 'SetAutoLogoffStatus';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function getTokenDefault() {
  var token;
  token = cookies.get('vue2tkn');
  return token;
}

var handleError = (function (err) {
  console.log(err.message);
});

function stringIsDefinedAndNotEmpty(value) {
  var isDefined = false;

  if (value !== undefined && value !== null && value !== '') {
    isDefined = true;
  }

  return isDefined;
}
function objectIsDefinedAndHasProperty(obj, propName) {
  var isDefined = false;

  if (obj !== undefined && obj !== null && Object.hasOwnProperty.call(obj, propName)) {
    isDefined = true;
  }

  return isDefined;
}

var ApiService = /*#__PURE__*/function () {
  function ApiService(_ref) {
    var userToken = _ref.userToken,
        _ref$baseUrl = _ref.baseUrl,
        baseUrl = _ref$baseUrl === void 0 ? store.getters['user/VUE_APP_API'] : _ref$baseUrl;

    _classCallCheck(this, ApiService);

    if (stringIsDefinedAndNotEmpty(userToken)) {
      this.userToken = userToken;
    } else {
      this.userToken = getTokenDefault();
    }

    this.baseUrl = baseUrl;
  }

  _createClass(ApiService, [{
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(route, signal) {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.apiClient.get(route, {
                  signal: signal
                });

              case 2:
                response = _context.sent;
                return _context.abrupt("return", this.handleResponse(response));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get(_x, _x2) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "post",
    value: function () {
      var _post = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(route, body) {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.apiClient.post(route, body);

              case 2:
                response = _context2.sent;
                return _context2.abrupt("return", this.handleResponse(response));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function post(_x3, _x4) {
        return _post.apply(this, arguments);
      }

      return post;
    }()
  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(route, body) {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.apiClient.put(route, body);

              case 2:
                response = _context3.sent;
                return _context3.abrupt("return", this.handleResponse(response));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function put(_x5, _x6) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "patch",
    value: function () {
      var _patch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(route, body) {
        var response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.apiClient.patch(route, body);

              case 2:
                response = _context4.sent;
                return _context4.abrupt("return", this.handleResponse(response));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function patch(_x7, _x8) {
        return _patch.apply(this, arguments);
      }

      return patch;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(route, body) {
        var response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.apiClient.delete(route, body);

              case 2:
                response = _context5.sent;
                return _context5.abrupt("return", this.handleResponse(response));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _delete(_x9, _x10) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "handleResponse",
    value: function handleResponse(resp) {
      if (resp.status >= 400) {
        handleError(Error(resp.message));
      }

      return resp.data;
    }
  }, {
    key: "apiClient",
    get: function get() {
      if (this._apiClient == undefined) {
        this._apiClient = axios.create({
          baseURL: this.baseUrl,
          headers: {
            Accept: 'application/json',
            Authorization: "Bearer ".concat(this.userToken)
          }
        });
      }

      return this._apiClient;
    }
  }]);

  return ApiService;
}();

function buildRoute(routeTemplate, paramObject) {
  for (var property in paramObject) {
    routeTemplate = routeTemplate.replace("{".concat(property, "}"), encodeURIComponent(paramObject[property]));
  }

  return routeTemplate;
}

/**
 * Takes in an object with properties for each page of results
 * Each page of results is an object with an items property
 * @param {*} objectArray
 * @returns
 */
function gatherItems (pageObject) {
  var items = [];

  if (pageObject) {
    for (var prop in pageObject) {
      if (Object.hasOwnProperty.call(pageObject, prop)) {
        if (pageObject[prop] && pageObject[prop].items && pageObject[prop].items.length > 0) items.push.apply(items, _toConsumableArray(pageObject[prop].items));
      }
    }
  }

  return items;
}

//require('date-fns');
var dateTimeString = function dateTimeString(jsondate) {
  //Expects UTC (unformatted) from JSON payload...
  if (typeof jsondate === 'string') {
    //forces UTC or passes it through
    //(especially if not a string type)
    jsondate = jsondate.replace('Z', '');
  }

  var utc = new Date(jsondate + 'Z');
  return localeString(utc, 'en-us');
};
var simulateIsoDate = function simulateIsoDate(jsdate) {
  var isoDate = jsdate.toISOString(); //(ISO-8601)...

  return new Date(isoDate.slice(0, -1)); //^ simulates db-server UTC by removing 'Z' in cache/store...
};
var localeString = function localeString(utcdate, locale) {
  var d = new Date(utcdate);
  var dt = d.toLocaleDateString(locale);
  var tm = d.toLocaleTimeString(locale);
  return "".concat(dt, " ").concat(tm);
};

var vueResetProp = (function (vue, statePropObj, propName) {
  var val = statePropObj[propName];
  vue.delete(statePropObj, propName);
  vue.set(statePropObj, propName, val);
});

var parseBool = function parseBool(val, defaultVal) {
  var result = false;
  var defaultWhenEmpty = false;

  if (typeof val === 'boolean') {
    result = val;
  } else {
    if (arguments.length > 1) {
      defaultWhenEmpty = defaultVal;
    }

    if (val !== undefined && val !== null && val !== '') {
      result = val.toLowerCase() === 'true';
    } else {
      result = defaultWhenEmpty;
    }
  }

  return result;
};

var MinutesToMS = 60000;

var userAutoLogOffPlugin = function userAutoLogOffPlugin(store) {
  window.addEventListener('keyup', function () {
    return autoLogoffManager.setLastActivity();
  }, {
    passive: true
  });
  window.addEventListener('mouseup', function () {
    return autoLogoffManager.setLastActivity();
  }, {
    passive: true
  });
  window.addEventListener('visibilitychange', function () {
    return document.visibilityState !== 'hidden' ? autoLogoffManager.checkLogoff() : autoLogoffManager.setLastActivity();
  }, {
    passive: true
  });
  store.subscribe(function (mutation) {
    if (mutation.type === 'user/SetAppConfigs') {
      var payload = mutation.payload;
      var timeout = parseInt(payload.VUE_APP_AUTOLOGOFF_TIMEOUT);
      var enabled = parseBool(payload.VUE_APP_AUTOLOGOFF_ENABLED);
      autoLogoffManager.setConfiguration(timeout, enabled);
    }
  });
};

var autoLogoffManager = {
  storageKey: 'vue_auto_lastActivity',
  isEnabled: false,
  intervalId: undefined,
  interval: MinutesToMS,
  timeout: MinutesToMS * 60,
  currentTimeSpan: function currentTimeSpan() {
    return new Date().getTime();
  },
  getLastActivity: function getLastActivity() {
    var val = localStorage.getItem(this.storageKey);
    var time;

    if (val) {
      val = parseInt(val);
      time = new Date(val).getTime();
    }

    return time;
  },
  setLastActivity: function setLastActivity() {
    localStorage.setItem(this.storageKey, this.currentTimeSpan());
  },
  stopInterval: function stopInterval() {
    if (this.intervalId != undefined) {
      clearInterval(this.intervalId);
      this.intervalId = undefined;
    }
  },
  startInterval: function startInterval() {
    if (this.intervalId || !this.isEnabled) return;
    this.intervalId = setInterval(this.checkLogoff.bind(this), this.interval);
  },
  checkLogoff: function checkLogoff() {
    if (this.isEnabled && this.currentTimeSpan() > this.getLastActivity() + this.timeout) {
      window.dispatchEvent(new Event('vuelogout'));
    }
  },
  setConfiguration: function setConfiguration(newTimeout, enabled) {
    this.setLastActivity();
    this.timeout = newTimeout || MinutesToMS * 60;
    this.isEnabled = enabled || false;
    this.stopInterval();
    this.startInterval();
  }
};
var userInfoPlugins = [userAutoLogOffPlugin];

var _mutations;
var userInfoModule = {
  strict: "production" !== 'production',
  name: 'user',
  namespaced: true,
  state: {
    userInfo: null,
    userToken: null,
    requestVerificationToken: null,
    apiService: undefined,
    userApiService: undefined,
    vueApiService: undefined,
    baseUrl: process.env.VUE_APP_API,
    authServerUrl: process.env.VUE_APP_AUTH_SERVER,
    accessWebUrl: process.env.VUE_APP_ACCESSWEB_URL,
    vueAppBase: process.env.VUE_APP_BASE || '',
    vueAppSitePath: process.env.VUE_APP_SITE_PATH,
    accessWebPageViewerUrl: '/System/PageViewer',
    pageTitle: '',
    isMenuOpen: false,
    isMenuExpanded: false,
    lastMenuItemOpen: [],
    appName: process.env.VUE_APP_NAME,
    userReady: false,
    initialized: false,
    localStorage: new Vue2Storage({
      prefix: 'vuelayout_',
      driver: 'local',
      ttl: 60 * 60 * 1000 // 1 hour

    }),
    logOffExpireTimeout: 60 * 60 * 1000,
    // 1 hour for AutoLogOff
    lastUserActivity: undefined,
    intervalcontextLocalStorage: 1000 * 5,
    // 5 seconds to capture a new Activity
    menuResults: undefined,
    profileMenuResults: {},
    companiesResults: undefined,
    icons: {},
    menuResultsStorageKeyPrefix: 'menuResults',
    mainItemClicked: {},
    version: 1,
    lastItemClicked: {},
    notificationModalContent: undefined,
    notificationModalVisible: false,
    activeNotificationPages: {},
    dismissedNotificationPages: {},
    unShownNotificationItems: [],
    pageVersionConfigKeyId: 0,
    iframeSource: null,
    router: {},
    currentCompanyId: -1,
    currentRouteMenuId: 0,
    lastMainItemClicked: 0,
    zoneWarning: null,
    //the default values are being set in the from .env when app builds
    //but in main.js, we call an api on AccessWeb to get these configs
    //and call the action to set them
    VUE_APP_API: process.env.VUE_APP_API,
    VUE_APP_AUTH_SERVER: process.env.VUE_APP_AUTH_SERVER,
    VUE_APP_NAME: process.env.VUE_APP_NAME,
    VUE_APP_SIGNALR_CONNECTION: process.env.VUE_APP_SIGNALR_CONNECTION,
    VUE_APP_ACCESSWEB_URL: process.env.VUE_APP_ACCESSWEB_URL
  },
  mutations: (_mutations = {}, _defineProperty(_mutations, SET_MENU_OPEN, function (state, menuState) {
    state.isMenuOpen = menuState;
  }), _defineProperty(_mutations, SET_MENU_EXPANDED, function (state, newMenuState) {
    state.isMenuExpanded = newMenuState;
  }), _defineProperty(_mutations, SET_LAST_MENU_ITEM_OPEN_ID, function (state, lastId) {
    var idIndex = state.lastMenuItemOpen.indexOf(lastId);

    if (idIndex !== -1) {
      var removedId = state.lastMenuItemOpen[idIndex];
      state.lastMenuItemOpen.splice(idIndex, 1);
      state.lastMenuItemOpen.push(removedId);
    } else {
      state.lastMenuItemOpen.push(lastId);
    }
  }), _defineProperty(_mutations, SET_USER_INFO, function (state, userInfo) {
    state.userInfo = userInfo;
  }), _defineProperty(_mutations, SET_USER_TOKEN, function (state, userToken) {
    state.userToken = userToken;
  }), _defineProperty(_mutations, LOGOUT_USER, function (state) {
    state.userInfo = null;
    state.userToken = null;
    state.apiService = undefined;
    state.userApiService = undefined;
    state.userReady = false;
    state.lastUserActivity = undefined;
  }), _defineProperty(_mutations, SET_PAGE_TITLE, function (state, pageTitle) {
    state.pageTitle = pageTitle;
  }), _defineProperty(_mutations, SET_APP_NAME, function (state, appName) {
    state.appName = appName;
  }), _defineProperty(_mutations, SET_USER_READY, function (state, userReady) {
    state.userReady = userReady;
  }), _defineProperty(_mutations, SET_API_SERVICE, function (state, apiService) {
    state.apiService = apiService;
  }), _defineProperty(_mutations, SET_USER_API_SERVICE, function (state, apiService) {
    state.userApiService = apiService;
  }), _defineProperty(_mutations, CLEAR_LOCAL_STORAGE, function (state) {
    if (state.localStorage != undefined) {
      state.localStorage.clear();
    }
  }), _defineProperty(_mutations, SET_MENU_RESULTS, function (state, menuResults) {
    state.menuResults = menuResults;
  }), _defineProperty(_mutations, SET_MENU_RESULTS_STORAGE, function (state, _ref) {
    var menuResults = _ref.menuResults,
        key = _ref.key;
    state.localStorage.set(key, menuResults);
  }), _defineProperty(_mutations, SET_PROFILE_MENU_RESULTS, function (state, _ref2) {
    var profileMenuResults = _ref2.profileMenuResults;
    state.profileMenuResults = profileMenuResults;
  }), _defineProperty(_mutations, SET_COMPANIES_RESULTS, function (state, _ref3) {
    var companiesResults = _ref3.companiesResults,
        key = _ref3.key;
    state.companiesResults = companiesResults;
    state.localStorage.set(key, companiesResults);
  }), _defineProperty(_mutations, "addIconClass", function addIconClass(state, _ref4) {
    var text = _ref4.text,
        iconClass = _ref4.iconClass;
    state.icons[text] = iconClass; //console.log(JSON.stringify(state.icons));
  }), _defineProperty(_mutations, SET_FAVORITES, function (state, favoritesCollection) {
    var favoritesIndex = state.menuResults.childItems.findIndex(function (menu) {
      return menu.itemText == 'Favorites';
    });
    state.menuResults.childItems.splice(favoritesIndex, 1, favoritesCollection);
  }), _defineProperty(_mutations, SET_MAIN_ITEM_CLICKED, function (state, menuItem) {
    state.mainItemClicked = menuItem;
    cookies.set('mainItemClickedId', menuItem);
  }), _defineProperty(_mutations, SET_LAST_MAIN_ITEM_CLICKED, function (state, menuItem) {
    state.lastMainItemClicked = menuItem; // cookies.set('lastMainItemClicked', menuItem);
  }), _defineProperty(_mutations, SET_LAST_ITEM_CLICKED, function (state, menuItem) {
    state.lastItemClicked = menuItem;
  }), _defineProperty(_mutations, SET_VUE_API_SERVICE, function (state, vueApiService) {
    state.vueApiService = vueApiService;
  }), _defineProperty(_mutations, SET_NOTIFICATION_MODAL_CONTENT, function (state, content) {
    state.notificationModalContent = content;
  }), _defineProperty(_mutations, SET_NOTIFICATION_MODAL_VISIBLE, function (state, visible) {
    state.notificationModalVisible = visible;
  }), _defineProperty(_mutations, SET_ACTIVE_NOTIFICATIONS, function (state, notifications) {
    Vue.set(state.activeNotificationPages, notifications.page + '', notifications);
  }), _defineProperty(_mutations, SET_DISMISSED_NOTIFICATIONS, function (state, notifications) {
    Vue.set(state.dismissedNotificationPages, notifications.page + '', notifications);
  }), _defineProperty(_mutations, SET_UNSHOWN_NOTIFICATIONS, function (state, notifications) {
    if (notifications && notifications.items && notifications.items.length > 0) {
      var _state$unShownNotific;

      (_state$unShownNotific = state.unShownNotificationItems).push.apply(_state$unShownNotific, _toConsumableArray(notifications.items));
    }
  }), _defineProperty(_mutations, REMOVE_SHOWN_NOTIFICATIONS, function (state, ids) {
    var _loop = function _loop(index) {
      var idToRemove = ids[index];
      var removeAtIndex = state.unShownNotificationItems.findIndex(function (n) {
        return n.id === idToRemove;
      });

      if (removeAtIndex >= 0) {
        state.unShownNotificationItems.splice(removeAtIndex, 1);
      }
    };

    for (var index = 0; index < ids.length; index++) {
      _loop(index);
    }
  }), _defineProperty(_mutations, REMOVE_FROM_ACTIVE_NOTIFICATIONS, function (state, notice) {
    for (var page in state.activeNotificationPages) {
      var index = state.activeNotificationPages[page].items.findIndex(function (n) {
        return n.id === notice.id;
      });

      if (index >= 0) {
        state.activeNotificationPages[page].items.splice(index, 1);
        state.activeNotificationPages['1'].totalCount -= 1; //for some reason, reactivity on the getter wasn't being triggered when this runs on an AccessWeb page
        //vueResetProp does a Vue.delete and Vue.set to force reactivity so the notifications and count get updated
        //bug 81109

        vueResetProp(Vue, state.activeNotificationPages, page);

        if (page !== '1') {
          vueResetProp(Vue, state.activeNotificationPages, '1');
        }

        break;
      }
    }
  }), _defineProperty(_mutations, ADD_UNSHOWN_ALERT, function (state, alert) {
    var len = 0;

    if (state.unShownNotificationItems) {
      len = state.unShownNotificationItems.length;
    }

    state.unShownNotificationItems.splice(len, 0, alert);
  }), _defineProperty(_mutations, ADD_TO_ACTIVE_NOTIFICATIONS, function (state, alert) {
    if (!state.activeNotificationPages) {
      state.activeNotificationPages = {};
    }

    if (!state.activeNotificationPages['1']) {
      Vue.set(state.activeNotificationPages, '1', {
        items: [],
        totalCount: 0
      });
    }

    alert.dismissed = false;
    alert.shown = true;
    state.activeNotificationPages['1'].items.splice(0, 0, alert);
    state.activeNotificationPages['1'].totalCount += 1; //for some reason, reactivity on the getter wasn't being triggered when this runs on an AccessWeb page
    //vueResetProp does a Vue.delete and Vue.set to force reactivity so the notifications and count get updated
    //bug 81109

    vueResetProp(Vue, state.activeNotificationPages, '1');
  }), _defineProperty(_mutations, ADD_TO_DISMISSED_NOTIFICATIONS, function (state, alert) {
    if (!state.dismissedNotificationPages) {
      state.dismissedNotificationPages = {};
    }

    if (!state.dismissedNotificationPages['1']) {
      Vue.set(state.dismissedNotificationPages, '1', {
        items: [],
        totalCount: 0
      });
    }

    if (state.dismissedNotificationPages['1'].items) {
      alert.dismissedOn = simulateIsoDate(new Date());
      alert.dismissed = true;
      alert.shown = true;

      if (state.dismissedNotificationPages['1'].items.findIndex(function (n) {
        return n.id == alert.id;
      }) < 0) {
        state.dismissedNotificationPages['1'].items.splice(0, 0, alert);
        state.dismissedNotificationPages['1'].totalCount += 1; //for some reason, reactivity on the getter wasn't being triggered when this runs on an AccessWeb page
        //vueResetProp does a Vue.delete and Vue.set to force reactivity so the notifications and count get updated
        //bug 81109

        vueResetProp(Vue, state.dismissedNotificationPages, '1');
      }
    }
  }), _defineProperty(_mutations, SET_PAGE_VERSION_CONFIGKEY_ID, function (state, id) {
    state.pageVersionConfigKeyId = id;
  }), _defineProperty(_mutations, SET_REQUEST_VERIFICATION_TOKEN, function (state, token) {
    state.requestVerificationToken = token;
  }), _defineProperty(_mutations, SET_IFRAME_SOURCE, function (state, iframeSource) {
    state.iframeSource = iframeSource;
  }), _defineProperty(_mutations, SET_CURRENT_COMPANY_ID, function (state, currentCompanyId) {
    state.currentCompanyId = currentCompanyId;
  }), _defineProperty(_mutations, SET_CURRENT_ROUTE_MENU_ID, function (state, id) {
    state.currentRouteMenuId = id;
    cookies.set('currentRouteMenuId', state.currentRouteMenuId);
  }), _defineProperty(_mutations, SET_APP_CONFIGS, function (state, appConfigs) {
    Object.assign(state, appConfigs);
    state.baseUrl = appConfigs.VUE_APP_API;
    state.authServerUrl = appConfigs.VUE_APP_AUTH_SERVER;
    state.accessWebUrl = appConfigs.VUE_APP_ACCESSWEB_URL;
    state.vueAppSitePath = appConfigs.VUE_APP_SITE_PATH;
    var timeoutSetting = appConfigs.VUE_APP_AUTOLOGOFF_TIMEOUT || 60 * 60 * 1000; // 1 hour for AutoLogOff

    state.logOffExpireTimeout = parseInt(timeoutSetting);
  }), _defineProperty(_mutations, SET_ZONE_WARNING, function (state, zoneWarning) {
    state.zoneWarning = zoneWarning;
  }), _defineProperty(_mutations, SET_AUTOLOGOFF_STATUS, function (state, enabled) {
    autoLogoffManager.isEnabled = enabled;
  }), _mutations),
  actions: {
    // actions let us get to ({ state, getters, commit, dispatch }) {
    getUserInfoAction: function getUserInfoAction(_ref5, cache) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var commit, state, parameters, userInfo;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref5.commit, state = _ref5.state;
                parameters = {
                  cache: cache !== false
                };
                _context.next = 4;
                return state.userApiService.get(buildRoute('/connect/userinfo?cache={cache}', parameters));

              case 4:
                userInfo = _context.sent;
                commit(SET_USER_INFO, userInfo);
                commit(SET_USER_READY, true);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    setTokenAction: function setTokenAction(_ref6, userToken) {
      var commit = _ref6.commit,
          state = _ref6.state;
      var apiService;
      var userApiService;
      var vueApiService;
      var baseUrl = state.baseUrl;
      commit(SET_USER_TOKEN, userToken);
      apiService = new ApiService({
        userToken: userToken,
        baseUrl: baseUrl
      });
      baseUrl = state.authServerUrl;
      userApiService = new ApiService({
        userToken: userToken,
        baseUrl: baseUrl
      }); //service for calling apis in AccessWeb
      //userToken is not used

      baseUrl = state.accessWebUrl;
      vueApiService = new ApiService({
        userToken: userToken,
        baseUrl: baseUrl
      });
      commit(SET_API_SERVICE, apiService);
      commit(SET_USER_API_SERVICE, userApiService);
      commit(SET_VUE_API_SERVICE, vueApiService);
    },
    logoutUserAction: function logoutUserAction(_ref7) {
      var commit = _ref7.commit;
      commit(LOGOUT_USER);
      commit(CLEAR_LOCAL_STORAGE);
    },
    setPageTitleAction: function setPageTitleAction(_ref8, pageTitle) {
      var commit = _ref8.commit;
      commit(SET_PAGE_TITLE, pageTitle);
    },
    setAppNameAction: function setAppNameAction(_ref9, appName) {
      var commit = _ref9.commit;
      commit(SET_APP_NAME, appName);
    },
    setMenuIsOpen: function setMenuIsOpen(_ref10, menuState) {
      var commit = _ref10.commit;
      commit(SET_MENU_OPEN, menuState);
    },
    setMenuIsExpanded: function setMenuIsExpanded(_ref11, menuState) {
      var commit = _ref11.commit;
      commit(SET_MENU_EXPANDED, menuState);
    },
    setLastMenuItemOpenId: function setLastMenuItemOpenId(_ref12, lastId) {
      var commit = _ref12.commit;
      commit(SET_LAST_MENU_ITEM_OPEN_ID, lastId);
    },
    //use this if the parent app is getting the oidc user info
    setUserInfoAction: function setUserInfoAction(_ref13, userInfo) {
      var commit = _ref13.commit;
      commit(SET_USER_INFO, userInfo);
      commit(SET_USER_READY, true);
    },
    setUserReady: function setUserReady(_ref14, userReady) {
      var commit = _ref14.commit;
      commit(SET_USER_READY, userReady);
    },
    getMenuResultsAction: function getMenuResultsAction(_ref15, companyId) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var commit, getters, state, varyParameters, key, menuResults;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit = _ref15.commit, getters = _ref15.getters, state = _ref15.state;
                varyParameters = {
                  companyId: companyId
                };
                key = getters.menuResultsStorageKey(companyId);
                menuResults = state.localStorage.get(key);

                if (!(menuResults == undefined)) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 7;
                return state.apiService.get(buildRoute('/menu/company/{companyId}', varyParameters));

              case 7:
                menuResults = _context2.sent;

              case 8:
                commit(SET_MENU_RESULTS, menuResults);
                commit(SET_MENU_RESULTS_STORAGE, {
                  menuResults: menuResults,
                  key: key
                });

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getProfileMenuResultsAction: function getProfileMenuResultsAction(_ref16) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var commit, state, varyParameters, profileMenuResults;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commit = _ref16.commit, state = _ref16.state;
                varyParameters = {
                  requestPath: window.location.pathname
                };
                _context3.next = 4;
                return state.apiService.get(buildRoute('/menu/profile?requestpath={requestPath}', varyParameters));

              case 4:
                profileMenuResults = _context3.sent;
                commit(SET_PROFILE_MENU_RESULTS, {
                  profileMenuResults: profileMenuResults
                });

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    getCompaniesAction: function getCompaniesAction(_ref17, companyId) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var commit, state, varyParameters, key, companiesResults;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commit = _ref17.commit, state = _ref17.state;
                varyParameters = {
                  companyId: companyId
                };
                key = "".concat(COMPANIES_RESULTS_KEY, "_").concat(JSON.stringify(varyParameters));
                companiesResults = state.localStorage.get(key);

                if (!(companiesResults == undefined)) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 7;
                return state.apiService.get(buildRoute('/dealership/company/{companyId}/companies', varyParameters));

              case 7:
                companiesResults = _context4.sent;

              case 8:
                commit(SET_COMPANIES_RESULTS, {
                  companiesResults: companiesResults,
                  key: key
                });

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    clearStateAction: function clearStateAction(_ref18) {
      var commit = _ref18.commit;
      commit(CLEAR_LOCAL_STORAGE, true);
    },
    setIconClass: function setIconClass(_ref19, menuItem) {
      var commit = _ref19.commit;
      var text = menuItem.itemText;
      var iconClass = "icon-".concat(menuItem.itemText.toLowerCase().replace(' ', '-'));
      commit('addIconClass', {
        text: text,
        iconClass: iconClass
      });
    },
    addToFavoritesAction: function addToFavoritesAction(_ref20, _ref21) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var commit, getters, state, menuItem, companyId, key, favoritesCollection;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                commit = _ref20.commit, getters = _ref20.getters, state = _ref20.state;
                menuItem = _ref21.menuItem, companyId = _ref21.companyId;
                key = getters.menuResultsStorageKey(companyId);
                _context5.next = 5;
                return state.apiService.post(buildRoute('/menu/company/{companyId}/favorites', {
                  companyId: companyId
                }), menuItem);

              case 5:
                favoritesCollection = _context5.sent;
                commit(SET_FAVORITES, favoritesCollection);
                commit(SET_MENU_RESULTS_STORAGE, {
                  menuResults: state.menuResults,
                  key: key
                });

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    removeFromFavoritesAction: function removeFromFavoritesAction(_ref22, _ref23) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var commit, getters, state, menuItem, companyId, key, favoritesCollection;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                commit = _ref22.commit, getters = _ref22.getters, state = _ref22.state;
                menuItem = _ref23.menuItem, companyId = _ref23.companyId;
                key = getters.menuResultsStorageKey(companyId);
                _context6.next = 5;
                return state.apiService.delete(buildRoute('/menu/company/{companyId}/favorites?itemText={itemText}&itemValue={itemValue}', {
                  companyId: companyId,
                  itemText: menuItem.itemText,
                  itemValue: menuItem.itemValue
                }));

              case 5:
                favoritesCollection = _context6.sent;
                commit(SET_FAVORITES, favoritesCollection);
                commit(SET_MENU_RESULTS_STORAGE, {
                  menuResults: state.menuResults,
                  key: key
                });

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    orderFavoritesAction: function orderFavoritesAction(_ref24, _ref25) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var commit, getters, state, menuItem, companyId, order, key, updatedItem, favoritesCollection;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                commit = _ref24.commit, getters = _ref24.getters, state = _ref24.state;
                menuItem = _ref25.menuItem, companyId = _ref25.companyId, order = _ref25.order;
                key = getters.menuResultsStorageKey(companyId);
                updatedItem = _objectSpread2({}, menuItem);
                updatedItem.order = order;
                _context7.next = 7;
                return state.apiService.put(buildRoute('/menu/company/{companyId}/favorites', {
                  companyId: companyId
                }), updatedItem);

              case 7:
                favoritesCollection = _context7.sent;
                commit(SET_FAVORITES, favoritesCollection);
                commit(SET_MENU_RESULTS_STORAGE, {
                  menuResults: state.menuResults,
                  key: key
                });

              case 10:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    setMainItemClickedAction: function setMainItemClickedAction(_ref26, menuItem) {
      var commit = _ref26.commit;
      commit(SET_MAIN_ITEM_CLICKED, menuItem);
    },
    setLastMainItemClickedAction: function setLastMainItemClickedAction(_ref27, menuItem) {
      var commit = _ref27.commit;
      commit(SET_LAST_MAIN_ITEM_CLICKED, menuItem);
    },
    switchVersionAction: function switchVersionAction(_ref28, _ref29) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var state, version, companyId, configurationKeyId, employeeId, configModel;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                state = _ref28.state;
                version = _ref29.version, companyId = _ref29.companyId, configurationKeyId = _ref29.configurationKeyId, employeeId = _ref29.employeeId;
                configModel = {
                  companyId: companyId,
                  entityId: employeeId,
                  configurationKeyId: configurationKeyId,
                  keyValue: version
                };
                _context8.next = 5;
                return state.apiService.post(buildRoute('/dealership/company/{companyId}/configurations/employee/{employeeId}/key/{configurationKeyId}', {
                  companyId: companyId,
                  employeeId: employeeId,
                  configurationKeyId: configurationKeyId
                }), configModel);

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    setLastItemClickedAction: function setLastItemClickedAction(_ref30, menuItem) {
      var commit = _ref30.commit;
      commit(SET_LAST_ITEM_CLICKED, menuItem);
    },
    getCustomerMessagingAction: function getCustomerMessagingAction(_ref31, params) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var commit, state, customerMessaging;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                commit = _ref31.commit, state = _ref31.state;
                _context9.next = 3;
                return state.vueApiService.post('/System/CustomerMessaging', params);

              case 3:
                customerMessaging = _context9.sent;
                commit(SET_NOTIFICATION_MODAL_CONTENT, customerMessaging);

              case 5:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    showNotificationModalAction: function showNotificationModalAction(_ref32, _ref33) {
      var commit = _ref32.commit,
          state = _ref32.state;
      var alertLinkType = _ref33.alertLinkType,
          args = _ref33.args;
      var argsQuery = JSON.stringify(args);
      var argsEncoded = encodeURIComponent(argsQuery);
      var iframeSource = "".concat(state.accessWebUrl).concat(state.accessWebPageViewerUrl, "?alertLinkType=").concat(alertLinkType, "&args=").concat(argsEncoded);
      commit(SET_IFRAME_SOURCE, iframeSource);
      commit(SET_NOTIFICATION_MODAL_VISIBLE, true);
    },
    hideNotificationModalAction: function hideNotificationModalAction(_ref34) {
      var commit = _ref34.commit;
      commit(SET_NOTIFICATION_MODAL_VISIBLE, false);
      commit(SET_IFRAME_SOURCE, null);
    },
    getNotificationsAction: function getNotificationsAction(_ref35, _ref36) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var state, companyId, page, pageSize, dismissed, shown, route, notifications;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                state = _ref35.state;
                companyId = _ref36.companyId, page = _ref36.page, pageSize = _ref36.pageSize, dismissed = _ref36.dismissed, shown = _ref36.shown;
                page = page || 1;
                route = buildRoute('/dealership/company/{companyId}/notifications/alerts?page={page}&countperpage={countperpage}', {
                  companyId: companyId,
                  page: page,
                  countperpage: pageSize
                }); //bug-58875: proper handling of route query params when undefined...
                //NOTE: underlying sproc assumes if [Dismissed] column is NULL === false

                if (dismissed !== undefined) {
                  route = buildRoute(route + '&dismissed={dismissed}', {
                    dismissed: dismissed
                  });
                } //bug-58875: proper handling of route query params when undefined...
                //NOTE: underlying sproc assumes if [Shown] column is NULL === false


                if (shown !== undefined) {
                  route = buildRoute(route + '&shown={shown}', {
                    shown: shown
                  });
                }

                _context10.next = 8;
                return state.apiService.get(route);

              case 8:
                notifications = _context10.sent;
                //Filter out notifications based upon the dismissal/shown flags...
                notifications.items = notifications.items.filter(function (n) {
                  if (dismissed !== undefined) {
                    return n.dismissed === dismissed;
                  }

                  return true;
                }).filter(function (n) {
                  if (shown !== undefined) {
                    return n.shown === shown;
                  }

                  return true;
                }); //console.log({ route: route, notifications: notifications });

                return _context10.abrupt("return", notifications);

              case 11:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    getActiveNotificationsAction: function getActiveNotificationsAction(_ref37, _ref38) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var commit, dispatch, companyId, page, pageSize, notifications;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                commit = _ref37.commit, dispatch = _ref37.dispatch;
                companyId = _ref38.companyId, page = _ref38.page, pageSize = _ref38.pageSize;
                page = page || 1; //Pre-sorted/filtered from dispatch by dismissed/created [ASC/DESC] (see above)...

                _context11.next = 5;
                return dispatch('getNotificationsAction', {
                  companyId: companyId,
                  page: page,
                  pageSize: pageSize,
                  dismissed: false //, shown: true //bug-58875: old data may not have been shown but needs to appear in the list...

                });

              case 5:
                notifications = _context11.sent;
                //Reinforce sort by created date (descending)...
                //Force the 'shown' flag to be true...
                notifications.items = notifications.items.sort(function (l, r) {
                  var ld = new Date(l.datetimeStamp);
                  var rd = new Date(r.datetimeStamp);
                  return rd - ld; //DESC - most recent first...
                }).map(function (n) {
                  n.shown = true;
                  return n;
                });
                commit(SET_ACTIVE_NOTIFICATIONS, notifications);

              case 8:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    getDismissedNotificationsAction: function getDismissedNotificationsAction(_ref39, _ref40) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var commit, dispatch, companyId, page, pageSize, notifications;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                commit = _ref39.commit, dispatch = _ref39.dispatch;
                companyId = _ref40.companyId, page = _ref40.page, pageSize = _ref40.pageSize;
                page = page || 1; //Pre-sorted/filtered from dispatch by dismissed/created [ASC/DESC] (see above)...

                _context12.next = 5;
                return dispatch('getNotificationsAction', {
                  companyId: companyId,
                  page: page,
                  pageSize: pageSize,
                  dismissed: true //, shown: true //bug-58875: old data may not have been shown, but needs to appear in the list...

                });

              case 5:
                notifications = _context12.sent;
                //Reinforce sort by dismissed date (descending)...
                //Force the 'shown' flag to be true...
                notifications.items = notifications.items.sort(function (l, r) {
                  var ld = new Date(l.datetimeStamp);
                  var rd = new Date(r.datetimeStamp);
                  return rd - ld; //DESC - most recent first...
                }).sort(function (l, r) {
                  var ld = new Date(l.dismissedOn); //NULL ~ 1/1/1970

                  var rd = new Date(r.dismissedOn); //NULL ~ 1/1/1970

                  return rd - ld; //DESC - then by most recently dismissed...
                }).map(function (n) {
                  n.shown = true;
                  return n;
                });
                commit(SET_DISMISSED_NOTIFICATIONS, notifications);

              case 8:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    },
    getUnShownNotificationsAction: function getUnShownNotificationsAction(_ref41, companyId) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var commit, dispatch, notifications;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                commit = _ref41.commit, dispatch = _ref41.dispatch;
                _context13.next = 3;
                return dispatch('getNotificationsAction', {
                  companyId: companyId,
                  page: 1,
                  pageSize: 100,
                  shown: false //bug-58875: no longer care if it had been dismissed before or not...

                });

              case 3:
                notifications = _context13.sent;
                //Reinforce sort by created date (descending)...
                //Force the 'shown' flag to be false...
                notifications.items = notifications.items.sort(function (l, r) {
                  var ld = new Date(l.datetimeStamp);
                  var rd = new Date(r.datetimeStamp);
                  return rd - ld; //DESC - most recent first...
                }).filter(function (n) {
                  return n.shown === false;
                });
                commit(SET_UNSHOWN_NOTIFICATIONS, notifications);

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }))();
    },
    dismissNotificationAction: function dismissNotificationAction( // eslint-disable-next-line no-unused-vars
    _ref42, _ref43) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var commit, state, getters, notification, companyId, route, params, mutations;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                commit = _ref42.commit, state = _ref42.state, getters = _ref42.getters;
                notification = _ref43.notification, companyId = _ref43.companyId;
                route = buildRoute('/dealership/company/{companyId}/notifications/alerts/dismiss', {
                  companyId: companyId
                });
                params = {
                  id: notification.id,
                  save: notification.save
                };
                state.apiService.post(route, params);

                if (notification.save) {
                  mutations = ["user/".concat(ADD_TO_DISMISSED_NOTIFICATIONS)];
                } else {
                  commit(REMOVE_FROM_ACTIVE_NOTIFICATIONS, notification);
                  mutations = ["user/".concat(REMOVE_FROM_ACTIVE_NOTIFICATIONS), "user/".concat(ADD_TO_DISMISSED_NOTIFICATIONS)];
                }

                _context14.next = 8;
                return store.dispatch('hub/invokeHubMethodAction', {
                  message: {
                    mutations: mutations,
                    ToUserIds: [getters.hubUserId],
                    data: notification,
                    excludeSenderConnection: true
                  }
                });

              case 8:
                //Mutation moved down after signal R
                commit(ADD_TO_DISMISSED_NOTIFICATIONS, notification);

              case 9:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }))();
    },
    alertsShownAction: function alertsShownAction(_ref44, _ref45) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var commit, state, notificationItems, companyId, route, ids;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                commit = _ref44.commit, state = _ref44.state;
                notificationItems = _ref45.notificationItems, companyId = _ref45.companyId;
                route = buildRoute('/dealership/company/{companyId}/notifications/alerts/shown', {
                  companyId: companyId
                });
                ids = [];

                if (!(notificationItems && notificationItems.length > 0)) {
                  _context15.next = 9;
                  break;
                }

                notificationItems.forEach(function (n) {
                  return ids.push(n.id);
                });
                commit(REMOVE_SHOWN_NOTIFICATIONS, ids);
                _context15.next = 9;
                return state.apiService.post(route, {
                  ids: ids
                });

              case 9:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }))();
    },
    addAlertAction: function addAlertAction(_ref46, alert) {
      var commit = _ref46.commit;
      commit(ADD_UNSHOWN_ALERT, alert);
      commit(ADD_TO_ACTIVE_NOTIFICATIONS, alert);
    },
    setPageVersionConfigKeyIdAction: function setPageVersionConfigKeyIdAction(_ref47, id) {
      var commit = _ref47.commit;
      commit(SET_PAGE_VERSION_CONFIGKEY_ID, id);
    },
    setRequestVerificationTokenAction: function setRequestVerificationTokenAction(_ref48, token) {
      var commit = _ref48.commit;
      commit(SET_REQUEST_VERIFICATION_TOKEN, token);
    },
    currentCompanyIdAction: function currentCompanyIdAction(_ref49, currentCompanyId) {
      var commit = _ref49.commit;
      commit(SET_CURRENT_COMPANY_ID, currentCompanyId);
    },
    setCurrentRouteMenuIdAction: function setCurrentRouteMenuIdAction(_ref50, id) {
      var commit = _ref50.commit;
      commit(SET_CURRENT_ROUTE_MENU_ID, id);
    },
    setAppConfigsAction: function setAppConfigsAction(_ref51, appConfigs) {
      var commit = _ref51.commit;
      commit(SET_APP_CONFIGS, appConfigs);
    },
    switchZoneAction: function switchZoneAction(_, zone) {
      //if we are already on the correct zone, do nothing
      if (zone.Host.localeCompare(window.location.host, undefined, {
        sensitivity: 'accent'
      }) === 0) return null; // we set a delay of 1ms to let the current call stack clear before redirecting

      return new Promise(function (resolve) {
        setTimeout(function () {
          var current = new URL(window.location.href);
          current.host = zone.Host;
          window.location.href = current.href;
          resolve();
        }, 1);
      });
    },
    setZoneWarning: function setZoneWarning(_ref52, warning) {
      var commit = _ref52.commit;
      if (warning.Host.localeCompare(window.location.host, undefined, {
        sensitivity: 'accent'
      }) === 0) return null;
      commit(SET_ZONE_WARNING, warning);
    },
    setAutoLogoffStatusAction: function setAutoLogoffStatusAction(_ref53, enabled) {
      var commit = _ref53.commit;
      commit(SET_AUTOLOGOFF_STATUS, enabled);
    }
  },
  getters: {
    hubUserId: function hubUserId(state) {
      var userId;

      if (state.userInfo) {
        userId = "".concat(state.userInfo.AspNetCompaniesId, "_").concat(state.userInfo.EmployeeId);
      }

      return userId;
    },
    currentCompanyId: function currentCompanyId(state) {
      return state.currentCompanyId;
    },
    userInfo: function userInfo(state) {
      return state.userInfo;
    },
    userInfoSlim: function userInfoSlim(state) {
      var _state$userInfo = state.userInfo,
          DealershipGroupNumber = _state$userInfo.DealershipGroupNumber,
          CurrentEmployeeCompanyId = _state$userInfo.CurrentEmployeeCompanyId,
          EmployeeImage = _state$userInfo.EmployeeImage,
          Email = _state$userInfo.Email,
          AspNetCompaniesId = _state$userInfo.AspNetCompaniesId,
          FirstName = _state$userInfo.FirstName,
          LastName = _state$userInfo.LastName,
          EmployeeId = _state$userInfo.EmployeeId,
          sub = _state$userInfo.sub;

      var firstOrDefault = function firstOrDefault(value) {
        return Array.isArray(value) ? value[0] : typeof value === 'string' ? value : null;
      };

      return {
        DealershipGroupNumber: DealershipGroupNumber,
        CurrentEmployeeCompanyId: CurrentEmployeeCompanyId,
        EmployeeImage: EmployeeImage,
        Email: Email,
        AspNetCompaniesId: AspNetCompaniesId,
        FirstName: firstOrDefault(FirstName),
        LastName: firstOrDefault(LastName),
        EmployeeId: EmployeeId,
        sub: sub
      };
    },
    permissions: function permissions(state) {
      return state.userInfo.permissions;
    },
    userToken: function userToken(state) {
      return state.userToken;
    },
    requestVerificationToken: function requestVerificationToken(state) {
      return state.requestVerificationToken;
    },
    quickSearchDefault: function quickSearchDefault(state) {
      if (state.userInfo) {
        return state.userInfo['CompanyConfigurations.QuickSearchDefault'];
      }

      return null;
    },
    userFirstName: function userFirstName(state) {
      if (state.userInfo) {
        return state.userInfo.FirstName;
      }

      return null;
    },
    userLastName: function userLastName(state) {
      if (state.userInfo) {
        return state.userInfo.LastName;
      }

      return null;
    },
    employeeId: function employeeId(state) {
      if (state.userInfo && state.userInfo.EmployeeId) {
        return parseInt(state.userInfo.EmployeeId);
      }

      return null;
    },
    pageTitle: function pageTitle(state) {
      return state.pageTitle;
    },
    pageVersionConfigKeyId: function pageVersionConfigKeyId(state) {
      return state.pageVersionConfigKeyId;
    },
    appName: function appName(state) {
      return state.appName;
    },
    isMenuOpen: function isMenuOpen(state) {
      return state.isMenuOpen;
    },
    isMenuExpanded: function isMenuExpanded(state) {
      return state.isMenuExpanded;
    },
    userReady: function userReady(state) {
      return state.userReady;
    },
    apiService: function apiService(state) {
      return state.apiService;
    },
    userApiService: function userApiService(state) {
      return state.userApiService;
    },
    vueApiService: function vueApiService(state) {
      return state.vueApiService;
    },
    initialized: function initialized(state) {
      return state.userReady && state.userToken;
    },
    menuResults: function menuResults(state) {
      return state.menuResults;
    },
    profileMenuResults: function profileMenuResults(state) {
      return state.profileMenuResults;
    },
    companiesResults: function companiesResults(state) {
      return state.companiesResults;
    },
    icons: function icons(state) {
      return state.icons;
    },
    notificationModalContent: function notificationModalContent(state) {
      return state.notificationModalContent;
    },
    accessWebUrl: function accessWebUrl(state) {
      return state.accessWebUrl;
    },
    accessWebPageViewerUrl: function accessWebPageViewerUrl(state) {
      return state.accessWebPageViewerUrl;
    },
    vueAppBase: function vueAppBase(state) {
      return state.vueAppBase;
    },
    notificationModalVisible: function notificationModalVisible(state) {
      return state.notificationModalVisible;
    },
    activeNotificationPages: function activeNotificationPages(state) {
      return state.activeNotificationPages;
    },
    unShownNotificationPages: function unShownNotificationPages(state) {
      return state.unShownNotificationPages;
    },
    dismissedNotificationPages: function dismissedNotificationPages(state) {
      return state.dismissedNotificationPages;
    },
    iframeSource: function iframeSource(state) {
      return state.iframeSource;
    },
    vueAppSitePath: function vueAppSitePath(state) {
      return state.vueAppSitePath;
    },
    activeNotificationItems: function activeNotificationItems(state) {
      var items = gatherItems(state.activeNotificationPages);
      return items;
    },
    dismissedNotificationItems: function dismissedNotificationItems(state) {
      var items = gatherItems(state.dismissedNotificationPages);
      return items;
    },
    unShownNotificationItems: function unShownNotificationItems(state) {
      return state.unShownNotificationItems;
    },
    activeNotificationCount: function activeNotificationCount(state) {
      var count = 0;

      if (state.activeNotificationPages && state.activeNotificationPages[1]) {
        count = state.activeNotificationPages[1].totalCount;
      }

      return count;
    },
    dismissedNotificationCount: function dismissedNotificationCount(state) {
      var count = 0;

      if (state.dismissedNotificationPages && state.dismissedNotificationPages[1]) {
        count = state.dismissedNotificationPages[1].totalCount;
      }

      return count;
    },
    activeNotificationPageCount: function activeNotificationPageCount(state) {
      var count = 1;

      if (state.activeNotificationPages && state.activeNotificationPages[1]) {
        count = state.activeNotificationPages[1].totalPageCount;
      }

      return count;
    },
    dismissedNotificationPageCount: function dismissedNotificationPageCount(state) {
      var count = 1;

      if (state.dismissedNotificationPages && state.dismissedNotificationPages[1]) {
        count = state.dismissedNotificationPages[1].totalPageCount;
      }

      return count;
    },
    isFavorite: function isFavorite(state) {
      return function (menuItem) {
        var isFav = false;
        var favorites = state.menuResults.childItems.find(function (el) {
          return el.itemText == 'Favorites';
        });

        if (favorites) {
          isFav = favorites.childItems.findIndex(function (el) {
            return el.itemText == menuItem.itemText && el.itemValue == menuItem.itemValue;
          }) >= 0;
        }

        return isFav;
      };
    },
    menuResultsStorageKey: function menuResultsStorageKey(state) {
      return function (companyId) {
        var varyParameters = {
          companyId: companyId
        };
        var key = "".concat(state.menuResultsStorageKeyPrefix, "_").concat(JSON.stringify(varyParameters));
        return key;
      };
    },
    mainItemClickedId: function mainItemClickedId(state) {
      var id = 0;

      if (state.mainItemClicked && state.mainItemClicked > 0) {
        id = state.mainItemClicked;
      } else {
        var cookieVal = cookies.get('mainItemClickedId');

        if (cookieVal) {
          id = parseInt(cookieVal);
        }
      }

      return id;
    },
    lastMainItemClickedId: function lastMainItemClickedId(state) {
      var id = 0;

      if (state.lastMainItemClicked && state.lastMainItemClicked > 0) {
        id = state.lastMainItemClicked;
      }

      return id;
    },
    lastItemClickedId: function lastItemClickedId(state) {
      var id = 0;

      if (state.lastItemClicked) {
        id = state.lastItemClicked.id;
      }

      return id;
    },
    currentRouteMenuId: function currentRouteMenuId(state) {
      var id = 0;

      if (state.currentRouteMenuId && state.currentRouteMenuId > 0) {
        id = state.currentRouteMenuId;
      } else {
        var cookieVal = cookies.get('currentRouteMenuId');

        if (cookieVal) {
          id = parseInt(cookieVal);
        }
      }

      return id;
    },
    zoneWarning: function zoneWarning(state) {
      return state.zoneWarning;
    },
    VUE_APP_API: function VUE_APP_API(state) {
      return state.VUE_APP_API;
    },
    VUE_APP_AUTH_SERVER: function VUE_APP_AUTH_SERVER(state) {
      return state.VUE_APP_AUTH_SERVER;
    },
    VUE_APP_NAME: function VUE_APP_NAME(state) {
      return state.VUE_APP_NAME;
    },
    VUE_APP_BASE: function VUE_APP_BASE(state) {
      return state.VUE_APP_BASE;
    },
    VUE_APP_SIGNALR_CONNECTION: function VUE_APP_SIGNALR_CONNECTION(state) {
      return state.VUE_APP_SIGNALR_CONNECTION;
    },
    VUE_APP_ACCESSWEB_URL: function VUE_APP_ACCESSWEB_URL(state) {
      return state.VUE_APP_ACCESSWEB_URL;
    }
  }
};

var SET_HUB_READY = 'SetHubReady';

/**
 * Server-side VueHub methods in Vue.Functions.Messages.Functions.VueHub
 */
var ON_CONNECT_METHOD = 'OnUserConnect';
var ON_DISCONNECT_METHOD = 'OnUserDisconnect';
var SEND_COMMUNICATION_METHOD = 'SendCommunication';
var ON_CONNECTION_CLOSE = 'OnConnectionClose';

/**
 * Targets the server side hub will send to client side hub
 */
var NEW_COMMUNICATION_TARGET = 'newCommunication';

var logLevel = process.env.VUE_APP_LOG_LEVEL;
var consoleLog = (function (message) {
  if (logLevel === 'Debug') {
    console.log(message);
  }
});

var hubConnection;
var parentAppStore;
var hubModule = {
  strict: "production" !== 'production',
  name: 'hub',
  namespaced: true,
  state: {
    hubReady: false,
    hubLogLevel: process.env.VUE_APP_LOG_LEVEL,
    newCommunicationTarget: NEW_COMMUNICATION_TARGET
  },
  mutations: _defineProperty({}, SET_HUB_READY, function (state, ready) {
    state.hubReady = ready;
  }),
  actions: {
    // actions let us get to ({ state, getters, commit, dispatch }) {
    receiveCommunicationAction: function receiveCommunicationAction(_ref, message) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;
      consoleLog('receiveCommunicationAction');
      consoleLog(message); //where message.action would be the store action

      if (message.Actions && Array.isArray(message.Actions)) {
        message.Actions.forEach(function (action) {
          if (action.includes('/')) {
            //if the action contains a /, then we're invoking
            //a mutation in a different module
            parentAppStore.dispatch(action, message.Data);
          } else {
            //action is in this module
            dispatch(action, message.Data);
          }
        });
      } //where message.mutation would be the mutation type, ie SET_CONCURRENT_USERS


      if (message.Mutations && Array.isArray(message.Mutations)) {
        message.Mutations.forEach(function (mutation) {
          if (mutation.includes('/')) {
            //if the action contains a /, then we're invoking
            //a mutation in a different module
            parentAppStore.commit(mutation, message.Data);
          } else {
            //mutation is in this module
            commit(mutation, message.Data);
          }
        });
      }

      store.dispatch('logging/logEventAction', {
        data: {
          event: 'Receive Communication Action',
          target: 'HubModule',
          eventData: message
        }
      });
    },
    // eslint-disable-next-line no-unused-vars
    invokeHubMethodAction: function invokeHubMethodAction(_ref2, _ref3) {
      var commit = _ref2.commit;
      var message = _ref3.message,
          method = _ref3.method;
      consoleLog('invokeHubMethodAction');
      var user = store.getters['user/userInfo'];

      if (user) {
        if (!message.dealershipGroupId) {
          message.dealershipGroupId = user.AspNetCompaniesId;
        }

        if (!message.companyId) {
          message.companyId = user.CurrentEmployeeCompanyId;
        }
      }

      hubConnection.invoke(method || SEND_COMMUNICATION_METHOD, JSON.stringify(message));
    },
    setHubConnectionAction: function setHubConnectionAction(_ref4, _ref5) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch,
          state = _ref4.state;
      var userToken = _ref5.userToken,
          user = _ref5.user;
      var connection = new HubConnectionBuilder().withUrl(store.getters['user/VUE_APP_SIGNALR_CONNECTION'], {
        accessTokenFactory: function accessTokenFactory() {
          return userToken;
        }
      }).configureLogging(LogLevel[state.hubLogLevel]).build();
      connection.on(state.newCommunicationTarget, function (message) {
        dispatch('receiveCommunicationAction', message);
      }); //TODO: this fires when a connection is closed,
      //not when the user leaves the page or closes the browser
      //figure out how to test

      connection.onclose(function () {
        dispatch('invokeHubMethodAction', {
          message: {
            data: user,
            dealershipGroupId: user.AspNetCompaniesId,
            companyId: user.CurrentEmployeeCompanyId
          },
          method: ON_CONNECTION_CLOSE
        });
        consoleLog('disconnected');
      });
      connection.start().then(function () {
        commit(SET_HUB_READY, true);
        consoleLog('hub connection ready');
        dispatch('onUserConnectedAction', user);
      }).catch(function (e) {
        consoleLog(e);
      });
      hubConnection = connection;
    },
    onUserConnectedAction: function onUserConnectedAction(_ref6, user) {
      var dispatch = _ref6.dispatch;
      consoleLog('onUserConnectedAction');
      dispatch('invokeHubMethodAction', {
        message: {
          data: user,
          dealershipGroupId: user.AspNetCompaniesId,
          companyId: user.CurrentEmployeeCompanyId
        },
        method: ON_CONNECT_METHOD
      });
    },
    onUserDisconnectAction: function onUserDisconnectAction(_ref7, user) {
      var dispatch = _ref7.dispatch;
      consoleLog('onUserDisconnectAction');
      dispatch('invokeHubMethodAction', {
        message: {
          data: user,
          dealershipGroupId: user.AspNetCompaniesId,
          companyId: user.CurrentEmployeeCompanyId
        },
        method: ON_DISCONNECT_METHOD
      });
    },
    // eslint-disable-next-line no-unused-vars
    setParentAppStoreAction: function setParentAppStoreAction(_ref8, store) {
      var commit = _ref8.commit;
      //commiting this into a state prop was causing an error,
      //so just putting in a local var
      parentAppStore = store;
    },
    // eslint-disable-next-line no-unused-vars
    addMessageHandlerAction: function addMessageHandlerAction(_ref9, _ref10) {
      var commit = _ref9.commit;
      var target = _ref10.target,
          handler = _ref10.handler;
      hubConnection.on(target, handler);
    }
  },
  getters: {
    hubReady: function hubReady(state) {
      return state.hubReady;
    }
  }
};

var SET_INITIALIZED = 'SetInitialized';
var ADD_EVENT = 'AddEvent';
var CLEAR_EVENTS = 'ClearEvents';
var SCHEDULE_BATCH = 'ScheduleBatch';
var REMOVE_TIMEOUT = 'RemoveTimeout';
var SET_OPTIONS = 'SetOptions';
var SET_LISTENER = 'SetListener';
var SET_TOKEN = 'SetToken';
var SET_DEVICE_ID = 'SetDeviceId';
var SET_SOURCE_APPLICATION = 'SetSourceApplication';
var SET_LOGGING_API = 'SetLoggingApi';
var SET_LOGGING_ENABLED = 'SetLoggingEnabled';

var _mutations$1;
var loggingModule = {
  strict: "production" !== 'production',
  name: 'logging',
  namespaced: true,
  state: {
    initialized: false,
    batchFrequency: 60000,
    options: {},
    batchedEvents: [],
    sendBatchTimeoutId: undefined,
    userToken: undefined,
    deviceId: undefined,
    deviceIdCookieName: 'vue2did',
    sourceApplication: undefined,
    loggingApi: undefined,
    loggingEnabled: false
  },
  mutations: (_mutations$1 = {}, _defineProperty(_mutations$1, SET_INITIALIZED, function (state, initialized) {
    state.initialized = initialized;
  }), _defineProperty(_mutations$1, SET_OPTIONS, function (state, options) {
    options = options || {};
    state.options = options;
    state.batchFrequency = options.batchFrequency || state.batchFrequency;
  }), _defineProperty(_mutations$1, SET_LISTENER, function (state, action) {
    window.removeEventListener('beforeunload', action, {
      capture: true
    });
    window.addEventListener('beforeunload', action, {
      capture: true
    });
  }), _defineProperty(_mutations$1, SET_DEVICE_ID, function (state) {
    var id = cookies.get(state.deviceIdCookieName);

    if (!id) {
      id = v4();
    }

    cookies.set(state.deviceIdCookieName, id, '5y');
    state.deviceId = id;
  }), _defineProperty(_mutations$1, ADD_EVENT, function (state, event) {
    state.batchedEvents.push(event);
  }), _defineProperty(_mutations$1, CLEAR_EVENTS, function (state) {
    state.batchedEvents = [];
  }), _defineProperty(_mutations$1, SCHEDULE_BATCH, function (state, action) {
    state.sendBatchTimeoutId = setTimeout(action, state.batchFrequency);
  }), _defineProperty(_mutations$1, REMOVE_TIMEOUT, function (state) {
    if (state.sendBatchTimeoutId) {
      clearTimeout(state.sendBatchTimeoutId);
      state.sendBatchTimeoutId = undefined;
    }
  }), _defineProperty(_mutations$1, SET_TOKEN, function (state, userToken) {
    state.userToken = userToken;
  }), _defineProperty(_mutations$1, SET_SOURCE_APPLICATION, function (state, sourceApplication) {
    state.sourceApplication = sourceApplication;
  }), _defineProperty(_mutations$1, SET_LOGGING_API, function (state, loggingApi) {
    state.loggingApi = loggingApi;
  }), _defineProperty(_mutations$1, SET_LOGGING_ENABLED, function (state, loggingEnabled) {
    state.loggingEnabled = loggingEnabled;
  }), _mutations$1),
  actions: {
    initLoggingAction: function initLoggingAction(_ref, options) {
      var commit = _ref.commit,
          getters = _ref.getters,
          dispatch = _ref.dispatch;
      var token;
      var sourceApplication;
      var loggingApi;
      var loggingEnabled;
      commit(SET_INITIALIZED, true);
      commit(SET_OPTIONS, options);
      commit(SET_DEVICE_ID);

      if (options) {
        token = options.userToken;
        sourceApplication = options.sourceApplication;
        loggingApi = options.loggingApi;
        loggingEnabled = options.loggingEnabled;
      }

      sourceApplication = sourceApplication || getters.sourceApplication;
      commit(SET_TOKEN, token);
      commit(SET_SOURCE_APPLICATION, sourceApplication);
      commit(SET_LOGGING_API, loggingApi);
      commit(SET_LOGGING_ENABLED, loggingEnabled);
      commit(REMOVE_TIMEOUT);

      if (getters.loggingEnabled) {
        commit(SET_LISTENER, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return dispatch('finalizeBatchAction');

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })));
        commit(SCHEDULE_BATCH, function () {
          dispatch('sendBatchAction');
        });
      }
    },
    sendBatchAction: function sendBatchAction(_ref3) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var commit, getters, dispatch, url, body, userToken;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                commit = _ref3.commit, getters = _ref3.getters, dispatch = _ref3.dispatch;

                if (!getters.loggingEnabled) {
                  _context2.next = 12;
                  break;
                }

                if (!(getters.batchedEvents && getters.batchedEvents.length > 0)) {
                  _context2.next = 10;
                  break;
                }

                consoleLog('sendBatchAction');
                url = "".concat(getters.loggingApi, "/events");
                body = JSON.stringify(getters.batchedEvents);
                userToken = getters.userToken;
                _context2.next = 9;
                return fetch(url, {
                  method: 'POST',
                  keepalive: true,
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': userToken
                  },
                  body: body
                });

              case 9:
                consoleLog('finish sendBatchAction');

              case 10:
                commit(CLEAR_EVENTS);
                commit(SCHEDULE_BATCH, function () {
                  dispatch('sendBatchAction');
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    finalizeBatchAction: function finalizeBatchAction(_ref4) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var commit, dispatch;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commit = _ref4.commit, dispatch = _ref4.dispatch;
                consoleLog('finalizeBatchAction');
                commit(REMOVE_TIMEOUT);
                _context3.next = 5;
                return dispatch('sendBatchAction');

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    logEventAction: function logEventAction(_ref5, data) {
      var commit = _ref5.commit,
          getters = _ref5.getters;

      if (getters.loggingEnabled) {
        var route = data.route || {};
        var now = new Date();
        var postBody = {
          event: data.data.event,
          target: data.data.target,
          eventData: _objectSpread2(_objectSpread2({}, data.data.eventData), {}, {
            timestamp: now.toUTCString()
          }),
          deviceId: getters.deviceId,
          sourceApplication: getters.sourceApplication,
          userAgent: window.navigator.userAgent,
          route: {
            name: route.name,
            fullPath: route.fullPath,
            path: route.path,
            params: route.params,
            query: route.query
          }
        };
        commit(ADD_EVENT, postBody);
        consoleLog('logEventAction');
        consoleLog(postBody);
      }
    }
  },
  getters: {
    initialized: function initialized(state) {
      return state.initialized;
    },
    options: function options(state) {
      return state.options;
    },
    userToken: function userToken(state) {
      return state.userToken;
    },
    sendBatchTimeoutId: function sendBatchTimeoutId(state) {
      return state.sendBatchTimeoutId;
    },
    batchedEvents: function batchedEvents(state) {
      return state.batchedEvents;
    },
    batchFrequency: function batchFrequency(state) {
      return state.batchFrequency;
    },
    loggingEnabled: function loggingEnabled(state) {
      return parseBool(state.loggingEnabled);
    },
    deviceId: function deviceId(state) {
      return state.deviceId;
    },
    sourceApplication: function sourceApplication(state) {
      return state.sourceApplication;
    },
    loggingApi: function loggingApi(state) {
      return state.loggingApi;
    }
  }
};

var ADD_CONCURRENT_USER = 'AddConcurrentUser';
var REMOVE_CONCURRENT_USER = 'RemoveConcurrentUser';
var SET_HUB_CONNECTION = 'SetHubConnection';
var SET_AP_POSTING_PROGRESS = 'SetApPostingProgress';
var SET_DISPLAY_CONCURRENT_USERS = 'SetDisplayConcurrentUsers';
var SET_CONCURRENT_USERS = 'SetConcurrentUsers';
var SET_HUB_READY$1 = 'SetHubReady';
var ADD_GROUP_USER_LOCK = 'AddGroupLockUser';
var REMOVE_GROUP_USER_LOCK = 'RemoveGroupLockUser';
var REMOVE_GROUP_LOCKS = 'RemoveGroupLock';
var REMOVE_GROUP_LOCK_SECTION = 'RemoveGroupLockSection';
var SET_GROUP_USER_LOCKS = 'SetGroupUsers';
var SET_GROUP_LOCKS_ENABLED = 'SetLockEnabled';
var SET_GROUP_NAME = 'SetGroupName';
var REMOVE_TOAST = 'RemoveToast';
var ADD_TOAST = 'AddToast';

var communicationHubMutationTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ADD_CONCURRENT_USER: ADD_CONCURRENT_USER,
  REMOVE_CONCURRENT_USER: REMOVE_CONCURRENT_USER,
  SET_HUB_CONNECTION: SET_HUB_CONNECTION,
  SET_AP_POSTING_PROGRESS: SET_AP_POSTING_PROGRESS,
  SET_DISPLAY_CONCURRENT_USERS: SET_DISPLAY_CONCURRENT_USERS,
  SET_CONCURRENT_USERS: SET_CONCURRENT_USERS,
  SET_HUB_READY: SET_HUB_READY$1,
  ADD_GROUP_USER_LOCK: ADD_GROUP_USER_LOCK,
  REMOVE_GROUP_USER_LOCK: REMOVE_GROUP_USER_LOCK,
  REMOVE_GROUP_LOCKS: REMOVE_GROUP_LOCKS,
  REMOVE_GROUP_LOCK_SECTION: REMOVE_GROUP_LOCK_SECTION,
  SET_GROUP_USER_LOCKS: SET_GROUP_USER_LOCKS,
  SET_GROUP_LOCKS_ENABLED: SET_GROUP_LOCKS_ENABLED,
  SET_GROUP_NAME: SET_GROUP_NAME,
  REMOVE_TOAST: REMOVE_TOAST,
  ADD_TOAST: ADD_TOAST
});

var REMOVE_GROUP_USER_LOCK_ACTION = 'removeGroupLockUserAction';
var SEND_REMOVE_GROUP_USER_LOCK_ACTION = 'sendRemoveGroupLockUserAction';
var ADD_GROUP_USER_LOCK_ACTION = 'addGroupLockUserAction';
var SEND_ADD_GROUP_USER_LOCK_ACTION = 'sendAddGroupLockUserAction';
var GET_GROUP_SECTION_LOCK_ACTION = 'getGroupSectionLockActionn';
var SEND_GET_GROUP_SECTION_LOCK_ACTION = 'sendGetGroupSectionLockAction';
var SEND_REMOVE_GROUP_LOCK_SECTION_ACTION = 'sendRemoveGroupLockForSectionAction';
var REMOVE_GROUP_LOCK_SECTION_ACTION = 'removeGroupLockForSectionAction';

/**
 * Server-side VueHub methods in Vue.Functions.Messages.Functions.VueHub
 */
var JOIN_GROUP_METHOD = 'JoinGroup';
var LEAVE_GROUP_METHOD = 'LeaveGroup';
var GET_COMMUNICATION_METHOD = 'GetCommunication';

var communicationHubMethods = /*#__PURE__*/Object.freeze({
  __proto__: null,
  JOIN_GROUP_METHOD: JOIN_GROUP_METHOD,
  LEAVE_GROUP_METHOD: LEAVE_GROUP_METHOD,
  GET_COMMUNICATION_METHOD: GET_COMMUNICATION_METHOD
});

var _mutations$2, _actions;
var communicationHubModule = {
  strict: "production" !== 'production',
  name: 'communicationHub',
  namespaced: true,
  state: {
    concurrentUsers: {},
    locks: {},

    /*
    	{
    		'group': [
    			{
    				EmployeeId: 1,
    				GroupName: 'group'
    				Section: 'Deals'
    				DisplayName: 'deal'
    			}
    		]
    	}
    */
    apPostingProgress: {},

    /* Object Example
    {
    	checkCount: 10,
    	currentCheckIndex: 5,
    	complete: false,
    	currentVendor: {
    		id: 123,
    		vendorName: 'Vendor A',
    		invoiceCount: 2,
    	}
    } */
    hubConnection: undefined,
    displayConcurrentUsers: false,
    locksEnabled: false,
    hubReady: false,
    hubLogLevel: process.env.VUE_APP_LOG_LEVEL,
    groupName: null,
    activeToasts: []
  },
  mutations: (_mutations$2 = {}, _defineProperty(_mutations$2, ADD_CONCURRENT_USER, function (state, message) {
    var currentUser = store.getters['user/userInfo'];

    if (currentUser && currentUser.EmployeeId) {
      if (message.EmployeeId == currentUser.EmployeeId) {
        //don't add yourself to the current user list
        return;
      }
    }

    if (!state.concurrentUsers[message.GroupName]) {
      Vue.set(state.concurrentUsers, message.GroupName, []);
    } else {
      //see if user is already in the array of concurrent users
      var index = state.concurrentUsers[message.GroupName].findIndex(function (u) {
        return u.EmployeeId === message.EmployeeId;
      }); //if exists, remove and re-add in case new info is in the message

      if (index >= 0) {
        state.concurrentUsers[message.GroupName].splice(index, 1);
      }
    }

    state.concurrentUsers[message.GroupName].splice(0, 0, message);
  }), _defineProperty(_mutations$2, ADD_GROUP_USER_LOCK, function (state, message) {
    if (!state.locks[message.GroupName]) {
      Vue.set(state.locks, message.GroupName, []);
    } else {
      //see if user is already in the array of concurrent users
      var index = state.locks[message.GroupName].findIndex(function (u) {
        return u.EmployeeId === message.EmployeeId && u.Section === message.Section;
      }); //if exists, remove and re-add in case new info is in the message

      if (index >= 0) {
        state.concurrentUsers[message.GroupName].splice(index, 1);
      }
    }

    state.locks[message.GroupName].splice(0, 0, message.data);
  }), _defineProperty(_mutations$2, REMOVE_GROUP_USER_LOCK, function (state, message) {
    if (state.locks[message.GroupName]) {
      //find the user
      var index = state.locks[message.GroupName].findIndex(function (u) {
        return u.EmployeeId === message.EmployeeId && message.Section === u.Section;
      }); //if exists, remove

      if (index >= 0) {
        state.locks[message.GroupName].splice(index, 1);
      }
    }
  }), _defineProperty(_mutations$2, REMOVE_CONCURRENT_USER, function (state, message) {
    if (state.concurrentUsers[message.GroupName]) {
      //find the user
      var index = state.concurrentUsers[message.GroupName].findIndex(function (u) {
        return u.EmployeeId === message.EmployeeId;
      }); //if exists, remove

      if (index >= 0) {
        state.concurrentUsers[message.GroupName].splice(index, 1);
      }
    }
  }), _defineProperty(_mutations$2, SET_AP_POSTING_PROGRESS, function (state, message) {
    state.apPostingProgress = message;
  }), _defineProperty(_mutations$2, SET_DISPLAY_CONCURRENT_USERS, function (state, displayConcurrentUsers) {
    state.displayConcurrentUsers = displayConcurrentUsers;
  }), _defineProperty(_mutations$2, SET_GROUP_LOCKS_ENABLED, function (state, locksEnabled) {
    state.locksEnabled = locksEnabled;
  }), _defineProperty(_mutations$2, SET_CONCURRENT_USERS, function (state, data) {
    var currentUser = store.getters['user/userInfo'];
    var index;

    if (data && data.Users) {
      index = data.Users.findIndex(function (u) {
        return u.EmployeeId == currentUser.EmployeeId;
      }); //remove current user from list if there

      if (index >= 0) {
        data.Users.splice(index, 1);
      }
    }

    Vue.set(state.concurrentUsers, data.GroupName, data.Users);
  }), _defineProperty(_mutations$2, SET_GROUP_USER_LOCKS, function (state, data) {
    Vue.set(state.locks, data.GroupName, data.Locks);
  }), _defineProperty(_mutations$2, REMOVE_GROUP_LOCKS, function (state, groupName) {
    Vue.set(state.locks, groupName, []);
  }), _defineProperty(_mutations$2, REMOVE_GROUP_LOCK_SECTION, function (state, data) {
    if (state.locks[data.groupName]) {
      state.locks[data.groupName] = state.locks[data.groupName].filter(function (item) {
        return item !== data.section;
      });
    }

    Vue.set(state.locks, data.groupName, state.locks[data.groupName]);
  }), _defineProperty(_mutations$2, SET_GROUP_NAME, function (state, groupName) {
    state.groupName = groupName;
  }), _defineProperty(_mutations$2, REMOVE_TOAST, function (state, id) {
    var toastIndex = state.activeToasts.findIndex(function (t) {
      return t.id === id;
    });

    if (toastIndex >= 0) {
      state.activeToasts.splice(toastIndex, 1);
    }
  }), _defineProperty(_mutations$2, ADD_TOAST, function (state, toast) {
    var toastIndex = state.activeToasts.findIndex(function (t) {
      return t.id === toast.id;
    });

    if (toastIndex >= 0) {
      state.activeToasts.splice(toastIndex, 1, toast);
    } else {
      state.activeToasts.push(toast);
    }
  }), _mutations$2),
  actions: (_actions = {
    /**
     *Called from page-mixin when user visits page
     * @param {*} param0
     * @param {*} param1
     */
    // eslint-disable-next-line no-unused-vars
    addConcurrentUserAction: function addConcurrentUserAction(_ref, _ref2) {
      var dispatch = _ref.dispatch;
      var groupName = _ref2.groupName,
          user = _ref2.user;

      var userClone = _objectSpread2(_objectSpread2({}, user), {}, {
        GroupName: groupName
      });

      dispatch('hub/invokeHubMethodAction', {
        message: {
          mutations: ["communicationHub/".concat(ADD_CONCURRENT_USER)],
          groupName: groupName,
          data: userClone,
          getMembership: true,
          dealershipGroupId: user.AspNetCompaniesId,
          companyId: user.CurrentEmployeeCompanyId
        },
        method: JOIN_GROUP_METHOD
      }, {
        root: true
      });
    },
    removeConcurrentUserAction: function removeConcurrentUserAction(_ref3, _ref4) {
      var dispatch = _ref3.dispatch;
      var groupName = _ref4.groupName,
          user = _ref4.user;

      var userClone = _objectSpread2(_objectSpread2({}, user), {}, {
        GroupName: groupName
      });

      dispatch('hub/invokeHubMethodAction', {
        message: {
          mutations: ["communicationHub/".concat(REMOVE_CONCURRENT_USER)],
          groupName: groupName,
          data: userClone,
          dealershipGroupId: user.AspNetCompaniesId,
          companyId: user.CurrentEmployeeCompanyId
        },
        method: LEAVE_GROUP_METHOD
      }, {
        root: true
      });
    }
  }, _defineProperty(_actions, REMOVE_GROUP_USER_LOCK_ACTION, function (_ref5, data) {
    var commit = _ref5.commit,
        state = _ref5.state;
    var groupName = data.GroupName;
    commit(REMOVE_GROUP_USER_LOCK, {
      groupName: groupName,
      data: data
    });

    if (groupName == state.groupName) {
      window.dispatchEvent(new CustomEvent('vue-concurrent-users-receive', {
        detail: {
          action: ["communicationHub/".concat(REMOVE_GROUP_USER_LOCK)],
          groupName: groupName,
          data: data
        }
      }));
    }
  }), _defineProperty(_actions, ADD_GROUP_USER_LOCK_ACTION, function (_ref6, data) {
    var commit = _ref6.commit,
        state = _ref6.state;
    var groupName = data.GroupName;
    commit(ADD_GROUP_USER_LOCK, {
      groupName: groupName,
      data: data
    });

    if (groupName == state.groupName) {
      window.dispatchEvent(new CustomEvent('vue-concurrent-users-receive', {
        detail: {
          action: "communicationHub/".concat(ADD_GROUP_USER_LOCK),
          groupName: data.groupName,
          data: data
        }
      }));
    }
  }), _defineProperty(_actions, SEND_REMOVE_GROUP_USER_LOCK_ACTION, function (_ref7, _ref8) {
    var dispatch = _ref7.dispatch;
    var groupName = _ref8.groupName,
        lock = _ref8.lock;
    var currentUser = store.getters['user/userInfo'];
    dispatch('hub/invokeHubMethodAction', {
      message: {
        actions: ["communicationHub/".concat(REMOVE_GROUP_USER_LOCK_ACTION)],
        groupName: groupName,
        serverAction: 'Remove',
        persistKey: "".concat(groupName, "_").concat(lock.Section),
        data: lock,
        dealershipGroupId: currentUser.AspNetCompaniesId,
        companyId: currentUser.CurrentEmployeeCompanyId,
        excludeSenderConnection: false
      }
    }, {
      root: true
    });
  }), _defineProperty(_actions, SEND_ADD_GROUP_USER_LOCK_ACTION, function (_ref9, _ref10) {
    var dispatch = _ref9.dispatch;
    var groupName = _ref10.groupName,
        lock = _ref10.lock;
    var currentUser = store.getters['user/userInfo'];
    dispatch('hub/invokeHubMethodAction', {
      message: {
        actions: ["communicationHub/".concat(ADD_GROUP_USER_LOCK_ACTION)],
        groupName: groupName,
        data: lock,
        serverAction: 'Persist',
        persistKey: "".concat(groupName, "_").concat(lock.Section),
        dealershipGroupId: currentUser.AspNetCompaniesId,
        companyId: currentUser.CurrentEmployeeCompanyId,
        excludeSenderConnection: false
      }
    }, {
      root: true
    });
  }), _defineProperty(_actions, SEND_GET_GROUP_SECTION_LOCK_ACTION, function (_ref11, _ref12) {
    var dispatch = _ref11.dispatch;
    var groupName = _ref12.groupName,
        lock = _ref12.lock;
    var currentUser = store.getters['user/userInfo'];
    dispatch('hub/invokeHubMethodAction', {
      message: {
        actions: ["communicationHub/".concat(GET_GROUP_SECTION_LOCK_ACTION)],
        groupName: groupName,
        persistKey: "".concat(groupName, "_").concat(lock.Section),
        data: lock,
        dealershipGroupId: currentUser.AspNetCompaniesId,
        companyId: currentUser.CurrentEmployeeCompanyId,
        excludeSenderConnection: false
      },
      method: GET_COMMUNICATION_METHOD
    }, {
      root: true
    });
  }), _defineProperty(_actions, GET_GROUP_SECTION_LOCK_ACTION, function (_ref13, _ref14) {
    var commit = _ref13.commit,
        state = _ref13.state;
    var data = _ref14.data;
    var addAction = "communicationHub/".concat(ADD_GROUP_USER_LOCK);

    if (data.action == addAction) {
      commit(ADD_GROUP_USER_LOCK, {
        groupName: data.groupName,
        data: data
      });

      if (data.groupName == state.groupName) {
        window.dispatchEvent(new CustomEvent('vue-concurrent-users-receive', {
          detail: {
            action: addAction,
            groupName: data.groupName,
            data: data
          }
        }));
      }
    }
  }), _defineProperty(_actions, REMOVE_GROUP_LOCK_SECTION_ACTION, function (_ref15, data) {
    var commit = _ref15.commit,
        state = _ref15.state;
    commit(REMOVE_GROUP_LOCK_SECTION, {
      groupName: data.GroupName,
      data: data
    });

    if (data.groupName == state.groupName) {
      window.dispatchEvent(new CustomEvent('vue-concurrent-users-receive', {
        detail: {
          action: "communicationHub/".concat(REMOVE_GROUP_LOCK_SECTION),
          groupName: data.groupName,
          data: data
        }
      }));
    }
  }), _defineProperty(_actions, SEND_REMOVE_GROUP_LOCK_SECTION_ACTION, function (_ref16, _ref17) {
    var dispatch = _ref16.dispatch;
    var groupName = _ref17.groupName,
        lock = _ref17.lock;
    var currentUser = store.getters['user/userInfo'];
    dispatch('hub/invokeHubMethodAction', {
      message: {
        actions: ["communicationHub/".concat(REMOVE_GROUP_LOCK_SECTION_ACTION)],
        groupName: groupName,
        data: lock,
        serverAction: 'Remove',
        persistKey: "".concat(groupName, "_").concat(lock.Section),
        dealershipGroupId: currentUser.AspNetCompaniesId,
        companyId: currentUser.CurrentEmployeeCompanyId,
        excludeSenderConnection: false
      }
    }, {
      root: true
    });
  }), _defineProperty(_actions, "setDisplayConcurrentUsersAction", function setDisplayConcurrentUsersAction(_ref18, _ref19) {
    var commit = _ref18.commit;
    var displayConcurrentUsers = _ref19.displayConcurrentUsers,
        groupName = _ref19.groupName;
    commit(SET_DISPLAY_CONCURRENT_USERS, displayConcurrentUsers);
    commit(SET_GROUP_NAME, groupName);
  }), _defineProperty(_actions, "setLocksEnabledAction", function setLocksEnabledAction(_ref20, locksEnabled) {
    var commit = _ref20.commit;
    commit(SET_GROUP_LOCKS_ENABLED, locksEnabled);
  }), _defineProperty(_actions, "setAPPostingProgress", function setAPPostingProgress(_ref21, apPostingProgress) {
    var commit = _ref21.commit;
    commit(SET_AP_POSTING_PROGRESS, apPostingProgress);
  }), _defineProperty(_actions, "showToastAction", function showToastAction(_ref22, _ref23) {
    var commit = _ref22.commit;
    var message = _ref23.message,
        dismissibleTime = _ref23.dismissibleTime,
        state = _ref23.state,
        iconClassName = _ref23.iconClassName,
        siteLevel = _ref23.siteLevel;
    commit(ADD_TOAST, {
      message: message,
      dismissibleTime: dismissibleTime,
      state: state,
      iconClassName: iconClassName,
      siteLevel: siteLevel,
      id: v4()
    });
  }), _defineProperty(_actions, "dismissToastAction", function dismissToastAction(_ref24, id) {
    var commit = _ref24.commit;
    commit(REMOVE_TOAST, id);
  }), _actions),
  getters: {
    concurrentUsers: function concurrentUsers(state) {
      return state.concurrentUsers;
    },
    concurrentUsersByGroup: function concurrentUsersByGroup(state) {
      return function (group) {
        return state.concurrentUsers[group];
      };
    },
    apPostingProgress: function apPostingProgress(state) {
      return state.apPostingProgress;
    },
    displayConcurrentUsers: function displayConcurrentUsers(state) {
      return state.displayConcurrentUsers;
    },
    groupName: function groupName(state) {
      return state.groupName;
    },
    locksEnabled: function locksEnabled(state) {
      return state.enableLocks;
    },
    getUserLockByEmployeeId: function getUserLockByEmployeeId(state) {
      return function (group, employeeId) {
        return state.locks[group].find(function (user) {
          return user.EmployeeId === employeeId;
        });
      };
    },
    lockedUsersByGroup: function lockedUsersByGroup(state) {
      return function (group) {
        return state.locks[group];
      };
    },
    toast: function toast(state) {
      return state.toast;
    },
    toastVisible: function toastVisible(state) {
      return state.toastVisible;
    },
    toastMessage: function toastMessage(state) {
      var message = '';

      if (state.toast) {
        message = state.toast.message;
      }

      return message;
    },
    toastState: function toastState(state) {
      var tState = 'positive';

      if (state.toast) {
        tState = state.toast.state;
      }

      return tState;
    },
    toastDismissibleTime: function toastDismissibleTime(state) {
      var dismissibleTime = 0;

      if (state.toast) {
        dismissibleTime = state.toast.dismissibleTime;
      }

      return dismissibleTime;
    },
    toastIconClassName: function toastIconClassName(state) {
      var iconClassName = '';

      if (state.toast) {
        iconClassName = state.toast.iconClassName;
      }

      return iconClassName;
    },
    toastSiteLevel: function toastSiteLevel(state) {
      var siteLevel = true;

      if (state.toast) {
        siteLevel = state.toast.siteLevel;
      }

      return siteLevel;
    },
    activeToasts: function activeToasts(state) {
      return state.activeToasts;
    }
  }
};

Vue.use(Vuex);
var store = new Vuex.Store({
  strict: "production" !== 'production',
  modules: {
    user: userInfoModule,
    hub: hubModule,
    logging: loggingModule,
    communicationHub: communicationHubModule
  },
  plugins: userInfoPlugins
});

function getCompanyId() {
  var companyid;
  var params = new URLSearchParams(window.location.search);
  var appName = store.getters['user/appName'];

  if (params.has('cid')) {
    //AccessWeb url
    //Always short-circuit the id from the URL!
    companyid = parseInt(params.get('cid'));
  } else if (appName === 'vue-ui') {
    //LL route
    companyid = store.getters['user/currentCompanyId'];
  }

  if ((!companyid || companyid < 0) && store.getters['user/userReady']) {
    var userInfo = store.getters['user/userInfo'];
    var companies = store.getters['user/companiesResults'];
    companyid = parseInt(userInfo.CurrentEmployeeCompanyId);

    if (companies != undefined) {
      var first = companies.items[0];
      var found = companies.items.find(function (c) {
        return c.defaultCompany === true;
      });

      if (found == undefined) {
        companyid = first.id;
      } else {
        companyid = found.id;
      }
    }
  }

  return companyid;
}

function setCompanyId(companyId) {
  window.location.assign("/?cid=".concat(companyId));
}

var script = {
  name: 'VueCompanySelector',
  data: function data() {
    return {
      isOpen: false,
      activeCompanyId: 0
    };
  },
  mixins: [propsMixin],
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeCompanyId = getCompanyId(_this.$route);
              _context.next = 3;
              return _this.getCompaniesAction(_this.activeCompanyId);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    document.addEventListener('click', this.clickHandler);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.clickHandler);
  },
  computed: _objectSpread2(_objectSpread2({}, mapGetters('user', ['companiesResults'])), {}, {
    companies: function companies() {
      var companiesResults = {};

      if (this.companiesResults !== undefined) {
        companiesResults = this.companiesResults;
      }

      return companiesResults;
    },
    selectedCompany: function selectedCompany() {
      var _this2 = this;

      return this.companies.items && this.companies.items.find(function (item) {
        return item.id == _this2.activeCompanyId;
      });
    },
    selectedCompanyName: function selectedCompanyName() {
      var defaultCompany = this.selectedCompany;

      if (defaultCompany) {
        return defaultCompany.companyName;
      }

      return '';
    },
    selectedCompanyNumber: function selectedCompanyNumber() {
      var defaultCompany = this.selectedCompany;

      if (defaultCompany) {
        return defaultCompany.companyNumber;
      }

      return '';
    },
    selectedCompanyHoverText: function selectedCompanyHoverText() {
      var defaultCompany = this.selectedCompany;

      if (defaultCompany) {
        return "".concat(defaultCompany.companyName, " (").concat(defaultCompany.companyNumber, ")");
      }

      return '';
    },
    dropdownStyles: function dropdownStyles() {
      return [{
        '--company-default-color': this.getCompanyColor(),
        '--company-default-color--fg': this.getFontColor()
      }];
    }
  }),
  methods: _objectSpread2(_objectSpread2({}, mapActions('user', ['getCompaniesAction', 'clearStateAction'])), {}, {
    clickHandler: function clickHandler(event) {
      var target = event.target;
      var $el = this.$el;

      if (!$el.contains(target)) {
        this.isOpen = false;
      }
    },
    toogleList: function toogleList() {
      this.isOpen = !this.isOpen;
    },
    getCompanyColor: function getCompanyColor(company) {
      company = company || this.selectedCompany;

      if (company && company.companyColor) {
        return "#".concat(company.companyColor);
      }

      return '#ffffff';
    },
    getFontColor: function getFontColor(company) {
      company = company || this.selectedCompany;

      if (company && company.fontColor) {
        return company.fontColor;
      }

      return '#000000';
    },
    changeCompany: function changeCompany(company) {
      this.toogleList();

      if (this.activeCompanyId != company.id) {
        this.activeCompanyId = company.id;
        this.clearStateAction();
        setCompanyId(company.id);
      }
    },
    itemStyle: function itemStyle(company) {
      return [{
        backgroundColor: this.getCompanyColor(company)
      }];
    },
    onLinkClick: function onLinkClick(e) {
      //don't let the link navigate because we need changeCompany to be called
      e.preventDefault();
    }
  })
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "company",
    class: _vm.isOpen && 'is-open',
    style: _vm.dropdownStyles,
    attrs: {
      "data-id": "company"
    }
  }, [_c('button', {
    staticClass: "company__btn",
    attrs: {
      "id": "companyselected",
      "title": _vm.selectedCompanyHoverText
    },
    on: {
      "click": _vm.toogleList
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "company__name",
    attrs: {
      "data-id": "company-name"
    }
  }, [_vm._v(_vm._s(_vm.selectedCompanyName))]), _vm._v(" "), _vm.selectedCompanyNumber ? _c('span', {
    staticClass: "company__number",
    attrs: {
      "data-id": "company-number"
    }
  }, [_vm._v(_vm._s("(" + _vm.selectedCompanyNumber + ")"))]) : _vm._e(), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _vm.isOpen ? _c('ul', {
    staticClass: "company__menu",
    attrs: {
      "id": "companylist"
    }
  }, _vm._l(_vm.companies.items, function (company) {
    return _c('li', {
      key: company.id,
      class: ['company__menu-item', company.id == _vm.activeCompanyId ? 'is-active' : ''],
      attrs: {
        "id": "company_" + company.id
      },
      on: {
        "click": function click($event) {
          return _vm.changeCompany(company);
        }
      }
    }, [_c('a', {
      staticClass: "company__menu-item-link",
      attrs: {
        "href": "/?cid=" + company.id,
        "tabindex": "0"
      },
      on: {
        "click": _vm.onLinkClick
      }
    }, [_c('span', {
      staticClass: "company__color-badge",
      style: _vm.itemStyle(company)
    }), _vm._v(" "), _c('span', {
      staticClass: "company__menu-link"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(company.companyName) + " " + _vm._s("(" + company.companyNumber + ")") + "\n\t\t\t\t")])])]);
  }), 0) : _vm._e()]);
};

var __vue_staticRenderFns__ = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    staticClass: "company__icon"
  }, [_c('i', {
    staticClass: "icon icon-company"
  })]);
}, function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    staticClass: "company__expand-icon"
  }, [_c('i', {
    staticClass: "icon icon-arrow_down_filled"
  })]);
}];
/* style */

var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-3b87913f_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-3b87913f]:export{menubreakpoint:992}[data-v-3b87913f]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-3b87913f]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-3b87913f],body.light[data-v-3b87913f]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}[data-v-3b87913f]::-webkit-scrollbar{width:14px;background-color:var(--bg-0)}[data-v-3b87913f]::-webkit-scrollbar-track{box-shadow:inset 0 0 2px rgba(0,0,0,.2);background-color:var(--bg-0)}[data-v-3b87913f]::-webkit-scrollbar-thumb{background-color:var(--bg-0-fg-1);border-radius:14px;border:3px solid transparent;background-clip:content-box;min-height:16px}[data-v-3b87913f]::-webkit-scrollbar{width:14px;background-color:transparent}[data-v-3b87913f]::-webkit-scrollbar-track{border-top:1px solid transparent;box-shadow:none;background-color:transparent}[data-v-3b87913f]::-webkit-scrollbar-thumb{background-color:var(--bg-0-fg-1);border-radius:14px;border:3px solid transparent;background-clip:content-box}.company[data-v-3b87913f]{display:flex;height:100%;width:42px}@media (min-width:62em){.company[data-v-3b87913f]:focus,.company[data-v-3b87913f]:hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_bg-2-fg-3);cursor:pointer}}.company .is-active[data-v-3b87913f]{background:var(--layout_menu-list-bg-active);color:var(--layout_menu-list-fg-active);cursor:default}@media (min-width:36em){.company[data-v-3b87913f]{position:relative}}@media (min-width:62em){.company[data-v-3b87913f]{width:220px;max-width:220px}}.company>*[data-v-3b87913f]{font-size:14px}.company.is-open[data-v-3b87913f]{background:var(--layout_menu-list-bg-active);color:var(--layout_menu-list-fg-active)}@media (max-width:35.99em){.company.is-open[data-v-3b87913f]{background:var(--layout_bg-brand-1)}.company.is-open .company__icon[data-v-3b87913f]{color:var(--layout_bg-brand-1-fg-3)}}.company.is-open .company__expand-icon[data-v-3b87913f]{transform:scaleY(-1)}.company__btn[data-v-3b87913f]{display:flex;position:relative;align-items:center;width:42px;padding:0 8px;border:none;background:0 0;color:inherit;cursor:pointer}@media (min-width:62em){.company__btn[data-v-3b87913f]{width:100%}}.company__btn[data-v-3b87913f]:focus{outline:0}.company__name[data-v-3b87913f]{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}@media (max-width:61.99em){.company__name[data-v-3b87913f]{display:none}}@media (max-width:61.99em){.company__number[data-v-3b87913f]{display:none}}.company__menu[data-v-3b87913f]{max-width:220px;position:absolute;top:100%;right:0;min-width:100%;width:max-content;background:var(--layout_menu-list-bg);color:var(--layout_menu-list-fg);border-top:1px solid var(--layout_menu-list-border);z-index:2000;height:calc(100vh - 48px)}@media (min-width:36em){.company__menu[data-v-3b87913f]{border:1px solid var(--layout_menu-list-border);border-radius:0 0 4px 4px;box-shadow:0 2px 4px rgba(0,0,0,.2);height:auto}}.company__menu-item[data-v-3b87913f]:not(.is-active):hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_menu-list-fg-hover)}.company__menu-item-link[data-v-3b87913f]{display:flex;align-items:center;width:100%;padding:16px;line-height:16px}.company__badge-count[data-v-3b87913f]{display:inline-block;margin-right:4px;white-space:nowrap;border:2px solid var(--layout_off-white)}.company__expand-icon[data-v-3b87913f]{display:none;margin-left:auto;font-size:10px;transition:all .2s ease}@media (min-width:62em){.company__expand-icon[data-v-3b87913f]{display:inline-flex;align-items:center}}.company.is-open .company__btn[data-v-3b87913f]{background:0 0;color:var(--layout_bg-2-fg-3)}@media (min-width:62em){.company.is-open .company__btn[data-v-3b87913f]:hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_menu-list-fg-hover)}}@media (min-width:62em){.company:hover .company__btn[data-v-3b87913f]{background:0 0;color:var(--layout_bg-2-fg-3)}}.company__btn[data-v-3b87913f]{background:var(--company-default-color);color:var(--company-default-color--fg);border-radius:0}.company__btn[data-v-3b87913f]:focus-visible{outline:2px solid var(--layout_brand-2);outline-offset:-2px}.company__number[data-v-3b87913f]{margin-left:2px;margin-right:4px}.company__icon[data-v-3b87913f]{margin-right:4px;font-size:24px}.company__menu[data-v-3b87913f]{max-height:500px;overflow:auto}.company__menu-item[data-v-3b87913f]{display:flex;align-items:center}.company__color-badge[data-v-3b87913f]{display:inline-block;min-width:16px;width:16px;height:16px;margin-right:8px;border-radius:4px;border:1px solid var(--layout_neutral-1)}.company__menu-item-link[data-v-3b87913f]:focus-visible{outline:2px solid var(--layout_brand-2);outline-offset:-2px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__ = "data-v-3b87913f";
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

//
//
//
//
//
//
var script$1 = {
  name: 'VueHelp'
};

/* script */
var __vue_script__$1 = script$1;
/* template */

var __vue_render__$1 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm._m(0);
};

var __vue_staticRenderFns__$1 = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('button', {
    staticClass: "launch-intercom",
    attrs: {
      "id": "launchIntercom",
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "icon icon-help-2"
  })]);
}];
/* style */

var __vue_inject_styles__$1 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-1f75e456_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-1f75e456]:export{menubreakpoint:992}[data-v-1f75e456]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-1f75e456]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-1f75e456],body.light[data-v-1f75e456]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}.launch-intercom[data-v-1f75e456]{height:100%;width:100%;background:0 0;border:none;cursor:pointer;font-size:20px;background:var(--layout_bg-0);color:var(--layout_bg-0-fg-4);border-radius:0}.launch-intercom [disabled][data-v-1f75e456],.launch-intercom.disabled[data-v-1f75e456]{opacity:.38;pointer-events:none}@media (min-width:62em){.launch-intercom[data-v-1f75e456]:hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_bg-2-fg-3)}}.launch-intercom[data-v-1f75e456]:focus-visible{outline:2px solid var(--layout_brand-2);outline-offset:-2px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$1 = "data-v-1f75e456";
/* module identifier */

var __vue_module_identifier__$1 = undefined;
/* functional template */

var __vue_is_functional_template__$1 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, createInjector, undefined, undefined);

var script$2 = {
  name: 'VueProfileMenu',
  mixins: [propsMixin],
  data: function data() {
    return {
      isProfileMenuOpen: false
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getProfileMenuResultsAction();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    document.addEventListener('click', this.clickHandler);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.clickHandler);
  },
  computed: _objectSpread2(_objectSpread2({}, mapGetters('user', ['appName', 'profileMenuResults'])), {}, {
    messageCenterURL: function messageCenterURL() {
      var messageCenterItem = this.getProfileMenuItem('Message Center');

      if (messageCenterItem) {
        return messageCenterItem.url;
      }

      return '';
    },
    profileItems: function profileItems() {
      var items;

      if (this.profileMenuResults !== undefined) {
        items = this.profileMenuResults.profileItems;
      }

      return items;
    }
  }),
  methods: _objectSpread2(_objectSpread2({}, mapActions('user', ['logoutUserAction', 'getProfileMenuResultsAction'])), {}, {
    isUrlLink: function isUrlLink(menuItem) {
      var result = true;

      if (menuItem.linkType && menuItem.linkType.toLowerCase() === 'route') {
        result = false;
      }

      return result;
    },
    logout: function logout() {
      //clears limelight state
      this.logoutUserAction(); //do AccessWeb logout

      window.dispatchEvent(new Event('vuelogout'));
    },
    clickHandler: function clickHandler(event) {
      var target = event.target;
      var $el = this.$el;

      if (!$el.contains(target) && this.isProfileMenuOpen) {
        this.isProfileMenuOpen = !this.isProfileMenuOpen;
      }
    },
    goToRouteByName: function goToRouteByName(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    displayProfileMenu: function displayProfileMenu(event) {
      var target = event.target;

      if (target.classList.contains('ignoreBadgeClick')) {
        return;
      }

      this.isProfileMenuOpen = !this.isProfileMenuOpen;
    },
    getProfileMenuItem: function getProfileMenuItem(menuTitle) {
      if (!this.profileMenuResults.profileItems) {
        return null;
      }

      return this.profileMenuResults.profileItems.find(function (p) {
        return p.name === menuTitle;
      });
    },
    messageCenterLinkType: function messageCenterLinkType() {
      var messageCenterItem = this.getProfileMenuItem('Message Center');

      if (messageCenterItem) {
        return messageCenterItem.linkType;
      }

      return 'Url';
    },
    onMenuItemClick: function onMenuItemClick() {
      this.isProfileMenuOpen = false;
    }
  })
};

var __vue_script__$2 = script$2;
/* template */

var __vue_render__$2 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "profile",
    class: _vm.isProfileMenuOpen && 'is-open'
  }, [_c('button', {
    staticClass: "profile__btn",
    attrs: {
      "data-testid": "profile-menu-name-label"
    },
    on: {
      "click": _vm.displayProfileMenu
    }
  }, [_c('span', {
    staticClass: "profile__name-badge",
    attrs: {
      "data-testid": "profile-menu-initials"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.profileMenuResults.userInitials) + "\n\t\t")]), _vm._v(" "), _vm.messageCenterLinkType() === 'Url' ? _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.profileMenuResults.unreadCount > 0,
      expression: "profileMenuResults.unreadCount > 0"
    }],
    staticClass: "profile__badge-count ignoreBadgeClick",
    attrs: {
      "href": _vm.messageCenterURL,
      "data-testid": "profile-menu-unread-count"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.profileMenuResults.unreadCount) + "\n\t\t")]) : _vm._e(), _vm._v(" "), _vm.messageCenterLinkType() === 'route' ? _c('router-link', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.profileMenuResults.unreadCount > 0,
      expression: "profileMenuResults.unreadCount > 0"
    }],
    staticClass: "profile__badge-count ignoreBadgeClick",
    attrs: {
      "to": _vm.messageCenterURL,
      "data-testid": "profile-menu-unread-count"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.profileMenuResults.unreadCount) + "\n\t\t")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "profile__name"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.profileMenuResults.userName) + "\n\t\t")]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isProfileMenuOpen,
      expression: "isProfileMenuOpen"
    }],
    staticClass: "profile__menu",
    attrs: {
      "data-testid": "profile-menu-items-menu"
    }
  }, [_vm._l(_vm.profileItems, function (menuItem) {
    return _c('li', {
      key: menuItem.name,
      staticClass: "profile__menu-item"
    }, [_vm.isUrlLink(menuItem) ? _c('a', {
      staticClass: "profile__menu-item-link",
      attrs: {
        "href": menuItem.url,
        "target": menuItem.target,
        "data-testid": "profile-menu-accessweb-link"
      },
      on: {
        "click": _vm.onMenuItemClick
      }
    }, [_vm._v(_vm._s(menuItem.name) + "\n\t\t\t\t"), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.profileMenuResults.unreadCount > 0 && menuItem.name === 'Message Center',
        expression: "\n\t\t\t\t\t\tprofileMenuResults.unreadCount > 0 &&\n\t\t\t\t\t\t\tmenuItem.name === 'Message Center'\n\t\t\t\t\t"
      }],
      staticClass: "profile__badge-count"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.profileMenuResults.unreadCount) + "\n\t\t\t\t")])]) : _vm._e(), _vm._v(" "), !_vm.isUrlLink(menuItem) ? _c('router-link', {
      staticClass: "profile__menu-item-link",
      attrs: {
        "to": menuItem.url,
        "data-testid": "profile-menu-router-link"
      },
      on: {
        "click": _vm.onMenuItemClick
      }
    }, [_vm._v(_vm._s(menuItem.name) + "\n\t\t\t\t"), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.profileMenuResults.unreadCount > 0 && menuItem.name === 'Message Center',
        expression: "\n\t\t\t\t\t\tprofileMenuResults.unreadCount > 0 &&\n\t\t\t\t\t\t\tmenuItem.name === 'Message Center'\n\t\t\t\t\t"
      }],
      staticClass: "profile__badge-count"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.profileMenuResults.unreadCount) + "\n\t\t\t\t")])]) : _vm._e()], 1);
  }), _vm._v(" "), _c('li', {
    staticClass: "profile__menu-item"
  }, [_c('a', {
    staticClass: "profile__menu-item-link",
    attrs: {
      "data-testid": "profile-menu-log-off"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Log Off")])])], 2)]);
};

var __vue_staticRenderFns__$2 = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    staticClass: "profile__expand-icon"
  }, [_c('i', {
    staticClass: "icon icon-arrow_down_filled"
  })]);
}];
/* style */

var __vue_inject_styles__$2 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-a77cc742_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-a77cc742]:export{menubreakpoint:992}[data-v-a77cc742]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-a77cc742]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-a77cc742],body.light[data-v-a77cc742]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}.profile[data-v-a77cc742]{display:flex;height:100%;width:42px}@media (min-width:62em){.profile[data-v-a77cc742]:focus,.profile[data-v-a77cc742]:hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_bg-2-fg-3);cursor:pointer}}.profile .is-active[data-v-a77cc742]{background:var(--layout_menu-list-bg-active);color:var(--layout_menu-list-fg-active);cursor:default}@media (min-width:36em){.profile[data-v-a77cc742]{position:relative}}@media (min-width:62em){.profile[data-v-a77cc742]{width:220px;max-width:220px}}.profile>*[data-v-a77cc742]{font-size:14px}.profile.is-open[data-v-a77cc742]{background:var(--layout_menu-list-bg-active);color:var(--layout_menu-list-fg-active)}@media (max-width:35.99em){.profile.is-open[data-v-a77cc742]{background:var(--layout_bg-brand-1)}.profile.is-open .profile__icon[data-v-a77cc742]{color:var(--layout_bg-brand-1-fg-3)}}.profile.is-open .profile__expand-icon[data-v-a77cc742]{transform:scaleY(-1)}.profile__btn[data-v-a77cc742]{display:flex;position:relative;align-items:center;width:42px;padding:0 8px;border:none;background:0 0;color:inherit;cursor:pointer}@media (min-width:62em){.profile__btn[data-v-a77cc742]{width:100%}}.profile__btn[data-v-a77cc742]:focus{outline:0}.profile__name[data-v-a77cc742]{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}@media (max-width:61.99em){.profile__name[data-v-a77cc742]{display:none}}@media (max-width:61.99em){.profile__number[data-v-a77cc742]{display:none}}.profile__menu[data-v-a77cc742]{max-width:220px;position:absolute;top:100%;right:0;min-width:100%;width:max-content;background:var(--layout_menu-list-bg);color:var(--layout_menu-list-fg);border-top:1px solid var(--layout_menu-list-border);z-index:2000;height:calc(100vh - 48px)}@media (min-width:36em){.profile__menu[data-v-a77cc742]{border:1px solid var(--layout_menu-list-border);border-radius:0 0 4px 4px;box-shadow:0 2px 4px rgba(0,0,0,.2);height:auto}}.profile__menu-item[data-v-a77cc742]:not(.is-active):hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_menu-list-fg-hover)}.profile__menu-item-link[data-v-a77cc742]{display:flex;align-items:center;width:100%;padding:16px;line-height:16px}.profile__badge-count[data-v-a77cc742]{display:inline-block;margin-right:4px;white-space:nowrap;border:2px solid var(--layout_off-white)}.profile__expand-icon[data-v-a77cc742]{display:none;margin-left:auto;font-size:10px;transition:all .2s ease}@media (min-width:62em){.profile__expand-icon[data-v-a77cc742]{display:inline-flex;align-items:center}}.profile__name-badge[data-v-a77cc742]{display:inline-flex;align-items:center;justify-content:center;min-width:26px;min-height:26px;width:26px;height:26px;border-radius:4px;background:var(--layout_bg-brand-1);color:var(--layout_bg-brand-1-fg-3)}@media (min-width:62em){.profile__name-badge[data-v-a77cc742]{margin-right:8px}}.profile__btn[data-v-a77cc742]:focus-visible{outline:2px solid var(--layout_brand-2);outline-offset:-2px}@media (min-width:62em){.profile__btn[data-v-a77cc742]:hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_menu-list-fg-hover)}}.profile__btn>.profile__badge-count[data-v-a77cc742]{display:none;position:absolute;top:0;left:20px;cursor:pointer;text-decoration:none}@media (min-width:62em){.profile__btn>.profile__badge-count[data-v-a77cc742]{display:inherit}}.profile__btn>.profile__badge-count[data-v-a77cc742]:focus-visible{outline:2px solid var(--layout_brand-2);outline-offset:-2px}.profile__badge-count[data-v-a77cc742]{display:inline-flex;justify-content:center;align-items:center;min-width:20px;height:20px;padding-left:6px;padding-right:6px;color:#0d0d0d;border-radius:12px;font-size:12px;font-weight:400;box-sizing:border-box;background:#5bc0de}.profile__menu-item-link[data-v-a77cc742]{position:relative}.profile__menu-item-link .profile__badge-count[data-v-a77cc742]{margin-left:4px}.profile__menu-item-link[data-v-a77cc742]:focus-within:focus-visible{outline:2px solid var(--layout_brand-2);outline-offset:-2px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$2 = "data-v-a77cc742";
/* module identifier */

var __vue_module_identifier__$2 = undefined;
/* functional template */

var __vue_is_functional_template__$2 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$3 = {
  name: 'VueNotificationBell',
  props: {
    counter: {
      type: Number,
      default: 0,
      require: true
    },
    displayLimit: {
      type: Number,
      default: 99
    },
    hasDisplayLimit: {
      type: Boolean,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    displayCounter: function displayCounter() {
      var text = this.counter;

      if (this.hasDisplayLimit && this.counter > this.displayLimit) {
        text = this.displayLimit + '+';
      }

      return text;
    }
  },
  methods: {
    notifyClick: function notifyClick() {
      this.$emit('bellClicked');
    }
  }
};

/* script */
var __vue_script__$3 = script$3;
/* template */

var __vue_render__$3 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "notification-bell",
    class: _vm.isOpen && 'is-open'
  }, [_c('button', {
    staticClass: "notification-bell__btn",
    attrs: {
      "data-id": "header-notifications-bell"
    },
    on: {
      "click": _vm.notifyClick
    }
  }, [_c('div', {
    staticClass: "notification-bell__badge-count",
    attrs: {
      "data-id": "total-count-badge"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.displayCounter))])]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-notification-2"
  })])]);
};

var __vue_staticRenderFns__$3 = [];
/* style */

var __vue_inject_styles__$3 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-5181c19c_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-5181c19c]:export{menubreakpoint:992}[data-v-5181c19c]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-5181c19c]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-5181c19c],body.light[data-v-5181c19c]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}@media (min-width:62em){.notification-bell[data-v-5181c19c]:hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_menu-list-fg-hover)}}@media (max-width:35.99em){.notification-bell.is-open .notification-bell__btn .icon[data-v-5181c19c]{color:var(--layout_bg-0)}}.notification-bell__btn[data-v-5181c19c]{position:relative;background:0 0;border:none;cursor:pointer;width:42px;height:100%;font-size:20px;padding:0 8px}.notification-bell__btn .icon[data-v-5181c19c]{color:var(--layout_black)}.notification-bell__btn[data-v-5181c19c]:focus-visible{outline:2px solid var(--layout_brand-2);outline-offset:-2px}.notification-bell__badge-count[data-v-5181c19c]{position:absolute;top:1px;left:20px;cursor:pointer;border:2px solid var(--layout_off-white);display:inline-flex;justify-content:center;align-items:center;min-width:20px;height:20px;padding-left:6px;padding-right:6px;color:#0d0d0d;border-radius:12px;font-size:12px;font-weight:400;box-sizing:border-box;background:#cf2f2d;color:var(--layout_off-white)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$3 = "data-v-5181c19c";
/* module identifier */

var __vue_module_identifier__$3 = undefined;
/* functional template */

var __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);

var hasWordOfLength = function hasWordOfLength(text, length) {
  var result = false;
  var splitText;

  if (text) {
    splitText = text.split(' ');

    for (var index = 0; index < splitText.length; index++) {
      if (splitText[index].length >= length) {
        result = true;
        break;
      }
    }
  }

  return result;
};

function getQueryParameter (queryString, key) {
  var obj = null;

  if (queryString && queryString.includes('?')) {
    queryString = queryString.split('?')[1];
    var params = new URLSearchParams(queryString);
    obj = params && params.get(key);
  }

  return obj;
}

var loggingMixin = {
  directives: {
    log: {
      inserted: function inserted(el, binding, vnode) {
        try {
          var component = vnode.context;

          if (binding.value) {
            if (binding.value.event) {
              if (vnode.componentInstance) {
                //a custom Vue.js component
                //it will emit it's data wit the event so pass it to the listener function
                //that will set it as eventData
                //but if the v-log declaration has eventData, it should override it
                vnode.componentInstance.$on(binding.value.event, function (e) {
                  var logData = getLogData(e);
                  component.logEvent(logData);
                });
              } else {
                //native DOM element
                //binding.value will have the eventData
                //that could be a value or function to call to get the value
                el.addEventListener(binding.value.event, function () {
                  var logData = getLogData();
                  component.logEvent(logData);
                });
              }
            }
          }

          var getLogData = function getLogData(emittedEventData) {
            var data = emittedEventData;
            var logData;

            if (binding.value.eventData) {
              if (typeof binding.value.eventData === 'function') {
                data = binding.value.eventData();
              } else {
                data = binding.value.eventData;
              }
            }

            logData = _objectSpread2(_objectSpread2({}, binding.value), {}, {
              eventData: data
            });
            return logData;
          };
        } catch (error) {
        }
      }
    }
  },
  methods: _objectSpread2(_objectSpread2({}, mapActions('logging', ['logEventAction'])), {}, {
    logEvent: function logEvent(e) {
      try {
        this.logEventAction({
          route: this.$route,
          data: e
        });
      } catch (error) {
      }
    }
  })
};

var script$4 = {
  name: 'VueNotificationCard',
  mixins: [loggingMixin],
  props: {
    notification: {
      type: Object,
      default: undefined
    }
  },
  data: function data() {
    return {
      alertLinks: undefined,
      accessWebUrl: this.VUE_APP_ACCESSWEB_URL
    };
  },
  mounted: function mounted() {
    var clickHandler; //Will return an empty array if none found....

    this.alertLinks = this.$el.querySelectorAll('[data-alertlinktype]');

    for (var index = 0; index < this.alertLinks.length; index++) {
      var link = this.linkProperties(this.alertLinks[index]);

      switch (link.type) {
        case 'BL':
          clickHandler = this.setOpenLinkInNewWindow;
          break;

        case 'LK':
          clickHandler = this.setOpenLinkInNewWindow;
          break;

        case 'CM':
          clickHandler = this.showCustomerMessage;
          break;

        case 'MG':
          clickHandler = this.showManagerApproval;
          break;

        case 'MP':
          clickHandler = this.showMultiPoint;
          break;

        case 'PRG':
          clickHandler = this.grabPartsRequest;
          break;

        case 'SP':
          clickHandler = this.showSideBySideProposal;
          break;

        case 'TC':
          clickHandler = this.showTeamChat;
          break;

        default:
          clickHandler = function clickHandler() {};

          break;
      }

      this.alertLinks[index].onclick = clickHandler;
    }
  },
  methods: _objectSpread2(_objectSpread2({}, mapActions('user', ['showNotificationModalAction', 'alertsShownAction'])), {}, {
    setOpenLinkInNewWindow: function setOpenLinkInNewWindow(e) {
      var labelElement = e.currentTarget;
      var alertLink = labelElement.getAttribute('data-alertLink');

      if (alertLink) {
        if (alertLink.includes('Parts/BackCounter')) this.showBackCounter(e);else {
          if (!alertLink.startsWith('http') && !alertLink.startsWith('/')) {
            alertLink = "/".concat(alertLink);
          }

          this.$emit('notificationClick');
          this.dismissAction();
          window.open(alertLink, '_blank');
        }
      }
    },
    showBackCounter: function showBackCounter(e) {
      var labelElement = e.currentTarget;
      var link = this.linkProperties(labelElement);
      var roId = labelElement.getAttribute('data-roid');
      var cid = labelElement.getAttribute('data-cid');
      var source = 'BackCounter';
      roId = roId || getQueryParameter(link.link, 'roId');
      cid = cid || getQueryParameter(link.link, 'cid');
      var model = {
        roid: roId,
        cid: cid,
        source: source
      };
      this.showModal(model, link);
    },
    showMultiPoint: function showMultiPoint(e) {
      var labelElement = e.currentTarget;
      var link = this.linkProperties(labelElement);
      var roId = labelElement.getAttribute('data-roid');
      var cid = labelElement.getAttribute('data-cid');
      var model = {
        roId: roId,
        cid: cid
      };
      this.showModal(model, link);
    },
    grabPartsRequest: function grabPartsRequest(e) {
      var labelElement = e.currentTarget;
      var link = this.linkProperties(labelElement);
      var roId = labelElement.getAttribute('data-roid');
      var cid = labelElement.getAttribute('data-cid');
      var model = {
        roId: roId,
        cid: cid
      };
      this.showModal(model, link);
    },
    showSideBySideProposal: function showSideBySideProposal(e) {
      var labelElement = e.currentTarget;
      var link = this.linkProperties(labelElement);
      var orgCid = labelElement.getAttribute('data-cid');
      var parentScenarioId = labelElement.getAttribute('data-scenarioid');
      var fromEmployeeId = labelElement.getAttribute('data-fromemployeeid');
      var model = {
        orgCid: orgCid,
        parentScenarioId: parentScenarioId,
        fromEmployeeId: fromEmployeeId
      };
      this.showModal(model, link);
    },
    showTeamChat: function showTeamChat(e) {
      var labelElement = e.currentTarget;
      var link = this.linkProperties(labelElement);
      var itemType = labelElement.getAttribute('data-itemtype');
      var itemId = labelElement.getAttribute('data-itemid');
      var itemCID = labelElement.getAttribute('data-itemcid');
      var model = {
        itemType: itemType,
        itemId: itemId,
        itemCID: itemCID
      };
      this.showModal(model, link);
    },
    showManagerApproval: function showManagerApproval(e) {
      var labelElement = e.currentTarget;
      var link = this.linkProperties(labelElement);
      var itemType = labelElement.getAttribute('data-itemdecision');
      var itemId = labelElement.getAttribute('data-itemid');
      var model = {
        itemId: itemId,
        itemType: itemType
      };
      this.showModal(model, link);
    },
    showCustomerMessage: function showCustomerMessage(e) {
      var labelElement = e.currentTarget;
      var link = this.linkProperties(labelElement);
      var itemType = labelElement.getAttribute('data-itemtype');
      var itemId = labelElement.getAttribute('data-itemid');
      var roNotifyReqsMet = labelElement.getAttribute('data-roNotifyReqsMet');
      var model = {
        itemType: itemType,
        itemId: itemId,
        RONotifyReqsMet: roNotifyReqsMet
      };
      this.showModal(model, link);
    },
    showModal: function showModal(model, link) {
      this.$emit('notificationClick');
      this.dismissAction();
      this.showNotificationModalAction({
        alertLinkType: link.type,
        args: model
      });
    },
    saveAction: function saveAction() {
      var notice = _objectSpread2(_objectSpread2({}, this.notification), {
        save: true
      });

      var params = {
        notification: notice,
        companyId: getCompanyId(this.$route)
      };
      this.$emit('saveClick', params);
    },
    dismissAction: function dismissAction() {
      var notice = _objectSpread2(_objectSpread2({}, this.notification), {
        save: false
      });

      var params = {
        notification: notice,
        companyId: getCompanyId(this.$route)
      };
      this.$emit('dismissClick', params);
    },
    closeAction: function closeAction() {
      var params = {
        notificationItems: [this.notification],
        companyId: getCompanyId(this.$route)
      };
      this.$emit('closeClick', params);
      this.alertsShownAction(params);
    },
    linkProperties: function linkProperties(element) {
      var linkType = element.getAttribute('data-alertlinktype');
      var alertLink = element.getAttribute('data-alertlink');
      return {
        type: linkType,
        link: alertLink
      };
    },
    formatDateTime: function formatDateTime(date) {
      return dateTimeString(date);
    }
  }),
  computed: _objectSpread2(_objectSpread2({}, mapGetters('user', ['vueAppSitePath', 'VUE_APP_ACCESSWEB_URL'])), {}, {
    parsedHtml: function parsedHtml() {
      var html = this.notification.alertHTML;

      if (html) {
        html = html.replace('*sitepath*', this.vueAppSitePath);
      }

      return html;
    },
    hasLongWord: function hasLongWord() {
      var text = this.notification.alertHTML;
      return hasWordOfLength(text, 38);
    },
    formatCreatedDate: function formatCreatedDate() {
      return this.formatDateTime(this.notification.datetimeStamp);
    },
    formatDismissedOn: function formatDismissedOn() {
      return this.formatDateTime(this.notification.dismissedOn);
    },
    notificationType: function notificationType() {
      switch (this.notification.alertType) {
        case 'I':
          return {
            class: 'info',
            icon: 'info'
          };

        case 'W':
          return {
            class: 'warning',
            icon: 'warning'
          };

        case 'S':
          return {
            class: 'success',
            icon: 'complete'
          };

        case 'E':
          return {
            class: 'error',
            icon: 'warning-01'
          };

        case 'T':
          return {
            class: 'time',
            icon: 'start_time'
          };

        default:
          return {
            class: 'mail',
            icon: 'mail'
          };
      }
    }
  })
};

/* script */
var __vue_script__$4 = script$4;
/* template */

var __vue_render__$4 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('li', {
    staticClass: "notification-card",
    class: 'notification-card--' + _vm.notificationType.class,
    attrs: {
      "id": 'notification-' + _vm.notification.id,
      "data-id": "notification-card-item"
    }
  }, [_c('span', {
    staticClass: "notification-card__type"
  }, [_c('i', {
    class: 'icon icon-' + _vm.notificationType.icon
  })]), _vm._v(" "), !_vm.notification.shown ? _c('span', {
    staticClass: "notification-card__close"
  }, [_c('button', {
    staticClass: "notification-card__close-btn",
    attrs: {
      "data-id": "notification-close-button"
    },
    on: {
      "click": _vm.closeAction
    }
  }, [_c('i', {
    staticClass: "icon icon-remove"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "notification-card__content",
    class: ['notification-card__content', _vm.hasLongWord && 'include-long-word'],
    attrs: {
      "data-id": "notification-content"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.parsedHtml)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "notification-card__date"
  }, [_c('span', {
    staticClass: "notification-card__created-date",
    attrs: {
      "data-id": "notification-created-date"
    }
  }, [_vm._v("\n\t\t\tCreated on: " + _vm._s(_vm.formatDateTime(_vm.notification.datetimeStamp)) + "\n\t\t")]), _vm._v(" "), _vm.notification.dismissed && _vm.notification.dismissedOn ? _c('span', {
    staticClass: "notification-card__dismissed-date",
    attrs: {
      "data-id": "notification-dismissed-date"
    }
  }, [_vm._v("\n\t\t\tDismissed on: " + _vm._s(_vm.formatDateTime(_vm.notification.dismissedOn)) + "\n\t\t")]) : _vm._e()]), _vm._v(" "), !_vm.notification.dismissed ? _c('div', {
    staticClass: "notification-card__actions"
  }, [_c('a', {
    staticClass: "notification-card__save-btn",
    attrs: {
      "data-id": "notification-save-button"
    },
    on: {
      "click": _vm.saveAction
    }
  }, [_vm._v("\n\t\t\tSave & Dismiss\n\t\t")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "log",
      rawName: "v-log",
      value: {
        target: 'Dismiss Notification Link',
        event: 'click',
        eventData: _vm.notification
      },
      expression: "{\n\t\t\t\ttarget: 'Dismiss Notification Link',\n\t\t\t\tevent: 'click',\n\t\t\t\teventData: notification\n\t\t\t}"
    }],
    staticClass: "notification-card__dismiss-btn",
    attrs: {
      "data-id": "notification-dismiss-button"
    },
    on: {
      "click": _vm.dismissAction
    }
  }, [_vm._v("\n\t\t\tDismiss\n\t\t")])]) : _vm._e()]);
};

var __vue_staticRenderFns__$4 = [];
/* style */

var __vue_inject_styles__$4 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-402b7c98_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);:export{menubreakpoint:992}:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light],body.light{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}.notification-card{display:grid;grid-template-columns:auto 6fr 16px;gap:8px;padding:8px;color:#f9f9f9;border-radius:4px;font-size:12px}.notification-card--info{background:#5bc0de}.notification-card--warning{background:#ef9855}.notification-card--success{background:#5cb85c}.notification-card--error{background:#cf2f2d}.notification-card--mail{background:#3f33f5}.notification-card--time{background:#585554}.notification-card:not(:last-child){margin-bottom:12px}.notification-card__type{grid-column:1/2;grid-row:1/3;justify-self:center;padding-top:2px;font-size:18px}.notification-card__close{grid-column:3/3;grid-row:1/3;font-size:11pt;margin-top:-2px}.notification-card__close-btn{margin-top:2px;min-width:66px;user-select:none;cursor:pointer;font-size:inherit;white-space:nowrap;border:none;outline:0;background-color:transparent;color:inherit;padding:0;min-width:16px}@media (min-width:75em){.notification-card__close-btn{min-width:58px}}@media (min-width:62em){.notification-card__close-btn{min-width:16px}}.notification-card__close-btn>.icon{font-size:12px}.notification-card__content{grid-column:2/3;grid-row:1/2}.notification-card__content>:first-child{display:block}.notification-card__content>h4,.notification-card__content>h5{font-size:14px;margin:0 0 8px 0;letter-spacing:.5px}.notification-card__content .anchorLink,.notification-card__content .jqx-link,.notification-card__content .vue-link,.notification-card__content a{margin-right:4px;line-height:18px;cursor:pointer;border-bottom:1px solid #f9f9f9}.notification-card__content .anchorLink:hover,.notification-card__content .jqx-link:hover,.notification-card__content .vue-link:hover,.notification-card__content a:hover{border-bottom:1px solid transparent}.notification-card__content .anchorLink:focus,.notification-card__content .anchorLink:focus-visible,.notification-card__content .jqx-link:focus,.notification-card__content .jqx-link:focus-visible,.notification-card__content .vue-link:focus,.notification-card__content .vue-link:focus-visible,.notification-card__content a:focus,.notification-card__content a:focus-visible{outline:0}.notification-card__content .anchorLink{display:inline-block}.notification-card__content label{display:inline}.notification-card__content label.block+.block{margin-left:4px}.notification-card__content label.white-bold-jqx-link{display:inline-block;margin:8px 4px 0 0;line-height:18px;font-weight:700;text-align:center;border-bottom:1px solid #f9f9f9;cursor:pointer}.notification-card__content label.white-bold-jqx-link:hover{border-bottom:1px solid transparent}.notification-card__content label.white-bold-jqx-link:focus,.notification-card__content label.white-bold-jqx-link:focus-visible{outline:0}.notification-card__content.include-long-word{word-break:keep-all}.notification-card__date{grid-column:2/3;grid-row:2/3;font-size:11px;margin-top:4px;display:flex;flex-direction:column;gap:4px}.notification-card__actions{grid-column:2/3;grid-row:3/4;display:flex;justify-content:space-between;gap:24px;margin-top:12px}.notification-card__actions>*{border-bottom:1px solid #f9f9f9;cursor:pointer}.notification-card__actions>:focus,.notification-card__actions>:hover{border-color:transparent}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$4 = undefined;
/* module identifier */

var __vue_module_identifier__$4 = undefined;
/* functional template */

var __vue_is_functional_template__$4 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, createInjector, undefined, undefined);

var script$5 = {
  name: 'VueNotificationList',
  components: {
    VueNotificationCard: __vue_component__$4
  },
  data: function data() {
    return {};
  },
  mixins: [propsMixin],
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: {},
  methods: {
    onNotificationClick: function onNotificationClick() {
      this.$emit('notificationClick');
    },
    onDismissClick: function onDismissClick(params) {
      this.$emit('dismissClick', params);
    },
    onSaveClick: function onSaveClick(params) {
      this.$emit('saveClick', params);
    }
  }
};

/* script */
var __vue_script__$5 = script$5;
/* template */

var __vue_render__$5 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ul', {
    staticClass: "notification-list"
  }, _vm._l(_vm.items, function (notification) {
    return _c('VueNotificationCard', {
      key: notification.id,
      attrs: {
        "notification": notification
      },
      on: {
        "notificationClick": _vm.onNotificationClick,
        "dismissClick": _vm.onDismissClick,
        "saveClick": _vm.onSaveClick
      }
    });
  }), 1);
};

var __vue_staticRenderFns__$5 = [];
/* style */

var __vue_inject_styles__$5 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-188bb1fb_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-188bb1fb]:export{menubreakpoint:992}[data-v-188bb1fb]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-188bb1fb]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-188bb1fb],body.light[data-v-188bb1fb]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$5 = "data-v-188bb1fb";
/* module identifier */

var __vue_module_identifier__$5 = undefined;
/* functional template */

var __vue_is_functional_template__$5 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
var script$6 = {
  name: 'IframeContainer',
  props: {
    source: {
      type: String,
      default: ''
    },
    sandbox: {
      type: Array,
      default: function _default() {
        return ['allow-forms', 'allow-modals', 'allow-popups', 'allow-scripts', 'allow-top-navigation', 'allow-same-origin', 'allow-top-navigation'];
      }
    }
  },
  created: function created() {//this.$refs.frame.onload = this.onFrameLoad;
  },
  mounted: function mounted() {
    document.body.appendChild(this.$el);
    this.$refs.frame.onload = this.onFrameLoad;
    this.$refs.frame.onerror = this.onFrameError;
  },
  computed: {
    sandboxVals: function sandboxVals() {
      var vals = '';

      if (this.sandbox) {
        vals = this.sandbox.join(' ');
      }

      return vals;
    }
  },
  methods: {
    onFrameError: function onFrameError(e) {
      console.log('onFrameError');
      console.log(e);
    },
    onFrameLoad: function onFrameLoad(e) {
      console.log('onFrameLoad');
      console.log(e);
    }
  }
};

/* script */
var __vue_script__$6 = script$6;
/* template */

var __vue_render__$6 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "iframe-container"
  }, [_c('iframe', {
    ref: "frame",
    staticClass: "iframe-container__iframe",
    attrs: {
      "src": _vm.source,
      "scrolling": "no",
      "frameborder": "0",
      "sandbox": _vm.sandboxVals
    }
  })]);
};

var __vue_staticRenderFns__$6 = [];
/* style */

var __vue_inject_styles__$6 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-59fec4ba_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-59fec4ba]:export{menubreakpoint:992}[data-v-59fec4ba]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-59fec4ba]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-59fec4ba],body.light[data-v-59fec4ba]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}.iframe-container[data-v-59fec4ba]{z-index:14000;position:fixed;left:0;top:0}.iframe-container__iframe[data-v-59fec4ba]{width:100vw;height:100vh;border:none;overflow:hidden;margin:0}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$6 = "data-v-59fec4ba";
/* module identifier */

var __vue_module_identifier__$6 = undefined;
/* functional template */

var __vue_is_functional_template__$6 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$7 = {
  name: 'Tabs',
  data: function data() {
    return {
      selectedTabData: this.selectedTab
    };
  },
  props: {
    tabCount: {
      type: Number,
      required: true
    },
    selectedTab: {
      type: Number,
      default: 0
    },
    tabSlotNamePrefix: {
      type: String,
      default: 'tab'
    },
    contentMaxHeight: {
      type: String,
      default: 'auto'
    }
  },
  methods: {
    onTabClick: function onTabClick(tabIndex) {
      this.selectedTabData = tabIndex;
    }
  }
};

/* script */
var __vue_script__$7 = script$7;
/* template */

var __vue_render__$7 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "tabs"
  }, [_c('ul', {
    staticClass: "tabs__header-items"
  }, _vm._l(_vm.tabCount, function (index) {
    return _c('li', {
      key: 'title' + index,
      class: ['tabs__header-item', _vm.selectedTabData === index && 'is-active'],
      attrs: {
        "tabindex": "0"
      },
      on: {
        "click": function click($event) {
          return _vm.onTabClick(index);
        }
      }
    }, [_c('span', {
      staticClass: "tabs__header"
    }, [_vm._t('title' + index, [_vm._v("Title " + _vm._s(index))])], 2)]);
  }), 0), _vm._v(" "), _c('ul', {
    staticClass: "tabs__content-items",
    style: {
      maxHeight: _vm.contentMaxHeight
    }
  }, _vm._l(_vm.tabCount, function (index) {
    return _c('li', {
      key: 'tab' + index,
      staticClass: "tabs__content-item"
    }, [_vm.selectedTabData === index ? _c('div', {
      staticClass: "tabs__content"
    }, [_vm._t('tab' + index, [_vm._v("Tab " + _vm._s(index) + " content")])], 2) : _vm._e()]);
  }), 0)]);
};

var __vue_staticRenderFns__$7 = [];
/* style */

var __vue_inject_styles__$7 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-691081b2_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-691081b2]:export{menubreakpoint:992}[data-v-691081b2]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-691081b2]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-691081b2],body.light[data-v-691081b2]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}[data-v-691081b2]::-webkit-scrollbar{width:14px;background-color:var(--bg-0)}[data-v-691081b2]::-webkit-scrollbar-track{box-shadow:inset 0 0 2px rgba(0,0,0,.2);background-color:var(--bg-0)}[data-v-691081b2]::-webkit-scrollbar-thumb{background-color:var(--bg-0-fg-1);border-radius:14px;border:3px solid transparent;background-clip:content-box;min-height:16px}[data-v-691081b2]::-webkit-scrollbar{width:14px;background-color:transparent}[data-v-691081b2]::-webkit-scrollbar-track{border-top:1px solid transparent;box-shadow:none;background-color:transparent}[data-v-691081b2]::-webkit-scrollbar-thumb{background-color:var(--bg-0-fg-1);border-radius:14px;border:3px solid transparent;background-clip:content-box}.tabs[data-v-691081b2]{font-size:14px}.tabs__header-items[data-v-691081b2]{display:flex;align-items:flex-end;position:relative;border-bottom:1px solid var(--layout_bg-0-fg-1);margin-bottom:12px;gap:2px}.tabs__header-item[data-v-691081b2]{display:flex;align-items:center;flex-direction:column-reverse;justify-content:flex-end;cursor:pointer;border:1px solid transparent;border-top-width:0;border-top-left-radius:4px;border-top-right-radius:4px;margin-bottom:-1px}.tabs__header-item.is-active[data-v-691081b2]{border-left-color:var(--layout_bg-0-fg-1);border-right-color:var(--layout_bg-0-fg-1);background:var(--layout_bg-0);color:var(--layout_bg-0-fg-4)}.tabs__header-item.is-active[data-v-691081b2]::after{content:\"\";height:4px;width:calc(100% + 2px);border-top-left-radius:4px;border-top-right-radius:4px;background:var(--layout_brand-2)}.tabs__header-item[data-v-691081b2]:not(.is-active):focus,.tabs__header-item[data-v-691081b2]:not(.is-active):hover{background:var(--layout_brand-2-tint);color:var(--layout_bg-brand-2-tint-fg-2)}.tabs__header[data-v-691081b2]{padding:8px 16px}.tabs__content-items[data-v-691081b2]{padding:0 4px;overflow-x:hidden}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$7 = "data-v-691081b2";
/* module identifier */

var __vue_module_identifier__$7 = undefined;
/* functional template */

var __vue_is_functional_template__$7 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, createInjector, undefined, undefined);

var EmptyLLImg = {
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 429 259"
      }
    }, [_c('g', {
      attrs: {
        "data-name": "empty-LL"
      }
    }, [_c('circle', {
      attrs: {
        "data-name": "Ellipse 1",
        "cx": "70.5",
        "cy": "70.5",
        "r": "70.5",
        "transform": "translate(283 113)",
        "fill": "#fff"
      }
    }), _c('path', {
      attrs: {
        "data-name": "Path 1",
        "d": "M353.5 259a75.5 75.5 0 1175.5-75.5 75.5 75.5 0 01-75.5 75.5zm0-141a65.5 65.5 0 1065.5 65.5 65.5 65.5 0 00-65.5-65.5z"
      }
    }), _c('path', {
      attrs: {
        "data-name": "Path 2",
        "d": "M348.77 239.84h-.2a58 58 0 01-8.42-1.28 2.503 2.503 0 111.12-4.88 51.989 51.989 0 007.68 1.17 2.502 2.502 0 01-.18 5zm16.19-1.16a2.51 2.51 0 01-.55-4.95 53.472 53.472 0 007.43-2.26 2.501 2.501 0 111.82 4.66 56.707 56.707 0 01-8.15 2.48 2.13 2.13 0 01-.51.07zm-39.34-6a2.509 2.509 0 01-1.26-.34 57.461 57.461 0 01-7-4.82 2.5 2.5 0 113.13-3.89 52.609 52.609 0 006.4 4.4 2.5 2.5 0 01.9 3.42 2.47 2.47 0 01-2.17 1.18zm61.22-4.4a2.5 2.5 0 01-1.55-4.46 51.742 51.742 0 005.71-5.27 2.5 2.5 0 113.65 3.41 57.956 57.956 0 01-6.26 5.77 2.47 2.47 0 01-1.55.5zm-78.95-12.13a2.49 2.49 0 01-2.07-1.09 58.8 58.8 0 01-4.25-7.38 2.5 2.5 0 114.5-2.16 52.51 52.51 0 003.88 6.74 2.49 2.49 0 01-.66 3.47 2.52 2.52 0 01-1.4.37zm94.14-6.77a2.49 2.49 0 01-2.24-3.59 51.664 51.664 0 002.87-7.22 2.5 2.5 0 114.77 1.49 56.708 56.708 0 01-3.14 7.92 2.55 2.55 0 01-2.29 1.35zm-103-15.82a2.49 2.49 0 01-2.47-2.13A56.994 56.994 0 01296 183a2.54 2.54 0 012.5-2.55 2.45 2.45 0 012.5 2.45v.17a52.37 52.37 0 00.56 7.58 2.5 2.5 0 01-2.11 2.84zm108.42-7.79a2.5 2.5 0 01-2.5-2.5V183a52.765 52.765 0 00-.57-7.75 2.5 2.5 0 014.94-.74A57.264 57.264 0 01410 183v.22a2.5 2.5 0 01-2.5 2.5zm-106.56-16.38a2.711 2.711 0 01-.74-.11 2.5 2.5 0 01-1.65-3.13 56.676 56.676 0 013.13-7.92 2.5 2.5 0 014.5 2.18 51.327 51.327 0 00-2.85 7.22 2.52 2.52 0 01-2.34 1.71zm101.18-7.47a2.49 2.49 0 01-2.25-1.42 51.808 51.808 0 00-3.89-6.73 2.5 2.5 0 114.13-2.81 56.285 56.285 0 014.26 7.38 2.5 2.5 0 01-1.17 3.34 2.54 2.54 0 01-1.03.19zm-89-13.5a2.49 2.49 0 01-1.82-4.2 56 56 0 016.25-5.78 2.5 2.5 0 113.11 3.91 51.728 51.728 0 00-5.7 5.28 2.55 2.55 0 01-1.81.74zm73.9-5.46a2.48 2.48 0 01-1.56-.55A53.806 53.806 0 00379 138a2.502 2.502 0 112.51-4.33 57.842 57.842 0 017 4.81 2.51 2.51 0 01-1.57 4.46zm-53.86-8.18a2.5 2.5 0 01-.91-4.83 56.405 56.405 0 018.15-2.5 2.501 2.501 0 011.1 4.88 52.225 52.225 0 00-7.43 2.28 2.582 2.582 0 01-.88.12zm32-2.36a2.742 2.742 0 01-.56-.06 53.5 53.5 0 00-7.68-1.16 2.507 2.507 0 11.37-5 56.649 56.649 0 018.42 1.27 2.5 2.5 0 01-.55 4.94z",
        "fill": "#e4e7e5"
      }
    }), _c('circle', {
      attrs: {
        "data-name": "Ellipse 2",
        "cx": "70.5",
        "cy": "70.5",
        "r": "70.5",
        "transform": "translate(5 112)",
        "fill": "#fff"
      }
    }), _c('path', {
      attrs: {
        "data-name": "Path 3",
        "d": "M75.5 258a75.5 75.5 0 1175.5-75.5A75.5 75.5 0 0175.5 258zm0-141a65.5 65.5 0 1065.5 65.5A65.5 65.5 0 0075.5 117z"
      }
    }), _c('circle', {
      attrs: {
        "data-name": "Ellipse 3",
        "cx": "105.75",
        "cy": "105.75",
        "r": "105.75",
        "transform": "translate(106 5)",
        "fill": "#fff"
      }
    }), _c('path', {
      attrs: {
        "data-name": "Path 4",
        "d": "M211.75 221.5A110.75 110.75 0 11322.5 110.75 110.75 110.75 0 01211.75 221.5zm0-211.5A100.75 100.75 0 10312.5 110.75 100.75 100.75 0 00211.75 10z"
      }
    }), _c('path', {
      attrs: {
        "data-name": "Path 5",
        "d": "M80.31 244.21L79 228.27c1.12-.09 2.25-.23 3.36-.42l2.57 15.79q-2.34.375-4.62.57zM49 238.47c-1.38-.67-2.75-1.39-4.07-2.15l8-13.85c1 .56 2 1.1 3 1.58zm64.93-8.1l-10.26-12.28c.86-.72 1.71-1.48 2.52-2.27l11.16 11.47c-1.15 1.06-2.3 2.1-3.47 3.08zm-91.41-16.73c-.75-1.34-1.46-2.72-2.11-4.09l14.49-6.78c.47 1 1 2 1.55 3zm111-13.85L118 195.62c.29-1.08.55-2.19.76-3.3l15.72 3c-.26 1.49-.61 3-1.01 4.47zM30.91 179.66L15 178.11c.15-1.52.36-3.06.62-4.56l15.76 2.75a31.936 31.936 0 00-.47 3.36zm10.44-24.54L29.2 144.7c1-1.16 2-2.3 3.12-3.38l11.33 11.3c-.79.8-1.57 1.64-2.3 2.5zm52.43-11.48c-1-.47-2.07-.91-3.13-1.3l5.59-15c1.44.54 2.87 1.13 4.25 1.77zM64 141l-4-15.49c1.49-.38 3-.71 4.5-1l2.81 15.75A23.6 23.6 0 0064 141z",
        "fill": "#e4e7e5"
      }
    }), _c('path', {
      attrs: {
        "data-name": "Path 6",
        "d": "M131.05 101.71L115.29 99c.24-1.39.52-2.79.82-4.16l15.62 3.45c-.24 1.1-.47 2.27-.68 3.42zm160.37-.11v-.2c-.21-1.17-.44-2.34-.7-3.48l15.62-3.49c.31 1.37.59 2.77.84 4.16v.11zM142.53 72.12L129 63.54c.75-1.19 1.55-2.38 2.35-3.54l13.12 9.16c-.65.97-1.31 1.96-1.94 2.96zm137.31-.29c-.64-1-1.3-2-2-3l13.08-9.21c.81 1.16 1.61 2.34 2.37 3.53zm-115.4-22.71L155.23 36c1.16-.81 2.35-1.61 3.53-2.37l8.62 13.48c-.98.66-1.97 1.33-2.94 2.01zm93.36-.17c-1-.67-2-1.33-3-2l8.58-13.51c1.19.76 2.38 1.55 3.53 2.35zM193.49 36.3L190 20.68c1.36-.3 2.74-.58 4.12-.83h.19l1 6.65 1.69 9.11h-.09c-1.12.2-2.29.39-3.42.69zm35.22-.1a84.95 84.95 0 00-3.47-.68L228 19.76c1.38.24 2.78.52 4.16.82z",
        "fill": "#a7afab"
      }
    }), _c('path', {
      attrs: {
        "data-name": "Path 7",
        "d": "M147.87 157.1h-13.56v-22.84h13.56v5h-7.39v3.59h6.84v5h-6.84v4.31h7.39z",
        "fill": "#8cc63f"
      }
    }), _c('path', {
      attrs: {
        "data-name": "Path 8",
        "d": "M287.15 155h-6.08v-22.82h13.5v5h-7.42v4.36H294v5h-6.84z",
        "fill": "#009245"
      }
    }), _c('path', {
      attrs: {
        "data-name": "Path 9",
        "d": "M222 109.35a7 7 0 00-10.35-6.15 7.008 7.008 0 00-1 .67l-52.07 34.93.82 1.42 58.22-24.39.22-.09h.07a7 7 0 004.09-6.39z"
      }
    }), _c('g', {
      attrs: {
        "data-name": "V Support - transparent"
      }
    }, [_c('g', {
      attrs: {
        "data-name": "V Support - transparent-2"
      }
    }, [_c('g', {
      attrs: {
        "data-name": "V - Transparent"
      }
    }, [_c('path', {
      attrs: {
        "data-name": "Path 16595",
        "d": "M211.86 187.68l13.25-24.55-10.51-5.51-2.75 5.47-2.71-5.47-10.5 5.51z",
        "fill": "#296f0f"
      }
    }), _c('path', {
      attrs: {
        "data-name": "Path 16596",
        "d": "M209.16 157.62l-1.35-2.73-18-7.41 8.88 15.65z",
        "fill": "#8cc63f"
      }
    }), _c('path', {
      attrs: {
        "data-name": "Path 16597",
        "d": "M214.61 157.62l1.35-2.73 18-7.41-8.88 15.65z",
        "fill": "#009245"
      }
    })])])])])]);
  }
};

//
var script$8 = {
  name: 'VueNotificationEmptyListMessage',
  components: {
    EmptyLLImg: EmptyLLImg
  },
  props: {
    labelText: {
      type: String,
      default: ''
    }
  }
};

/* script */
var __vue_script__$8 = script$8;
/* template */

var __vue_render__$8 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "empty-list-message"
  }, [_c('EmptyLLImg', {
    staticClass: "empty-list-message__img"
  }), _vm._v(" "), _c('div', {
    staticClass: "empty-list-message__text"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.labelText) + "\n\t")])], 1);
};

var __vue_staticRenderFns__$8 = [];
/* style */

var __vue_inject_styles__$8 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-2a4d61b6_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-2a4d61b6]:export{menubreakpoint:992}[data-v-2a4d61b6]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-2a4d61b6]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-2a4d61b6],body.light[data-v-2a4d61b6]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}.empty-list-message[data-v-2a4d61b6]{display:flex;flex-direction:column;align-items:center;margin:92px 0;padding:8px;background:var(--layout_bg-0);color:var(--layout_bg-0-fg-4)}.empty-list-message__img[data-v-2a4d61b6]{max-width:175px;margin-bottom:24px}.empty-list-message__text[data-v-2a4d61b6]{font-weight:700;font-size:14px;line-height:22px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$8 = "data-v-2a4d61b6";
/* module identifier */

var __vue_module_identifier__$8 = undefined;
/* functional template */

var __vue_is_functional_template__$8 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, createInjector, undefined, undefined);

var script$9 = {
  name: 'VueNotifications',
  components: {
    VueNotificationBell: __vue_component__$3,
    IframeContainer: __vue_component__$6,
    VueNotificationList: __vue_component__$5,
    Tabs: __vue_component__$7,
    InfiniteScroller: InfiniteScroller,
    VueNotificationEmptyListMessage: __vue_component__$8
  },
  data: function data() {
    return {
      itemsVisible: false,
      loadingItems: false,
      response: {
        totalCount: 0
      },
      modalWidth: 'auto',
      modalHeight: 'auto',
      selectedTab: 1,
      activePage: 1,
      dismissedPage: 1,
      activeLoading: false,
      dismissedLoading: false,
      scrollElement: undefined
    };
  },
  mixins: [propsMixin],
  props: {
    activePageSize: {
      type: Number,
      default: 10
    },
    dismissedPageSize: {
      type: Number,
      default: 10
    }
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              document.addEventListener('mouseup', _this.globalMouseUpHandler.bind(_this));

              _this.getActiveNotifications(_this.activePage);

              _this.getDismissedNotifications(_this.dismissedPage);

              window.addEventListener('message', _this.onMessage);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('message', this.onMessage);
  },
  computed: _objectSpread2(_objectSpread2({}, mapGetters('user', ['notificationModalVisible', 'activeNotificationItems', 'dismissedNotificationItems', 'activeNotificationCount', 'dismissedNotificationCount', 'activeNotificationPageCount', 'dismissedNotificationPageCount', 'iframeSource'])), {}, {
    notificationManagerLink: function notificationManagerLink() {
      return "/System/NotificationManager?cid=".concat(getCompanyId(this.$route));
    },
    activeCount: function activeCount() {
      return this.activeNotificationCount;
    },
    dismissedCount: function dismissedCount() {
      return this.dismissedNotificationCount;
    },
    hasMoreActiveResults: function hasMoreActiveResults() {
      var result = false;
      result = this.activeNotificationItems.length < this.activeCount;
      return result;
    },
    hasMoreDismissedResults: function hasMoreDismissedResults() {
      var result = false;
      result = this.dismissedNotificationItems.length < this.dismissedCount;
      return result;
    }
  }),
  methods: _objectSpread2(_objectSpread2({}, mapActions('user', ['hideNotificationModalAction', 'getActiveNotificationsAction', 'getDismissedNotificationsAction', 'dismissNotificationAction'])), {}, {
    getActiveNotifications: function getActiveNotifications(page) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                page = page || 1;
                _this2.activeLoading = true;
                _context2.next = 4;
                return _this2.getActiveNotificationsAction({
                  companyId: getCompanyId(_this2.$route),
                  page: page,
                  pageSize: _this2.activePageSize
                });

              case 4:
                _this2.activeLoading = false;

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getDismissedNotifications: function getDismissedNotifications(page) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                page = page || 1;
                _this3.dismissedLoading = true;
                _context3.next = 4;
                return _this3.getDismissedNotificationsAction({
                  companyId: getCompanyId(_this3.$route),
                  page: page,
                  pageSize: _this3.dismissedPageSize
                });

              case 4:
                _this3.dismissedLoading = false;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },

    /**
     * Toggles visibility
     */
    toggleShowItemsWrapper: function toggleShowItemsWrapper() {
      this.itemsVisible = !this.itemsVisible;
    },

    /**
     * Make sure clicking outside the notification area
     * will hide notifications dropdown
     */
    globalMouseUpHandler: function globalMouseUpHandler(e) {
      var container = document.getElementById('headerNotifications');

      if (e && !container.contains(e.target) && this.itemsVisible) {
        this.toggleShowItemsWrapper();
      }
    },
    onScrollBoundaryActive: function onScrollBoundaryActive() {
      if (this.activePage + 1 <= this.activeNotificationPageCount) {
        this.activePage += 1;
        this.getActiveNotifications(this.activePage);
      }
    },
    onScrollBoundaryDismissed: function onScrollBoundaryDismissed() {
      if (this.dismissedPage + 1 <= this.dismissedNotificationPageCount) {
        this.dismissedPage += 1;
        this.getDismissedNotifications(this.dismissedPage);
      }
    },
    onCloseModal: function onCloseModal() {
      this.hideNotificationModalAction();
    },
    onMessage: function onMessage(e) {
      if (e && e.data.source === 'AccessToVue' && e.data.data === 'vue.closeNotificationModal') {
        console.log('vue-ui onMessage');
        console.log(e);
        this.onCloseModal();
      }
    },
    onNotificationClick: function onNotificationClick() {
      this.itemsVisible = false;
    },
    onNotificationDismissed: function onNotificationDismissed(params) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var i;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this4.dismissNotificationAction(params);

              case 2:
                if (!(_this4.activeNotificationPageCount > 1 && _this4.activePage + 1 <= _this4.activeNotificationPageCount)) {
                  _context4.next = 10;
                  break;
                }

                i = _this4.activePage + 1;

              case 4:
                if (!(i > 0)) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 7;
                return _this4.getActiveNotifications(i);

              case 7:
                i--;
                _context4.next = 4;
                break;

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  })
};

/* script */
var __vue_script__$9 = script$9;
/* template */

var __vue_render__$9 = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "notification",
    class: _vm.itemsVisible && 'is-open',
    attrs: {
      "id": "headerNotifications"
    }
  }, [_c('VueNotificationBell', {
    attrs: {
      "counter": _vm.activeCount,
      "hasDisplayLimit": true,
      "isOpen": _vm.itemsVisible
    },
    on: {
      "bellClicked": _vm.toggleShowItemsWrapper
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.itemsVisible && !_vm.notificationModalVisible,
      expression: "itemsVisible && !notificationModalVisible"
    }],
    staticClass: "notification__list"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loadingItems,
      expression: "loadingItems"
    }],
    staticClass: "notification__loading"
  }, [_vm._m(0)]), _vm._v(" "), _c('h3', {
    staticClass: "notification__header"
  }, [_vm._v("\n\t\t\tManage Notifications\n\t\t")]), _vm._v(" "), _c('Tabs', {
    attrs: {
      "tabCount": 2,
      "selectedTab": _vm.selectedTab,
      "contentMaxHeight": "586px"
    },
    scopedSlots: _vm._u([{
      key: "title1",
      fn: function fn() {
        return [_vm._v("Active (" + _vm._s(_vm.activeCount) + ")")];
      },
      proxy: true
    }, {
      key: "title2",
      fn: function fn() {
        return [_vm._v("\n\t\t\t\tDismissed (" + _vm._s(_vm.dismissedCount) + ")\n\t\t\t")];
      },
      proxy: true
    }, {
      key: "tab1",
      fn: function fn() {
        return [_vm.activeNotificationItems.length === 0 ? _c('VueNotificationEmptyListMessage', {
          attrs: {
            "labelText": "You have no active notifications."
          }
        }) : _vm._e(), _vm._v(" "), _vm.activeNotificationItems.length > 0 ? _c('InfiniteScroller', {
          staticClass: "notification__infinity-scroll",
          attrs: {
            "loading": _vm.activeLoading,
            "hasMoreResults": _vm.hasMoreActiveResults
          },
          on: {
            "scrollBoundary": _vm.onScrollBoundaryActive
          },
          scopedSlots: _vm._u([{
            key: "scrollDiv",
            fn: function fn() {
              return [_c('VueNotificationList', {
                attrs: {
                  "items": _vm.activeNotificationItems
                },
                on: {
                  "notificationClick": _vm.onNotificationClick,
                  "dismissClick": _vm.onNotificationDismissed,
                  "saveClick": _vm.onNotificationDismissed
                }
              })];
            },
            proxy: true
          }], null, false, 2536609579)
        }) : _vm._e()];
      },
      proxy: true
    }, {
      key: "tab2",
      fn: function fn() {
        return [_vm.dismissedNotificationItems.length === 0 ? _c('VueNotificationEmptyListMessage', {
          attrs: {
            "labelText": "You have no dismissed notifications."
          }
        }) : _vm._e(), _vm._v(" "), _vm.dismissedNotificationItems.length > 0 ? _c('InfiniteScroller', {
          staticClass: "notification__infinity-scroll",
          attrs: {
            "loading": _vm.dismissedLoading,
            "hasMoreResults": _vm.hasMoreDismissedResults
          },
          on: {
            "scrollBoundary": _vm.onScrollBoundaryDismissed
          },
          scopedSlots: _vm._u([{
            key: "scrollDiv",
            fn: function fn() {
              return [_c('VueNotificationList', {
                attrs: {
                  "items": _vm.dismissedNotificationItems
                },
                on: {
                  "notificationClick": _vm.onNotificationClick
                }
              })];
            },
            proxy: true
          }], null, false, 1469055079)
        }) : _vm._e()];
      },
      proxy: true
    }])
  })], 1), _vm._v(" "), _vm.notificationModalVisible ? _c('IframeContainer', {
    attrs: {
      "source": _vm.iframeSource
    }
  }) : _vm._e()], 1);
};

var __vue_staticRenderFns__$9 = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('i', {
    staticClass: "icon icon-loading"
  }, [_c('span', {
    staticClass: "path1"
  }), _c('span', {
    staticClass: "path2"
  })]);
}];
/* style */

var __vue_inject_styles__$9 = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-9cc3e83a_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-9cc3e83a]:export{menubreakpoint:992}[data-v-9cc3e83a]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-9cc3e83a]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-9cc3e83a],body.light[data-v-9cc3e83a]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}.notification[data-v-9cc3e83a]{position:relative;display:flex;height:100%;width:42px}@media (min-width:62em){.notification[data-v-9cc3e83a]:focus,.notification[data-v-9cc3e83a]:hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_bg-2-fg-3);cursor:pointer}}.notification .is-active[data-v-9cc3e83a]{background:var(--layout_menu-list-bg-active);color:var(--layout_menu-list-fg-active);cursor:default}@media (min-width:36em){.notification[data-v-9cc3e83a]{position:relative}}.notification>*[data-v-9cc3e83a]{font-size:14px}.notification.is-open[data-v-9cc3e83a]{background:var(--layout_menu-list-bg-active);color:var(--layout_menu-list-fg-active)}@media (max-width:35.99em){.notification.is-open[data-v-9cc3e83a]{background:var(--layout_bg-brand-1)}.notification.is-open .notification-bell__icon[data-v-9cc3e83a]{color:var(--layout_bg-brand-1-fg-3)}}.notification.is-open .notification-bell__expand-icon[data-v-9cc3e83a]{transform:scaleY(-1)}.notification__btn[data-v-9cc3e83a]{display:flex;position:relative;align-items:center;width:42px;padding:0 8px;border:none;background:0 0;color:inherit;cursor:pointer}@media (min-width:62em){.notification__btn[data-v-9cc3e83a]{width:100%}}.notification__btn[data-v-9cc3e83a]:focus{outline:0}.notification__name[data-v-9cc3e83a]{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}@media (max-width:61.99em){.notification__name[data-v-9cc3e83a]{display:none}}@media (max-width:61.99em){.notification__number[data-v-9cc3e83a]{display:none}}.notification__menu[data-v-9cc3e83a]{max-width:220px;position:absolute;top:100%;right:0;min-width:100%;width:max-content;background:var(--layout_menu-list-bg);color:var(--layout_menu-list-fg);border-top:1px solid var(--layout_menu-list-border);z-index:2000;height:calc(100vh - 48px)}@media (min-width:36em){.notification__menu[data-v-9cc3e83a]{border:1px solid var(--layout_menu-list-border);border-radius:0 0 4px 4px;box-shadow:0 2px 4px rgba(0,0,0,.2);height:auto}}.notification__menu-item[data-v-9cc3e83a]:not(.is-active):hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_menu-list-fg-hover)}.notification__menu-item-link[data-v-9cc3e83a]{display:flex;align-items:center;width:100%;padding:16px;line-height:16px}.notification__badge-count[data-v-9cc3e83a]{display:inline-block;margin-right:4px;white-space:nowrap;border:2px solid var(--layout_off-white)}.notification__expand-icon[data-v-9cc3e83a]{display:none;margin-left:auto;font-size:10px;transition:all .2s ease}@media (min-width:62em){.notification__expand-icon[data-v-9cc3e83a]{display:inline-flex;align-items:center}}.notification__header[data-v-9cc3e83a]{margin-bottom:8px;font-size:18px;font-weight:700}.notification__loading[data-v-9cc3e83a]{display:flex;justify-content:center;font-size:30px}.notification__loading .icon-loading[data-v-9cc3e83a]{display:inline-block;animation:spin-data-v-9cc3e83a linear 0s infinite;animation-duration:.8s}@keyframes spin-data-v-9cc3e83a{from{transform:rotate(0)}to{transform:rotate(360deg)}}.notification__empty-list[data-v-9cc3e83a]{margin:24px 0}.notification__empty-list-img[data-v-9cc3e83a]{max-width:250px}.notification__empty-list-text[data-v-9cc3e83a]{text-align:center;margin-top:12px;font-size:18px;font-weight:400;line-height:22px}.notification__list[data-v-9cc3e83a]{position:fixed;width:100%;height:calc(100% - 49px);top:49px;left:0;z-index:2200;background:var(--layout_bg-0);color:var(--layout_bg-0-fg-4);padding:16px;cursor:initial}@media (min-width:36em){.notification__list[data-v-9cc3e83a]{position:absolute;width:320px;height:auto;max-height:700px;top:100%;left:50%;transform:translateX(-55%);border:1px solid var(--layout_menu-list-border);border-radius:0 0 4px 4px;box-shadow:0 2px 4px rgba(0,0,0,.2)}}.notification__infinity-scroll[data-v-9cc3e83a] .infinite-scroller__container-elements{margin:12px 0 0}.notification__infinity-scroll[data-v-9cc3e83a] .infinite-scroller__loading{display:flex}.notification__pagination[data-v-9cc3e83a]{display:flex;justify-content:space-between;margin-top:12px}.notification__pagination>*[data-v-9cc3e83a]{background:0 0;border:none;cursor:pointer;color:var(--layout_link);border-bottom:1px solid transparent}.notification__pagination[data-v-9cc3e83a]>:hover{color:var(--layout_link-hover);border-color:var(--layout_link-hover)}.notification__pagination-next[data-v-9cc3e83a]{margin-left:auto}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$9 = "data-v-9cc3e83a";
/* module identifier */

var __vue_module_identifier__$9 = undefined;
/* functional template */

var __vue_is_functional_template__$9 = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
var script$a = {
  name: 'VueGlobalSearchSectionVehicle',
  props: {
    globalSearchSectionVehicle: {
      type: Object,
      default: undefined
    }
  },
  computed: {
    formattedVehicleInfo: function formattedVehicleInfo() {
      var _this$globalSearchSec = this.globalSearchSectionVehicle,
          year = _this$globalSearchSec.year,
          makeShort = _this$globalSearchSec.makeShort,
          modelShort = _this$globalSearchSec.modelShort,
          vin = _this$globalSearchSec.vin;
      var yearPart = year ? "".concat(year, " ") : '';
      var makeShortPart = makeShort ? "".concat(makeShort, " ") : '';
      var modelShortPart = modelShort ? "".concat(modelShort, " ") : '';
      var hasYearMakeModel = year || makeShort || modelShort;
      var vinPart = '';
      vinPart = vin ? "- ".concat(vin) : '';
      if (!hasYearMakeModel) vinPart = vin ? "".concat(vin) : '';
      return "".concat(yearPart).concat(makeShortPart).concat(modelShortPart).concat(vinPart);
    }
  }
};

/* script */
var __vue_script__$a = script$a;
/* template */

var __vue_render__$a = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "search-menu-item-info",
    attrs: {
      "data-testid": "globalsearch-section-vehicle"
    }
  }, [_vm._v("\n\t" + _vm._s(_vm.formattedVehicleInfo) + "\n")]);
};

var __vue_staticRenderFns__$a = [];
/* style */

var __vue_inject_styles__$a = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-5cce52bc_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-5cce52bc]:export{menubreakpoint:992}[data-v-5cce52bc]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-5cce52bc]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-5cce52bc],body.light[data-v-5cce52bc]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}.search-menu-item-info[data-v-5cce52bc]{margin-top:4px;font-size:12px;color:#585554}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$a = "data-v-5cce52bc";
/* module identifier */

var __vue_module_identifier__$a = undefined;
/* functional template */

var __vue_is_functional_template__$a = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, createInjector, undefined, undefined);

//
var script$b = {
  name: 'VueGlobalSearchSection',
  components: {
    VueGlobalSearchSectionVehicle: __vue_component__$a
  },
  props: {
    globalSearchSection: {
      type: Object,
      default: undefined
    },
    ultimateSearchLink: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.$emit('globalsearch-clicked-result');
    }
  }
};

var __vue_script__$b = script$b;
/* template */

var __vue_render__$b = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "search-menu-item"
  }, [_c('div', {
    attrs: {
      "data-testid": "globalsearch-section-area-name"
    }
  }, [_c('a', {
    staticClass: "search-menu-item__header",
    attrs: {
      "data-testid": "globalsearch-section-link",
      "target": "_blank",
      "href": _vm.ultimateSearchLink
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v(_vm._s(_vm.globalSearchSection.areaName))])]), _vm._v(" "), _c('ul', {
    attrs: {
      "data-testid": "globalsearch-section-area-items"
    }
  }, _vm._l(_vm.globalSearchSection.items, function (item) {
    return _c('li', {
      key: item.link,
      staticClass: "search-menu-item__result-item"
    }, [_c('a', {
      staticClass: "search-menu-item__result-item-link",
      attrs: {
        "data-testid": "globalsearch-section-result-link",
        "target": "_blank",
        "href": item.link
      },
      on: {
        "click": _vm.handleClick
      }
    }, [_vm._v(_vm._s(item.description) + "\n\t\t\t\t"), item.vehicle ? _c('VueGlobalSearchSectionVehicle', {
      attrs: {
        "globalSearchSectionVehicle": item.vehicle
      }
    }) : _vm._e()], 1)]);
  }), 0)]);
};

var __vue_staticRenderFns__$b = [];
/* style */

var __vue_inject_styles__$b = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-e74340bc_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-e74340bc]:export{menubreakpoint:992}[data-v-e74340bc]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-e74340bc]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-e74340bc],body.light[data-v-e74340bc]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}.search-menu-item[data-v-e74340bc]{background:var(--layout_menu-list-bg);color:var(--layout_menu-list-fg)}.search-menu-item__header[data-v-e74340bc]{font-weight:700;font-size:14px;line-height:22px;display:inline-block;width:100%;text-transform:uppercase;padding:16px}.search-menu-item__header[data-v-e74340bc]:hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_menu-list-fg-hover)}.search-menu-item__header[data-v-e74340bc]:focus-visible{outline:2px solid var(--layout_brand-2);outline-offset:-2px}.search-menu-item__result-item-link[data-v-e74340bc]{display:inline-block;padding:8px 16px;padding-left:32px;width:100%;height:100%}.search-menu-item__result-item-link[data-v-e74340bc]:hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_menu-list-fg-hover)}.search-menu-item__result-item-link[data-v-e74340bc]:focus-visible{outline:2px solid var(--layout_brand-2);outline-offset:-2px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$b = "data-v-e74340bc";
/* module identifier */

var __vue_module_identifier__$b = undefined;
/* functional template */

var __vue_is_functional_template__$b = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script$c = {
  name: 'DropdownList',
  data: function data() {
    return {
      selected: this.value,
      expanded: false
    };
  },
  mounted: function mounted() {
    document.addEventListener('click', this.handleDocumentClicked);
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClicked);
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    value: {
      type: String
    }
  },
  methods: {
    onSelect: function onSelect(option) {
      this.selected = option.value;
      this.$emit('input', this.selected);
      this.$emit('change', this.selected);
      this.onClick();
    },
    onClick: function onClick() {
      this.expanded = !this.expanded;
    },
    handleDocumentClicked: function handleDocumentClicked(event) {
      var target = event.target;
      var $el = this.$el;

      if (!$el.contains(target) && this.expanded) {
        this.expanded = false;
      }
    }
  },
  computed: {
    selectedText: function selectedText() {
      var _this = this;

      var text;
      var option;
      option = this.options.find(function (option) {
        return option.value == _this.selected;
      });
      text = option.text;
      return text;
    }
  }
};

/* script */
var __vue_script__$c = script$c;
/* template */

var __vue_render__$c = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    ref: "button",
    staticClass: "dropdown__expand-btn",
    class: _vm.expanded && 'is-open',
    attrs: {
      "type": "button",
      "data-testid": "dropdown-list-button"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_c('span', {
    staticClass: "dropdown__text"
  }, [_vm._v(_vm._s(_vm.selectedText))]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-arrow_down_filled"
  })]), _vm._v(" "), _vm.expanded ? _c('ul', {
    staticClass: "dropdown__list"
  }, [_vm._l(_vm.options, function (option) {
    return [_c('li', {
      key: option.value,
      ref: "li" + option.value,
      refInFor: true,
      staticClass: "dropdown__list-item",
      class: ['dropdown-list__item', _vm.selected == option.value ? 'is-active' : ''],
      attrs: {
        "data-value": option.value
      },
      on: {
        "click": function click($event) {
          return _vm.onSelect(option);
        }
      }
    }, [_vm._v("\n\t\t\t\t" + _vm._s(option.text) + "\n\t\t\t")]), _vm._v(" "), option.hasDivider ? _c('li', {
      key: option.value,
      staticClass: "dropdown__divider"
    }, [_c('hr', {
      staticClass: "dropdown__divider-line"
    })]) : _vm._e()];
  })], 2) : _vm._e()]);
};

var __vue_staticRenderFns__$c = [];
/* style */

var __vue_inject_styles__$c = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-df48a50e_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-df48a50e]:export{menubreakpoint:992}[data-v-df48a50e]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-df48a50e]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-df48a50e],body.light[data-v-df48a50e]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}.dropdown[data-v-df48a50e]{position:relative;font-size:14px}.dropdown__expand-btn[data-v-df48a50e]{position:relative;background:0 0;border:none;cursor:pointer;padding:8px;padding-right:24px;border:1px solid var(--layout_bg-2-fg-1);border-right:none;border-top-right-radius:0;border-bottom-right-radius:0;border-top-left-radius:4px;border-bottom-left-radius:4px;line-height:16px}.dropdown__expand-btn.is-open[data-v-df48a50e]{border-bottom-left-radius:0}.dropdown__expand-btn .icon[data-v-df48a50e]{position:absolute;right:0;padding:8px;position:absolute;top:50%;transform:translateY(-50%);font-size:10px}.dropdown__expand-btn[data-v-df48a50e]:active,.dropdown__expand-btn[data-v-df48a50e]:focus{outline:0;border-color:transparent}.dropdown__expand-btn[data-v-df48a50e]:active:after,.dropdown__expand-btn[data-v-df48a50e]:focus:after{content:\"\";position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:calc(100% + 1px);height:calc(100% + 3px);border:2px solid var(--layout_brand-2);z-index:2100}.dropdown__text[data-v-df48a50e]{white-space:nowrap}.dropdown__list[data-v-df48a50e]{position:absolute;left:0;margin-top:-1px;background:var(--layout_menu-list-bg);color:var(--layout_menu-list-fg);border:1px solid var(--layout_menu-list-border);border-bottom-left-radius:4px;border-bottom-right-radius:4px}@media (min-width:36em){.dropdown__list[data-v-df48a50e]{box-shadow:0 2px 4px rgba(0,0,0,.2)}}.dropdown__list-item[data-v-df48a50e]{padding:8px 16px;white-space:nowrap}.dropdown__list-item[data-v-df48a50e]:hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_menu-list-fg-hover)}.dropdown__list-item.is-active[data-v-df48a50e]{background:var(--layout_menu-list-bg-active);color:var(--layout_menu-list-fg-active)}.dropdown__divider[data-v-df48a50e]{display:flex;padding:4px}.dropdown__divider-line[data-v-df48a50e]{width:100%;margin-block-start:0;margin-block-end:0;border:0;height:1px;background:var(--bg-2)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$c = "data-v-df48a50e";
/* module identifier */

var __vue_module_identifier__$c = undefined;
/* functional template */

var __vue_is_functional_template__$c = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, createInjector, undefined, undefined);

var GlobalSearchCategory = {
  All: '',
  Accounting: 'J',
  AccountsPayable: 'AP',
  CustomerPhoneNumbers: 'H',
  Customers: 'C',
  Deals: 'D',
  Desks: 'S',
  JournalDetails: 'JR',
  PartsInvoices: 'I',
  Prospects: 'P',
  PurchaseOrders: 'PO',
  Receipts: 'RC',
  RepairOrders: 'R',
  Appointments: 'A',
  Vehicles: 'V',
  VehicleSales: 'VS',
  Vendors: 'N'
};

function parameterizeArray(name, params) {
  return params.map(function (p) {
    return name + '=' + p;
  }).join('&');
}

var script$d = {
  name: 'VueGlobalSearch',
  components: {
    VueGlobalSearchSection: __vue_component__$b,
    DropdownList: __vue_component__$c,
    Loader: Loader
  },
  data: function data() {
    return {
      loading: false,
      abortControllers: [],
      globalSearchResults: {},
      searchText: '',
      selectedArea: '',
      showSearch: false,
      showResults: false,
      globalSearchCategory: GlobalSearchCategory,
      companyId: getCompanyId(this.$route),
      areas: [{
        text: 'Accounting',
        value: GlobalSearchCategory.Accounting,
        selected: false,
        hasDivider: true,
        categories: [GlobalSearchCategory.JournalDetails, GlobalSearchCategory.Receipts, GlobalSearchCategory.PurchaseOrders, GlobalSearchCategory.AccountsPayable, GlobalSearchCategory.VehicleSales]
      }, {
        text: 'All',
        value: GlobalSearchCategory.All,
        selected: true
      }, {
        text: 'Appointments',
        value: GlobalSearchCategory.Appointments,
        selected: false
      }, {
        text: 'Customers',
        value: GlobalSearchCategory.Customers,
        selected: false
      }, {
        text: 'Deals',
        value: GlobalSearchCategory.Deals,
        selected: false
      }, {
        text: 'Desks',
        value: GlobalSearchCategory.Desks,
        selected: false
      }, {
        text: 'Parts Invoices',
        value: GlobalSearchCategory.PartsInvoices,
        selected: false
      }, {
        text: 'Phone Numbers',
        value: GlobalSearchCategory.CustomerPhoneNumbers,
        selected: false
      }, {
        text: 'Prospects',
        value: GlobalSearchCategory.Prospects,
        selected: false
      }, {
        text: 'Repair Orders',
        value: GlobalSearchCategory.RepairOrders,
        selected: false
      }, {
        text: 'Vehicles',
        value: GlobalSearchCategory.Vehicles,
        selected: false
      }, {
        text: 'Vendors',
        value: GlobalSearchCategory.Vendors,
        selected: false
      }]
    };
  },
  mixins: [propsMixin, loggingMixin],
  created: function created() {
    this.setQuickSearchDefault();
  },
  computed: _objectSpread2(_objectSpread2({}, mapGetters('user', ['vueAppBase', 'quickSearchDefault'])), {}, {
    hasResults: function hasResults() {
      return this.globalSearchResults.categories && this.globalSearchResults.categories.length;
    }
  }),
  methods: {
    setQuickSearchDefault: function setQuickSearchDefault() {
      var defVal = '';
      var defText = this.quickSearchDefault;

      if (defText) {
        var areaIndex = this.areas.findIndex(function (a) {
          return a.text === defText;
        });

        if (areaIndex > 0) {
          defVal = this.areas[areaIndex].value;
        }
      } //console.log(defVal);


      this.selectedArea = defVal;
    },
    loadGlobalSearchResults: function loadGlobalSearchResults() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var abortController, route;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                //https://axios-http.com/docs/cancellation
                abortController = new AbortController();
                route = buildRoute('/globalsearch/company/{companyId}/autocomplete?searchText={searchText}&maxCount=3&area={area}&companyId={cid}', {
                  companyId: _this.companyId,
                  cid: _this.companyId,
                  searchText: _this.searchText,
                  area: _this.selectedArea
                });

                _this.cancelPending();

                _this.abortControllers.push(abortController);

                _context.prev = 4;
                _this.loading = true;
                _context.next = 8;
                return _this.apiService.get(route, abortController.signal);

              case 8:
                _this.globalSearchResults = _context.sent;
                _this.abortControllers = [];
                _this.loading = false;
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](4);
                //when we abort pending api calls a cancel error is thrown
                console.log('cancelled');

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 13]]);
      }))();
    },
    getGlobalSearchAction: function getGlobalSearchAction(area) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var abortController, route, areaQueryParamString;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                //https://axios-http.com/docs/cancellation
                abortController = new AbortController();
                route = buildRoute('/globalsearch/company/{companyId}/autocomplete?searchText={searchText}&maxCount=3&companyId={cid}', {
                  companyId: _this2.companyId,
                  cid: _this2.companyId,
                  searchText: _this2.searchText
                });
                areaQueryParamString = parameterizeArray('Area', _this2.areas.find(function (cat) {
                  return cat.value === area;
                }).categories);

                _this2.cancelPending();

                _this2.abortControllers.push(abortController);

                _context2.prev = 5;
                _this2.loading = true;
                _context2.next = 9;
                return _this2.apiService.get(route + '&' + areaQueryParamString, abortController.signal);

              case 9:
                _this2.globalSearchResults = _context2.sent;
                _this2.abortControllers = [];
                _this2.loading = false;
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](5);
                //when we abort pending api calls a cancel error is thrown
                console.log('cancelled');

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[5, 14]]);
      }))();
    },
    cancelPending: function cancelPending() {
      //cancels pending api calls
      if (this.abortControllers && this.abortControllers.length > 0) {
        while (this.abortControllers.length > 0) {
          var controller = this.abortControllers.shift();
          controller.abort();
        }
      }
    },
    search: function search() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this3.searchText.length > 2)) {
                  _context3.next = 11;
                  break;
                }

                _this3.showSearchResults();

                if (!(_this3.selectedArea == _this3.globalSearchCategory.Accounting)) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 5;
                return _this3.getGlobalSearchAction(_this3.selectedArea);

              case 5:
                _context3.next = 9;
                break;

              case 7:
                _context3.next = 9;
                return _this3.loadGlobalSearchResults();

              case 9:
                _context3.next = 12;
                break;

              case 11:
                _this3.hideSearchResults();

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    ultimateSearchLink: function ultimateSearchLink(area) {
      var base = this.vueAppBase;

      if (!base) {
        base = '/';
      }

      return "".concat(base, "company/").concat(this.companyId, "/globalsearch/search/").concat(this.searchText, "/area/").concat(area);
    },
    navigateToUltimateSearch: function navigateToUltimateSearch(area) {
      var link;

      if (this.searchText.length) {
        link = this.ultimateSearchLink(area);
        this.hideSearch();
        window.open(link, '_blank');
      }
    },
    toggleSearch: function toggleSearch() {
      if (this.showSearch) {
        this.hideSearch();
      } else {
        this.showSearch = true;
        this.focusOnInput();
      }
    },
    hideSearchResults: function hideSearchResults() {
      this.showResults = false;
      document.removeEventListener('mouseup', this.globalMouseUpHandler);
    },
    showSearchResults: function showSearchResults() {
      if (this.showSearch) {
        this.showResults = true;
        document.addEventListener('mouseup', this.globalMouseUpHandler);
      }
    },
    hideSearch: function hideSearch() {
      this.showSearch = false;
      this.globalSearchResults = {};
      this.searchText = '';
      this.hideSearchResults();
    },
    globalMouseUpHandler: function globalMouseUpHandler(e) {
      var container = this.$refs.globalsearchHeader;

      if (e && container && !container.contains(e.target) && this.showResults) {
        this.hideSearchResults();
      }
    },
    focusOnInput: function focusOnInput() {
      var _this4 = this;

      this.$nextTick(function () {
        var input = _this4.$refs.globalsearchInput;
        input.focus();
      });
    },
    handleAreaChange: function handleAreaChange() {
      this.search();
      this.focusOnInput();
    }
  }
};

var __vue_script__$d = script$d;
/* template */

var __vue_render__$d = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    ref: "globalsearchHeader",
    class: ['search', _vm.showSearch ? 'is-open' : '', _vm.showResults ? 'is-result-list-visible' : ''],
    attrs: {
      "data-testid": "globalsearchHeader"
    }
  }, [_c('div', {
    staticClass: "search__forms"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSearch,
      expression: "showSearch"
    }],
    staticClass: "search__form",
    attrs: {
      "data-testid": "globalsearch-form"
    }
  }, [_c('div', {
    staticClass: "search__form-options"
  }, [_c('DropdownList', {
    directives: [{
      name: "log",
      rawName: "v-log",
      value: {
        target: 'Global Search Select Area',
        event: 'change'
      },
      expression: "{\n\t\t\t\t\t\ttarget: 'Global Search Select Area',\n\t\t\t\t\t\tevent: 'change'\n\t\t\t\t\t}"
    }],
    attrs: {
      "options": _vm.areas,
      "data-testid": "globalsearch-area-dropdown"
    },
    on: {
      "change": _vm.handleAreaChange
    },
    model: {
      value: _vm.selectedArea,
      callback: function callback($$v) {
        _vm.selectedArea = $$v;
      },
      expression: "selectedArea"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search__form-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchText,
      expression: "searchText"
    }],
    ref: "globalsearchInput",
    staticClass: "search__form-input",
    attrs: {
      "data-testid": "globalsearch-input",
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": _vm.searchText
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }

        _vm.searchText = $event.target.value;
      }, _vm.search],
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.navigateToUltimateSearch(_vm.selectedArea);
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "search__form-btn",
    attrs: {
      "data-testid": "globalsearch-search-btn"
    },
    on: {
      "click": function click($event) {
        return _vm.navigateToUltimateSearch(_vm.selectedArea);
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-search-2"
  })])]), _vm._v(" "), _c('button', {
    staticClass: "search__btn",
    attrs: {
      "data-testid": "globalsearch-toggle-btn"
    },
    on: {
      "click": _vm.toggleSearch
    }
  }, [_c('span', {
    staticClass: "search__btn-icon-tablet-up"
  }, [_c('i', {
    class: ['icon', _vm.showSearch ? 'icon-remove-2' : 'icon-search-2']
  })]), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showResults,
      expression: "showResults"
    }],
    staticClass: "search__results",
    attrs: {
      "data-testid": "globalsearch-results"
    }
  }, [_vm.loading ? _c('div', [_c('Loader', {
    attrs: {
      "variant": "dots"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.hasResults ? _c('div', {
    attrs: {
      "data-testid": "globalsearch-has-results"
    }
  }, [_c('ul', {
    staticClass: "search__results-list"
  }, _vm._l(_vm.globalSearchResults.categories, function (section) {
    return _c('li', {
      key: section.areaName,
      staticClass: "search__results-item"
    }, [_c('VueGlobalSearchSection', {
      attrs: {
        "globalSearchSection": section,
        "ultimateSearchLink": _vm.ultimateSearchLink(section.area)
      },
      on: {
        "globalsearch-clicked-result": _vm.hideSearch
      }
    }), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: section.totalCount > 3,
        expression: "section.totalCount > 3"
      }],
      staticClass: "search__link-see-more",
      attrs: {
        "data-testid": "globalsearch-result-see-more-" + section.area,
        "target": "_blank",
        "href": _vm.ultimateSearchLink(section.area)
      },
      on: {
        "click": _vm.hideSearch
      }
    }, [_vm._v("See more " + _vm._s(section.areaName) + "...")])], 1);
  }), 0)]) : _vm._e(), _vm._v(" "), !_vm.hasResults && !_vm.loading ? _c('div', {
    staticClass: "search__no-results",
    attrs: {
      "data-testid": "globalsearch-no-results"
    }
  }, [_c('span', [_vm._v("\n\t\t\t\tNo results found.\n\t\t\t")])]) : _vm._e()])]);
};

var __vue_staticRenderFns__$d = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    staticClass: "search__btn-icon-mobile"
  }, [_c('i', {
    staticClass: "icon icon-search-2"
  })]);
}];
/* style */

var __vue_inject_styles__$d = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-3b521908_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-3b521908]:export{menubreakpoint:992}[data-v-3b521908]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-3b521908]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-3b521908],body.light[data-v-3b521908]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}[data-v-3b521908]::-webkit-scrollbar{width:14px;background-color:var(--bg-0)}[data-v-3b521908]::-webkit-scrollbar-track{box-shadow:inset 0 0 2px rgba(0,0,0,.2);background-color:var(--bg-0)}[data-v-3b521908]::-webkit-scrollbar-thumb{background-color:var(--bg-0-fg-1);border-radius:14px;border:3px solid transparent;background-clip:content-box;min-height:16px}[data-v-3b521908]::-webkit-scrollbar{width:14px;background-color:transparent}[data-v-3b521908]::-webkit-scrollbar-track{border-top:1px solid transparent;box-shadow:none;background-color:transparent}[data-v-3b521908]::-webkit-scrollbar-thumb{background-color:var(--bg-0-fg-1);border-radius:14px;border:3px solid transparent;background-clip:content-box}.search[data-v-3b521908]{display:flex;justify-content:center;height:100%;max-width:420px;min-width:42px;position:relative;font-size:14px;margin-left:auto}.search[data-v-3b521908] ::placeholder{color:var(--layout_placeholder)}.search.is-open .search__btn[data-v-3b521908]{justify-content:center;background:var(--layout_bg-brand-1);color:var(--layout_bg-brand-1-fg-3)}@media (min-width:62em){.search.is-open .search__btn[data-v-3b521908]:hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_menu-list-fg-hover)}}@media (min-width:36em){.search.is-open .search__btn[data-v-3b521908]{background:0 0;color:inherit}}@media (min-width:36em){.search.is-result-list-visible .search__form-input[data-v-3b521908]{border-bottom-right-radius:0}}.search__forms[data-v-3b521908]{display:inline-flex;width:100%;align-items:center;z-index:2200}.search__form[data-v-3b521908]{display:inline-flex;align-items:flex-start;position:fixed;width:100%;height:calc(100vh - 49px);top:49px;left:0;z-index:2500;padding:16px;background:var(--layout_bg-0);color:var(--layout_bg-0-fg-4)}@media (min-width:36em){.search__form[data-v-3b521908]{align-items:center;position:inherit;height:initial;margin-left:auto;top:initial;left:initial;padding:0}}.search__btn[data-v-3b521908]{display:flex;align-items:center;height:100%;justify-content:center;min-width:42px;padding:6px 8px;margin-left:2px;background:0 0;border:none;cursor:pointer;font-size:18px;background:var(--layout_bg-0);color:var(--layout_bg-0-fg-4);border-radius:0}@media (min-width:62em){.search__btn[data-v-3b521908]:hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_menu-list-fg-hover)}}.search__btn-icon-tablet-up[data-v-3b521908]{display:none}@media (min-width:36em){.search__btn-icon-tablet-up[data-v-3b521908]{display:inline-block}.search__btn-icon-mobile[data-v-3b521908]{display:none}}.search__btn[data-v-3b521908]:focus-visible{outline:2px solid var(--layout_brand-2);outline-offset:-2px}.search__form-input-container[data-v-3b521908]{width:100%;display:flex;align-items:center;position:relative}.search__form-input-container[data-v-3b521908]::before{position:absolute;content:\"\";left:0;top:50%;transform:translateY(-50%);height:20px;width:1px;background:var(--layout_field-fg-extras)}.search__form-input-container[data-v-3b521908]:focus-within::before{display:none}.search__form-input-container[data-v-3b521908]:focus-within::after{content:\"\";position:absolute;top:50%;transform:translateY(-50%);width:calc(100% + 34px);height:calc(100% + 1px);border-radius:2px;border:2px solid var(--layout_brand-2);pointer-events:none;z-index:2100}.search__form-input[data-v-3b521908]{width:100%;border:1px solid var(--layout_bg-2-fg-1);border-left:none;border-right:none;padding:8px;border-radius:0;line-height:16px}.search__form-input[data-v-3b521908]:active,.search__form-input[data-v-3b521908]:focus{outline:0;border-color:transparent}.search__form-btn[data-v-3b521908]{display:inline-flex;position:relative;background:0 0;border:none;cursor:pointer;border:1px solid var(--layout_bg-2-fg-1);border-left:none;border-top-left-radius:0;border-bottom-left-radius:0;border-top-right-radius:4px;border-bottom-right-radius:4px;padding:8px;color:var(--layout_bg-0-fg-3);font-size:16px;line-height:16px}.search__form-btn[data-v-3b521908]:hover{color:var(--layout_bg-0-fg-4)}.search__form-btn[data-v-3b521908]:focus,.search__form-btn[data-v-3b521908]:visited{outline:0;border-color:transparent}.search__form-btn[data-v-3b521908]:focus:after,.search__form-btn[data-v-3b521908]:visited:after{content:\"\";position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:calc(100% + 1px);height:calc(100% + 3px);border:2px solid var(--layout_brand-2);z-index:2100}.search__results[data-v-3b521908]{position:fixed;width:100%;height:calc(100% - 108px);top:108px;left:0;border-top:#cbcbcb;overflow-y:auto;z-index:2100}@media (min-width:36em){.search__results[data-v-3b521908]{position:absolute;width:266px;height:auto;max-height:450px;top:40px;left:auto;right:44px;background:var(--layout_bg-0);color:var(--layout_bg-0-fg-4);border:1px solid #cbcbcb;border-radius:0 0 4px 4px;box-shadow:0 2px 4px rgba(0,0,0,.2)}}.search__no-results[data-v-3b521908]{padding:16px;text-align:center}.search__link-see-more[data-v-3b521908]{display:inline-block;width:100%;padding:16px;padding-left:32px;color:var(--layout_link)}.search__link-see-more[data-v-3b521908]:hover{color:var(--layout_link-hover);text-decoration:underline}.search__link-see-more[data-v-3b521908]:focus-visible{outline:2px solid var(--layout_brand-2);outline-offset:-2px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$d = "data-v-3b521908";
/* module identifier */

var __vue_module_identifier__$d = undefined;
/* functional template */

var __vue_is_functional_template__$d = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, createInjector, undefined, undefined);

var propsMixin$1 = {
  data: function data() {
    return {
      reponsibleForUserInfo: true
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.reponsibleForUserInfo && !objectIsDefinedAndHasProperty(_this.userInfo, 'sub'))) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return _this.getUserInfoAction();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: _objectSpread2({}, mapGetters('user', ['userInfo', 'userToken', 'userReady', 'apiService', 'initialized'])),
  methods: _objectSpread2({}, mapActions('user', ['getUserInfoAction', 'setTokenAction']))
};

var VUELogo = {
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 86.77 30"
      }
    }, [_c('circle', {
      attrs: {
        "cx": "15",
        "cy": "15",
        "r": "14.84",
        "fill": "#06262d"
      }
    }), _c('path', {
      attrs: {
        "fill": "#2d7037",
        "d": "M14.99 26.5l6.07-11.24-4.81-2.52-1.26 2.51-1.24-2.51-4.81 2.52 6.05 11.24z"
      }
    }), _c('path', {
      attrs: {
        "fill": "#8dc641",
        "d": "M13.75 12.74l-.61-1.25L4.88 8.1l4.06 7.16 4.81-2.52z"
      }
    }), _c('path', {
      attrs: {
        "fill": "#079247",
        "d": "M16.25 12.74l.61-1.25 8.26-3.39-4.06 7.16-4.81-2.52z"
      }
    }), _c('path', {
      attrs: {
        "d": "M15 30C6.73 30 0 23.27 0 15S6.73 0 15 0s15 6.73 15 15-6.73 15-15 15zM15 .33C6.91.33.33 6.91.33 15S6.91 29.67 15 29.67 29.67 23.09 29.67 15 23.09.33 15 .33z",
        "fill": "#8dc641"
      }
    }), _c('path', {
      attrs: {
        "d": "M67.7 19.23c0 1.98-1.6 3.57-3.56 3.57s-3.56-1.59-3.56-3.57V12.1H58.8v7.13c0 2.96 2.39 5.35 5.35 5.35s5.35-2.39 5.35-5.35V12.1h-1.78v7.13zm-21.69 1.89l-4.94-9.02h-2.03l6.83 12.48h.27l6.83-12.48h-2.03l-4.92 9.02zm33.63.57h-1.78v2.89h8.91V22.8h-7.13v-1.1zm-1.78-9.59v5.54h1.78v-3.76h7.13V12.1h-8.91z",
        "fill": "#06262d"
      }
    }), _c('path', {
      attrs: {
        "fill": "#8dc641",
        "d": "M77.85 18.77h7.22v1.8h-7.22z"
      }
    })]);
  }
};

var VUELogoVonly = {
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 30 30"
      }
    }, [_c('circle', {
      attrs: {
        "cx": "15",
        "cy": "15",
        "r": "14.84",
        "fill": "#06262d"
      }
    }), _c('path', {
      attrs: {
        "fill": "#2d7037",
        "d": "M14.99 26.5l6.07-11.24-4.81-2.52-1.26 2.51-1.24-2.51-4.81 2.52 6.05 11.24z"
      }
    }), _c('path', {
      attrs: {
        "fill": "#8dc641",
        "d": "M13.75 12.74l-.61-1.25L4.88 8.1l4.06 7.16 4.81-2.52z"
      }
    }), _c('path', {
      attrs: {
        "fill": "#079247",
        "d": "M16.25 12.74l.61-1.25 8.26-3.39-4.06 7.16-4.81-2.52z"
      }
    }), _c('path', {
      attrs: {
        "d": "M15 30C6.73 30 0 23.27 0 15S6.73 0 15 0s15 6.73 15 15-6.73 15-15 15zM15 .33C6.91.33.33 6.91.33 15S6.91 29.67 15 29.67 29.67 23.09 29.67 15 23.09.33 15 .33z",
        "fill": "#8dc641"
      }
    })]);
  }
};

var script$e = {
  name: 'VueUiHeader',
  data: function data() {
    return {
      reponsibleForUserInfo: false,
      activeMode: 'light',
      brandingVars: {},
      displayHelp: false,
      helpCloseHandlerSet: false
    };
  },
  components: {
    VueCompanySelector: __vue_component__,
    VueHelp: __vue_component__$1,
    VueProfileMenu: __vue_component__$2,
    VueNotifications: __vue_component__$9,
    VueGlobalSearch: __vue_component__$d,
    VUELogo: VUELogo,
    VUELogoVonly: VUELogoVonly
  },
  mixins: [propsMixin$1],
  props: {
    hideMenuButton: {
      type: Boolean,
      default: false
    },
    hideGlobalSearch: {
      type: Boolean,
      default: false
    },
    hideNotifications: {
      type: Boolean,
      default: false
    },
    hideHelp: {
      type: Boolean,
      default: false
    },
    hideProfileMenu: {
      type: Boolean,
      default: false
    },
    hideCompanySelector: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    window.LLHeader = true;
  },
  computed: _objectSpread2(_objectSpread2({}, mapGetters('user', ['pageTitle', 'userToken', 'isMenuOpen'])), {}, {
    showMenuButton: function showMenuButton() {
      return this.initialized && !this.hideMenuButton;
    },
    showGlobalSearch: function showGlobalSearch() {
      return this.initialized && !this.hideGlobalSearch;
    },
    showNotifications: function showNotifications() {
      return this.initialized && !this.hideNotifications;
    },
    showHelp: function showHelp() {
      return !this.hideHelp;
    },
    showProfileMenu: function showProfileMenu() {
      return this.initialized && !this.hideProfileMenu;
    },
    showCompanySelector: function showCompanySelector() {
      return this.initialized && !this.hideCompanySelector;
    },
    showVerticalLine: function showVerticalLine() {
      var result = false; //if one element on the left and one on the right are visible, it should show

      if ((this.showGlobalSearch || this.showNotifications || this.showHelp) && (this.showProfileMenu || this.showCompanySelector)) {
        result = true;
      }

      return result;
    }
  }),
  methods: _objectSpread2(_objectSpread2({}, mapActions('user', ['setMenuIsOpen'])), {}, {
    removeToastAction: function removeToastAction() {},
    handleMenu: function handleMenu() {
      this.setMenuIsOpen(!this.isMenuOpen);
    },
    gotoDashboard: function gotoDashboard() {
      var cid = getCompanyId(this.$route);
      var location = '/';

      if (cid != undefined) {
        location = "/?cid=".concat(cid);
      }

      window.location.assign(location);
    },
    onHelpClick: function onHelpClick() {
      // const self = this;
      this.displayHelp = !this.displayHelp; // if (window.HubSpotConversations && !this.helpCloseHandlerSet) {
      // 	window.Intercom('onHide', function() {
      // 		self.displayHelp = false;
      // 		self.helpCloseHandlerSet = true;
      // 	});
      // }
    }
  })
};

/* script */
var __vue_script__$e = script$e;
/* template */

var __vue_render__$e = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vue-header",
    style: _vm.brandingVars,
    attrs: {
      "mode": _vm.activeMode
    }
  }, [_c('div', {
    staticClass: "vue-header__left-col"
  }, [_c('div', {
    staticClass: "vue-header__logo",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.gotoDashboard
    }
  }, [_c('VUELogoVonly', {
    staticClass: "vue-header__logo--mobile"
  }), _vm._v(" "), _c('VUELogo', {
    staticClass: "vue-header__logo--desktop",
    attrs: {
      "data-testid": "header-logo"
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "vue-header__vertical-div"
  }), _vm._v(" "), _vm.showMenuButton ? _c('button', {
    staticClass: "vue-header__menu-btn",
    class: _vm.isMenuOpen && 'is-open',
    attrs: {
      "data-testid": "menu-button",
      "id": "menu-button"
    },
    on: {
      "click": _vm.handleMenu
    }
  }, [_c('i', {
    staticClass: "icon icon-menu-2",
    attrs: {
      "id": "menu-button-icon"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "vue-header__right-col"
  }, [_c('div', {
    staticClass: "vue-header__search"
  }, [_vm.showGlobalSearch ? _c('VueGlobalSearch', {
    attrs: {
      "apiService": _vm.apiService,
      "data-testid": "global-search"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "vue-header__notification"
  }, [_vm.showNotifications ? _c('VueNotifications', {
    attrs: {
      "apiService": _vm.apiService,
      "data-testid": "notification-list"
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.showHelp ? _c('div', {
    class: ['vue-header__help', _vm.displayHelp && 'is-open'],
    on: {
      "click": _vm.onHelpClick
    }
  }, [_c('VueHelp', {
    staticClass: "vue-header__help",
    attrs: {
      "data-testid": "help"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.showVerticalLine ? _c('hr', {
    staticClass: "vue-header__vertical-div",
    attrs: {
      "data-testid": "verticalDiv"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "vue-header__profile-menu"
  }, [_vm.showProfileMenu ? _c('VueProfileMenu', {
    attrs: {
      "apiService": _vm.apiService,
      "data-testid": "profile-menu"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "vue-header__company-selector"
  }, [_vm.showCompanySelector ? _c('VueCompanySelector', {
    attrs: {
      "apiService": _vm.apiService,
      "data-testid": "company-selector"
    }
  }) : _vm._e()], 1)])]);
};

var __vue_staticRenderFns__$e = [];
/* style */

var __vue_inject_styles__$e = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-b95cd000_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-b95cd000]:export{menubreakpoint:992}[data-v-b95cd000]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-b95cd000]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-b95cd000],body.light[data-v-b95cd000]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}[data-v-b95cd000]{@import url(\"https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap\");}[data-v-b95cd000] *{font-family:Lato,sans-serif}[data-v-b95cd000] *,[data-v-b95cd000] ::after,[data-v-b95cd000] ::before{box-sizing:border-box}[data-v-b95cd000] li{list-style:none}[data-v-b95cd000] li::marker{content:none}[data-v-b95cd000] h1,[data-v-b95cd000] h2,[data-v-b95cd000] h3,[data-v-b95cd000] h4,[data-v-b95cd000] h5{margin:0}[data-v-b95cd000] h1{font-size:30px;line-height:36px}[data-v-b95cd000] h2{font-size:24px;line-height:30px}[data-v-b95cd000] h3{font-size:18px;line-height:23px}[data-v-b95cd000] h4{font-size:16px;line-height:19px}[data-v-b95cd000] h5{font-size:14px;line-height:18px}[data-v-b95cd000] p{font-size:16px;margin-block-start:0;margin-block-end:0}[data-v-b95cd000] img{display:inline-block;max-width:100%;max-height:100%}[data-v-b95cd000] button{background:0 0;border:none;padding:none;padding:0;margin:0;cursor:pointer}[data-v-b95cd000] button:focus{outline:0}[data-v-b95cd000] :-ms-input-placeholder,[data-v-b95cd000] ::-moz-placeholder,[data-v-b95cd000] ::-webkit-input-placeholder,[data-v-b95cd000] ::placeholder,[data-v-b95cd000] input::-webkit-input-placeholder{font-size:14px;line-height:normal;color:var(--placeholder)}[data-v-b95cd000] a{text-decoration:none;outline:0}[data-v-b95cd000] .is-hidden{display:none}[data-v-b95cd000] *,[data-v-b95cd000] ::after,[data-v-b95cd000] ::before{box-sizing:border-box}[data-v-b95cd000] ul{margin:0;margin-block-start:0;margin-block-end:0;padding:0;padding-inline-start:0;box-sizing:border-box}[data-v-b95cd000] a{background-color:transparent;color:inherit}.vue-header[data-v-b95cd000]{position:fixed;top:0;width:100%;max-width:1402px;height:48px;border-bottom:1px solid #cbcbcb;display:flex;justify-content:space-between;background:var(--layout_bg-0);color:var(--layout_bg-0-fg-4);z-index:10000}.vue-header__logo-breadcrumb[data-v-b95cd000]{height:100%;display:flex;align-items:center}.vue-header__menu-btn[data-v-b95cd000]{font-size:14px;height:100%;min-width:42px;border-radius:0}.vue-header__menu-btn.is-open[data-v-b95cd000]{background:var(--layout_menu-list-bg-active);color:var(--layout_menu-list-fg-active)}@media (max-width:35.99em){.vue-header__menu-btn.is-open[data-v-b95cd000]{background:var(--layout_bg-brand-1);color:var(--layout_bg-0)}}@media (min-width:62em){.vue-header__menu-btn[data-v-b95cd000]:hover:not(.is-open){background:var(--layout_menu-list-bg-hover);color:var(--layout_menu-list-fg-hover)}}@media (min-width:62em){.vue-header__menu-btn[data-v-b95cd000]{display:none}}.vue-header__menu-btn[data-v-b95cd000]:focus-visible{outline:2px solid var(--layout_brand-2);outline-offset:-2px}.vue-header__logo[data-v-b95cd000]{min-width:42px;height:100%;display:flex;justify-content:center;align-items:center;padding:0 4px;cursor:pointer}.vue-header__logo-img[data-v-b95cd000],.vue-header__logo-img-mobile[data-v-b95cd000]{height:80%}.vue-header__logo-img[data-v-b95cd000]{display:none}@media (min-width:48em){.vue-header__logo-img[data-v-b95cd000]{display:inline-block}.vue-header__logo-img-mobile[data-v-b95cd000]{display:none}}.vue-header__logo[data-v-b95cd000]:focus-visible{outline:2px solid var(--layout_brand-2);outline-offset:-2px}.vue-header__left-col[data-v-b95cd000]{margin-left:4px;display:flex;align-items:center}.vue-header__left-col .vue-header__vertical-div[data-v-b95cd000]{display:none;margin-right:8px;margin-left:12px}@media (max-width:61.99em){.vue-header__left-col .vue-header__vertical-div[data-v-b95cd000]{display:inline-block}}.vue-header__logo>*[data-v-b95cd000]{height:30px}@media (min-width:62em){.vue-header__logo--mobile[data-v-b95cd000]{display:none}}.vue-header__logo--desktop[data-v-b95cd000]{display:none}@media (min-width:62em){.vue-header__logo--desktop[data-v-b95cd000]{display:inline-block;margin-left:.5px}}.vue-header__right-col[data-v-b95cd000]{display:flex;justify-content:flex-end;align-items:center;flex-grow:2}.vue-header__right-col>*[data-v-b95cd000]{min-width:42px;height:100%;display:flex;justify-content:center;align-items:center}.vue-header__right-col .vue-header__vertical-div[data-v-b95cd000]{margin:0 12px}.vue-header__vertical-div[data-v-b95cd000]{display:inline-block;min-width:initial;width:1px;height:60%;padding:0;border-width:0;background:var(--layout_bg-0-fg-1)}.vue-header__search[data-v-b95cd000]{margin-left:8px;flex-grow:2;min-width:42px}@media (min-width:48em){.vue-header__search[data-v-b95cd000]{margin-left:24px}}.vue-header__notification[data-v-b95cd000]{z-index:2100}.vue-header__help.is-open .launch-intercom[data-v-b95cd000]{background-image:linear-gradient(-225deg,#50cccc 35%,#45aeca 100%);color:#f9f9f9}.vue-header__company-selector[data-v-b95cd000],.vue-header__profile-menu[data-v-b95cd000]{min-width:max-content}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$e = "data-v-b95cd000";
/* module identifier */

var __vue_module_identifier__$e = undefined;
/* functional template */

var __vue_is_functional_template__$e = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, createInjector, undefined, undefined);

var menuItemIcons = {
  Favorites: 'icon-favorites',
  'General Ledger': 'icon-general-ledger',
  'Cash and Bank': 'icon-cash-bank',
  'Accounts Receivable': 'icon-accounts-receivable',
  'Accounts Payable': 'icon-accounts-payable',
  'Journal Reports': 'icon-journal-reports',
  'Schedule Reports': 'icon-schedule-reports',
  Reports: 'icon-reports',
  Monthly: 'icon-monthly',
  Miscellaneous: 'icon-miscellaneous',
  Maintenance: 'icon-maintenance',
  Accounting: 'icon-accounting',
  Vehicles: 'icon-vehicles',
  'F & I': 'icon-fi',
  Vehicle: 'icon-vehicle',
  Sales: 'icon-sales',
  Tax: 'icon-tax',
  Payroll: 'icon-payroll',
  'Payroll Process': 'icon-payroll-process',
  Employee: 'icon-employee',
  Quarterly: 'icon-quarterly',
  Counter: 'icon-counter',
  Management: 'icon-management',
  Cashier: 'icon-cashier',
  Audit: 'icon-audit',
  Inventory: 'icon-inventory',
  Orders: 'icon-orders',
  Manufacturer: 'icon-manufacturer',
  Parts: 'icon-parts',
  Advisor: 'icon-advisor',
  Service: 'icon-service',
  Acura: 'icon-acura',
  Chrysler: 'icon-chrysler',
  Fiat: 'icon-fiat',
  Ford: 'icon-ford',
  GM: 'icon-gm',
  Honda: 'icon-honda',
  Infiniti: 'icon-infiniti',
  Kia: 'icon-kia',
  Lexus: 'icon-lexus',
  Mazda: 'icon-mazda',
  Nissan: 'icon-nissan',
  Subaru: 'icon-subaru',
  Toyota: 'icon-toyota',
  'OEM DCS': 'icon-oem',
  MyVUE: 'icon-vue'
};

function documentClickedMixin (closeHandlerName) {
  return {
    mounted: function mounted() {
      document.addEventListener('click', this.handleDocumentClicked);
    },
    beforeDestroy: function beforeDestroy() {
      document.removeEventListener('click', this.handleDocumentClicked);
    },
    methods: {
      handleDocumentClicked: function handleDocumentClicked(event) {
        var target = event.target;
        var $el = this.$el;

        if (!$el.contains(target)) {
          this[closeHandlerName]();
        }
      }
    }
  };
}

//
var script$f = {
  name: 'ContextMenu',
  mixins: [documentClickedMixin('closeHandler')],

  /**
   * Array of menu options in format:
   * {
   * 	text: "Menu Item Name",
   * 	action: () => {}
   * }
   */
  props: {
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    closeHandler: function closeHandler() {
      this.$emit('onClose');
    }
  }
};

/* script */
var __vue_script__$f = script$f;
/* template */

var __vue_render__$f = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('ul', {
    staticClass: "context-menu",
    attrs: {
      "data-testid": "context-menu"
    }
  }, _vm._l(_vm.options, function (option) {
    return _c('li', {
      key: option.text,
      staticClass: "context-menu__item",
      on: {
        "mousedown": option.action
      }
    }, [_vm._v("\n\t\t" + _vm._s(option.text) + "\n\t")]);
  }), 0);
};

var __vue_staticRenderFns__$f = [];
/* style */

var __vue_inject_styles__$f = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-8d062506_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-8d062506]:export{menubreakpoint:992}[data-v-8d062506]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-8d062506]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-8d062506],body.light[data-v-8d062506]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}.context-menu[data-v-8d062506]{position:absolute;top:100%;margin-left:8px;border:1px solid var(--layout_menu-list-border);background:var(--layout_menu-list-bg);color:var(--layout_menu-list-fg);border-radius:4px;box-shadow:0 2px 4px rgba(0,0,0,.2);z-index:2100}.context-menu__item[data-v-8d062506]{padding:8px;cursor:pointer;white-space:nowrap}.context-menu__item[data-v-8d062506]:hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_menu-list-fg-hover)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$f = "data-v-8d062506";
/* module identifier */

var __vue_module_identifier__$f = undefined;
/* functional template */

var __vue_is_functional_template__$f = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, createInjector, undefined, undefined);

function getMenuItemLink (menuItem, companyId, appBase) {
  var link = menuItem.itemValue;
  var base = link;
  var query = '';
  var pathParts;
  var searchParams;

  if (menuItem.linkType === 2) {
    link = link.replace('{companyId}', companyId);

    if (appBase) {
      if (appBase.endsWith('/')) {
        appBase = appBase.substring(0, appBase.length - 1);
      }
    } else {
      appBase = '';
    }

    link = "".concat(appBase).concat(link);
  } else {
    pathParts = link.split('?');

    if (pathParts.length > 1) {
      base = pathParts[0];
      query = pathParts[1];
    }

    searchParams = new URLSearchParams(query);
    searchParams.append('cid', companyId);
    query = searchParams.toString();
    link = "".concat(base, "?").concat(query);
  }

  return link;
}

function matchPathUtil (path, route) {
  var location;
  var currentPath;
  var isMatch = false;

  if (route && route.fullPath) {
    //then we're on a vue-ui route
    location = route.fullPath;
  } else {
    location = window.location.pathname;
  }

  currentPath = location + window.location.search;
  isMatch = currentPath.includes(path);
  return isMatch;
}

var script$g = {
  name: 'VueMenuItem',
  components: {
    ContextMenu: __vue_component__$f,
    Draggable: Draggable
  },
  data: function data() {
    return {
      isSubMenuOpen: false,
      isOpen: false,
      openClass: 'is-open',
      activeClass: 'is-active',
      selectedRouteClass: 'is-selected-route',
      leafParentClass: 'is-leaf-parent',
      menuItemClass: 'menu-item__link',
      contextMenuActive: false,
      itemsInOrder: [],
      childRoutes: [],
      currentTranslateY: '',
      resizeId: null
    };
  },
  props: {
    menuItem: {
      type: Object,
      default: undefined
    },
    isTopLevel: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: Number,
      default: undefined
    },
    topLevelParentId: {
      type: Number
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    parentMenuIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  mixins: [propsMixin$1],
  created: function created() {
    this.reponsibleForUserInfo = true;
    var me = this;

    if (this.isFavoritesParent) {
      this.menuItem.childItems.forEach(function (element) {
        me.itemsInOrder.push(_objectSpread2({}, element));
      });
    }
  },
  mounted: function mounted() {
    document.addEventListener('click', this.handleDocumentClicked);
    document.addEventListener('auxclick', this.handleDocumentClicked);

    if (this.isMain || this.isSub) {
      window.addEventListener('resize', this.handleResize);
    }
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClicked);
    document.removeEventListener('auxclick', this.handleDocumentClicked);

    if (this.isMain || this.isSub) {
      window.removeEventListener('resize', this.handleResize);
    }
  },
  computed: _objectSpread2(_objectSpread2({}, mapGetters('user', ['isFavorite', 'mainItemClickedId', 'lastItemClickedId', 'appName', 'vueAppBase', 'currentRouteMenuId', 'lastMainItemClickedId'])), {}, {
    pathMenuIds: function pathMenuIds() {
      var ids = this.parentMenuIds;
      ids.push(this.menuItem.id);
      return ids;
    },
    menuLink: function menuLink() {
      var link = this.menuItem.itemValue;

      if (!this.isMain && !this.isSub) {
        link = getMenuItemLink(this.menuItem, this.companyId, this.vueAppBase);
      }

      return link;
    },
    menuLinkNoBase: function menuLinkNoBase() {
      var link = this.menuItem.itemValue;

      if (!this.isMain && !this.isSub) {
        link = getMenuItemLink(this.menuItem, this.companyId);
      }

      return link;
    },
    isFavoritesParent: function isFavoritesParent() {
      return this.menuItem.itemText === 'Favorites';
    },
    contextMenuOptions: function contextMenuOptions() {
      var menuOptions = [{
        text: 'Open in a new tab',
        action: this.openInNewTab
      }];

      if (this.isFavorite(this.menuItem)) {
        menuOptions.push({
          text: 'Remove from Favorites',
          action: this.removeFromFavorites
        });
      } else {
        menuOptions.push({
          text: 'Add to Favorites',
          action: this.addToFavorites
        });
      }

      return menuOptions;
    },
    hasSubMenu: function hasSubMenu() {
      if (this.menuItem.childItems.length > 0) {
        return true;
      }

      return false;
    },
    iconClass: function iconClass() {
      var className;

      if (this.menuItem.iconClass) {
        className = this.menuItem.iconClass;
      } else if (this.isTopLevel) {
        if (Object.prototype.hasOwnProperty.call(menuItemIcons, this.menuItem.itemText)) {
          className = menuItemIcons[this.menuItem.itemText];
        }
      }

      return className;
    },
    dragOptions: function dragOptions() {
      return {
        animation: 200,
        group: 'description',
        ghostClass: 'sortable-ghost'
      };
    },
    currentClassList: function currentClassList() {
      var classList = [this.menuItemClass]; //let foundChildItem;

      if (this.isOpen || this.isTopLevel) {
        //only main sub menus can be open
        if (this.isOpen) {
          this.addClass(this.openClass, classList);

          if (this.menuItem.id === this.lastItemClickedId) {
            this.addClass(this.activeClass, classList);

            if (this.isMain || this.isSub) {
              this.addClass(this.leafParentClass, classList);
            }
          }

          if (this.isTopLevel) {
            this.addClass(this.selectedRouteClass, classList);
          }
        } else {
          this.removeClass(this.openClass, classList);
          this.removeClass(this.activeClass, classList);
          this.removeClass(this.leafParentClass, classList);

          if (this.menuItem.id === this.mainItemClickedId) {
            var childMatch = this.findChildItem(this.menuItem);

            if (childMatch) {
              this.addClass(this.selectedRouteClass, classList);
            } else {
              this.removeClass(this.selectedRouteClass, classList);
            }
          } else {
            this.removeClass(this.selectedRouteClass, classList);
          }
        }
      } else {
        //if top level parent is open
        //if menu link, active if matches route
        //is submenu, active and open if a child matches route
        if (this.topLevelParentId === this.mainItemClickedId) {
          if (this.isSub && this.itemIdInPath(this.lastMainItemClickedId)) {
            var _childMatch = this.findChildItem(this.menuItem);

            if (_childMatch) {
              this.addClass(this.openClass, classList);
              this.addClass(this.activeClass, classList);
            }
          } else if (this.matchPath(this.menuItem, this.$route)) {
            this.addClass(this.activeClass, classList);
          }
        }
      }

      return classList;
    },
    isMain: function isMain() {
      var path = this.menuItem.itemValue;
      var test = path.endsWith('MAIN');
      return test;
    },
    isSub: function isSub() {
      var path = this.menuItem.itemValue;
      var test = path.endsWith('SUB');
      return test;
    },
    currentRouteMatch: function currentRouteMatch() {
      var result = false;
      var currentRoute = this.$route.fullPath;

      if (this.menuLinkNoBase.toLowerCase() === currentRoute.toLowerCase()) {
        result = true;
      }

      return result;
    }
  }),
  methods: _objectSpread2(_objectSpread2({}, mapActions('user', ['addToFavoritesAction', 'removeFromFavoritesAction', 'orderFavoritesAction', 'setMainItemClickedAction', 'setLastItemClickedAction', 'setMenuIsOpen', 'setCurrentRouteMenuIdAction', 'setLastMainItemClickedAction'])), {}, {
    itemIdInPath: function itemIdInPath(id) {
      var result = false;

      if (this.pathMenuIds && this.pathMenuIds.indexOf(id) >= 0 || this.itemIsChild(id, this.menuItem.childItems)) {
        result = true;
      }

      return result;
    },
    itemIsChild: function itemIsChild(id, childItems) {
      var result = false;

      if (childItems) {
        for (var index = 0; index < childItems.length; index++) {
          var item = childItems[index];

          if (item.id === id) {
            result = true;
            break;
          } else {
            result = this.itemIsChild(id, item.childItems);

            if (result) {
              break;
            }
          }
        }
      }

      return result;
    },
    matchPath: function matchPath(menuItem, route) {
      var idMatch = menuItem.id === this.currentRouteMenuId;
      var routeMatch = false;

      if (idMatch) {
        routeMatch = matchPathUtil(getMenuItemLink(menuItem, this.companyId), route);
      }

      return idMatch && routeMatch;
    },
    onItemsOrderChange: function onItemsOrderChange(e) {
      var movedItem = this.menuItem.childItems[e.moved.oldIndex];
      var targetItem = this.menuItem.childItems[e.moved.newIndex];
      var newOrder = targetItem.order;
      this.orderFavoritesAction({
        menuItem: movedItem,
        companyId: this.companyId,
        order: newOrder
      });
    },
    openInNewTab: function openInNewTab() {
      var href = this.menuLink;
      window.open(href, '_blank');
    },
    addToFavorites: function addToFavorites() {
      this.addToFavoritesAction({
        menuItem: this.menuItem,
        companyId: this.companyId
      });
      this.closeContextMenu();
    },
    removeFromFavorites: function removeFromFavorites() {
      this.removeFromFavoritesAction({
        menuItem: this.menuItem,
        companyId: this.companyId
      });
      this.closeContextMenu();
    },
    open: function open() {
      this.isOpen = true;
    },
    close: function close() {
      this.isOpen = false; // if (
      // 	this.isMobile &&
      // 	e.srcElement.id !== 'menu-button-icon' &&
      // 	e.srcElement.id !== 'menu-button'
      // ) {
      // 	//this.setMenuIsOpen(false);
      // }
    },
    addClass: function addClass(className, classList) {
      classList.push(className);
    },
    removeClass: function removeClass(className, classList) {
      var index = classList.indexOf(className);

      if (index >= 0) {
        classList.splice(index, 1);
      }
    },
    handleDocumentClicked: function handleDocumentClicked(event) {
      var target = event.target;
      var $el = this.$el;

      if (!$el.contains(target)) {
        this.close();
      }
    },
    handleAuxClick: function handleAuxClick(e) {
      if (e.button == 1) {
        this.handleClick(e);
      }
    },
    handleClick: function handleClick(e) {
      this.setLastItemClickedAction(this.menuItem);

      if (this.isMain || this.isSub) {
        e.preventDefault();
        this.setLastMainItemClickedAction(this.menuItem.id);

        if (this.isOpen) {
          this.close();
        } else {
          this.open();
        }

        this.transform();
      } else {
        //then we clicked an item that's navigating
        //emit an event that will tell the parent menut items to close
        if (this.menuItem.linkType == 2) {
          if (this.appName === 'vue-ui') {
            //if a limilight page, do a router navigate instead href click
            e.preventDefault();

            if (!this.currentRouteMatch) {
              this.$router.push({
                path: this.menuLinkNoBase
              });
            }
          }
        }

        this.setCurrentRouteMenuIdAction(this.menuItem.id);
        this.setMainItemClickedAction(this.topLevelParentId);
        this.$emit('linkClick');
      }
    },
    showContextMenu: function showContextMenu(e) {
      if (this.menuItem.itemText !== 'Dashboard' && this.menuItem.itemText !== 'MyVUE') {
        e.preventDefault();

        if (this.isMain || this.isSub) {
          return false;
        } else {
          if (!this.contextMenuActive) {
            this.contextMenuActive = true;
          }
        }
      }
    },
    closeContextMenu: function closeContextMenu() {
      this.contextMenuActive = false;
    },
    findChildItem: function findChildItem(menuItem) {
      var _this = this;

      var foundItem;
      var childFoundItem; //for top level menu with no children (like Dashboard)

      if (this.matchPath(menuItem, this.$route)) {
        return menuItem;
      } //check if we've stored this route in child routes
      //so we don't need to re-do the search
      //NOTE: this will only work when routing -- not when loading pages


      var childRouteIndex = this.childRoutes.findIndex(function (cr) {
        return _this.matchPath(cr, _this.$route);
      });

      if (childRouteIndex >= 0) {
        return menuItem;
      }

      if (menuItem.childItems && menuItem.childItems.length > 0) {
        for (var index = 0; index < menuItem.childItems.length; index++) {
          var currentItem = menuItem.childItems[index];

          if (this.matchPath(currentItem, this.$route)) {
            foundItem = currentItem;
            break;
          } else if (currentItem.childItems && currentItem.childItems.length > 0) {
            childFoundItem = this.findChildItem(currentItem);

            if (childFoundItem) {
              foundItem = childFoundItem;
              break;
            }
          }
        }
      }

      if (foundItem) {
        //add the menu item route to the child route collection
        //so we don't need to re-do this search
        if (this.childRoutes.indexOf(foundItem) < 0) {
          this.childRoutes.push(foundItem);
        }
      }

      return foundItem;
    },
    onLinkClick: function onLinkClick() {
      //then we clicked an item that's navigating
      //emit an event that will tell the parent menut items to close
      this.$emit('linkClick');
      this.close();
    },
    handleResize: function handleResize() {
      clearTimeout(this.resizeId);
      this.resizeId = setTimeout(this.transform, 100);
    },
    transform: function transform() {
      this.$nextTick(this.execTransform);
    },
    execTransform: function execTransform() {
      var subMenu = this.$refs.subMenu;
      subMenu.$el.style.transform = 'translateY(0px)';

      if (subMenu && (this.isMain || this.isSub) && this.isOpen) {
        var windowHeight = window.innerHeight;
        var menuBottom = subMenu.$el.getBoundingClientRect().bottom;
        var diff = menuBottom - windowHeight > 0 ? menuBottom - windowHeight + 4 : 0;
        subMenu.$el.style.transform = "translateY(".concat(-diff, "px)");
      }
    }
  })
};

var __vue_script__$g = script$g;
/* template */

var __vue_render__$g = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "menu-item"
  }, [_vm.contextMenuActive ? _c('ContextMenu', {
    ref: "contextMenu",
    attrs: {
      "options": _vm.contextMenuOptions
    },
    on: {
      "onClose": _vm.closeContextMenu
    }
  }) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "menuItemLink",
    class: _vm.currentClassList,
    attrs: {
      "href": _vm.menuLink,
      "data-id": "menu-item-link",
      "title": _vm.menuItem.itemText
    },
    on: {
      "auxclick": _vm.handleAuxClick,
      "click": _vm.handleClick,
      "contextmenu": _vm.showContextMenu,
      "blur": _vm.closeContextMenu
    }
  }, [_c('span', {
    staticClass: "menu-item__link-icon"
  }, [_c('i', {
    class: ['icon', _vm.iconClass],
    attrs: {
      "alt": _vm.menuItem.itemText
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "menu-item__link-label",
    attrs: {
      "data-id": "menu-item-text"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.menuItem.itemText) + "\n\t\t")]), _vm._v(" "), _vm.hasSubMenu ? _c('span', {
    staticClass: "menu-item__expand-icon"
  }, [_c('i', {
    staticClass: "icon icon-arrow_right_filled"
  })]) : _vm._e()]), _vm._v(" "), _vm.menuItem.childItems ? _c('Draggable', _vm._b({
    ref: "subMenu",
    staticClass: "menu-item__sub-menu",
    class: _vm.isFavoritesParent && 'is-favorite-parent',
    attrs: {
      "tag": "ul",
      "data-id": "child-items",
      "disabled": !_vm.isFavoritesParent
    },
    on: {
      "change": _vm.onItemsOrderChange
    },
    model: {
      value: _vm.itemsInOrder,
      callback: function callback($$v) {
        _vm.itemsInOrder = $$v;
      },
      expression: "itemsInOrder"
    }
  }, 'Draggable', _vm.dragOptions, false), _vm._l(_vm.menuItem.childItems, function (childItem) {
    return _c('li', {
      key: childItem.id,
      staticClass: "menu-item__sub-menu-item"
    }, [_c('VueMenuItem', {
      attrs: {
        "menuItem": childItem,
        "topLevelParentId": _vm.topLevelParentId,
        "parentMenuIds": _vm.parentMenuIds.concat([_vm.menuItem.id]),
        "isMobile": _vm.isMobile,
        "companyId": _vm.companyId
      },
      on: {
        "linkClick": _vm.onLinkClick
      }
    })], 1);
  }), 0) : _vm._e()], 1);
};

var __vue_staticRenderFns__$g = [];
/* style */

var __vue_inject_styles__$g = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-2c261128_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-2c261128]:export{menubreakpoint:992}[data-v-2c261128]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-2c261128]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-2c261128],body.light[data-v-2c261128]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}@media (min-width:62em){.vue-side-menu:not(.is-expanded) .root-item.menu-item>.menu-item__link>.menu-item__link-icon[data-v-2c261128]{margin-right:0}.vue-side-menu:not(.is-expanded) .root-item.menu-item>.menu-item__link>.menu-item__link-label[data-v-2c261128]{display:none}.vue-side-menu:not(.is-expanded) .root-item.menu-item>.menu-item__link>.menu-item__expand-icon[data-v-2c261128]{transition-delay:0s;font-size:0;opacity:0;margin-left:0}}@media (min-width:62em) and (min-width:62em){.vue-side-menu.is-expanded .root-item.menu-item>.menu-item__link[data-v-2c261128]{justify-content:flex-start}.vue-side-menu.is-expanded .root-item.menu-item>.menu-item__link>.menu-item__link-label[data-v-2c261128]{padding-left:4px}}.vue-side-menu .root-item.menu-item>.menu-item__link[data-v-2c261128]{padding-left:13.5px}.vue-side-menu .root-item.menu-item>.menu-item__link.is-selected-route>.menu-item__link-icon .icon[data-v-2c261128]{position:relative;color:var(--layout_bg-brand-1-fg-3)}.vue-side-menu .root-item.menu-item>.menu-item__link.is-selected-route>.menu-item__link-icon .icon[data-v-2c261128]::before{position:relative;z-index:2100}.vue-side-menu .root-item.menu-item>.menu-item__link.is-selected-route>.menu-item__link-icon .icon[data-v-2c261128]::after{background:var(--layout_bg-brand-1);position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);content:\"\";width:26px;height:26px;border-radius:4px}.vue-side-menu .root-item.menu-item>.menu-item__link[data-v-2c261128]:focus-visible{outline:2px solid var(--layout_brand-2);outline-offset:-2px}.menu-item[data-v-2c261128]{font-size:13px;position:relative}.menu-item__link[data-v-2c261128]{display:inline-flex;justify-content:flex-start;align-items:center;width:100%;padding:8px;line-height:16px}.menu-item__link.is-open[data-v-2c261128]{background:var(--layout_bg-2);color:var(--layout_bg-2-fg-3)}.menu-item__link.is-open+.menu-item__sub-menu[data-v-2c261128]{display:block}@media (min-width:62em){.menu-item__link.is-open[data-v-2c261128]:hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_menu-list-fg-hover)}}@media (max-width:61.99em){.menu-item__link.is-open[data-v-2c261128]{background:0 0}.menu-item__link.is-open .menu-item__expand-icon[data-v-2c261128]{transform:rotate(90deg);transition:all .2s ease}.menu-item__link.is-open+.menu-item__sub-menu[data-v-2c261128]{border-left:2px solid var(--layout_neutral-1)}.menu-item__link.is-active[data-v-2c261128]{color:var(--layout_brand-1)}.menu-item__link.is-active+.menu-item__sub-menu[data-v-2c261128]{background-color:rgba(var(--layout_brand-1_rgb),.1);border-left:2px solid var(--layout_brand-1)}.menu-item__link.is-leaf-parent[data-v-2c261128]{color:var(--layout_brand-1)}.menu-item__link.is-leaf-parent+.menu-item__sub-menu[data-v-2c261128]{border-left:none}.menu-item__link.is-leaf-parent+.menu-item__sub-menu>.menu-item__sub-menu-item .menu-item .menu-item__link.is-active[data-v-2c261128]{background-color:rgba(var(--layout_brand-1_rgb),.1);color:var(--layout_bg-2-fg-3);border-left:2px solid var(--layout_brand-1)}}@media (min-width:62em){.menu-item__link.is-leaf-parent+.menu-item__sub-menu>.menu-item__sub-menu-item .menu-item .menu-item__link.is-active[data-v-2c261128]{background-color:var(--layout_bg-2);font-weight:700}.menu-item__link.is-leaf-parent+.menu-item__sub-menu>.menu-item__sub-menu-item .menu-item .menu-item__link.is-active[data-v-2c261128]:hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_menu-list-fg-hover)}.menu-item__link[data-v-2c261128]:hover{background:var(--layout_menu-list-bg-hover);color:var(--layout_menu-list-fg-hover)}}.menu-item__link-icon[data-v-2c261128]{font-size:20px;margin-right:8px}.menu-item__link-label[data-v-2c261128]{display:inline-block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.menu-item__expand-icon[data-v-2c261128]{transition-delay:.1s;transition-property:font-size;font-size:10px;width:initial;margin-left:auto;transition:all .2s ease}.menu-item__sub-menu[data-v-2c261128]{margin:0 16px;display:none;transition:transform .2s ease;transition-delay:.15s}@media (min-width:62em){.menu-item__sub-menu[data-v-2c261128]{position:absolute;top:0;left:100%;width:200px;margin:0;border-left:none;background:var(--layout_bg-0);border:1px solid var(--layout_neutral-1);box-shadow:0 1px 1px rgba(0,0,0,.2)}}.menu-item__sub-menu.is-favorite-parent[data-v-2c261128]{overflow:auto;max-height:75vh}.menu-item__sub-menu.is-favorite-parent>.menu-item__sub-menu-item>.menu-item>.menu-item__link[data-v-2c261128]{cursor:move}.menu-item__sub-menu.is-favorite-parent>.menu-item__sub-menu-item.sortable-ghost[data-v-2c261128]{opacity:.2}.menu-item__sub-menu .menu-item__link[data-v-2c261128]{padding-left:16px}.menu-item__sub-menu .menu-item__link-icon[data-v-2c261128]{display:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$g = "data-v-2c261128";
/* module identifier */

var __vue_module_identifier__$g = undefined;
/* functional template */

var __vue_is_functional_template__$g = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, createInjector, undefined, undefined);

var script$h = {
  name: 'VueUiMenu',
  components: {
    VueMenuItem: __vue_component__$g
  },
  props: {
    preExpand: {
      type: Boolean,
      default: false
    },
    showExpandButton: {
      type: Boolean,
      default: true
    },
    alwaysDesktop: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      activeMode: 'light',
      brandingVars: {},
      childMenus: 0,
      dashboardMenuItem: {
        id: -2,
        itemText: 'Dashboard',
        itemValue: '/',
        iconClass: 'icon-home-2',
        order: 1,
        childItems: []
      },
      windowWidth: window.innerWidth,
      breakpoint: 992,
      //breakpointVars.menubreakpoint
      menuCompanyId: getCompanyId(this.$route)
    };
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.onWindowResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize);
  },
  mixins: [propsMixin$1],
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.reponsibleForUserInfo = true;
              _context.next = 3;
              return _this.getMenuResultsAction(getCompanyId(_this.$route));

            case 3:
              if (_this.preExpand) {
                _this.setMenuIsExpanded(true);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: _objectSpread2(_objectSpread2({}, mapGetters('user', ['isMenuOpen', 'isMenuExpanded', 'menuResults'])), {}, {
    menuItems: function menuItems() {
      var items;

      if (this.menuResults !== undefined) {
        items = this.menuResults.childItems;
      }

      return items;
    },
    menuHiddenClass: function menuHiddenClass() {
      var hiddenClass = '';

      if (this.isMobile && !this.isMenuOpen) {
        hiddenClass = 'is-hidden';
      }

      return hiddenClass;
    },
    isMobile: function isMobile() {
      if (this.alwaysDesktop) {
        return false;
      }

      return this.windowWidth <= this.breakpoint;
    }
  }),
  methods: _objectSpread2(_objectSpread2({}, mapActions('user', ['setMenuIsExpanded', 'getMenuResultsAction', 'setMenuIsOpen'])), {}, {
    handleExpandableMenu: function handleExpandableMenu() {
      this.setMenuIsExpanded(!this.isMenuExpanded);
    },
    onWindowResize: function onWindowResize() {
      this.windowWidth = window.innerWidth;
    }
  })
};

/* script */
var __vue_script__$h = script$h;
/* template */

var __vue_render__$h = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: ['vue-side-menu', _vm.menuHiddenClass, _vm.isMenuExpanded && 'is-expanded'],
    style: _vm.brandingVars,
    attrs: {
      "mode": _vm.activeMode,
      "data-testid": "menu-div"
    }
  }, [_c('ul', {
    staticClass: "vue-side-menu__root-menu"
  }, [_vm.showExpandButton ? _c('li', {
    staticClass: "vue-side-menu__expand-btn",
    attrs: {
      "data-testid": "expand-li"
    },
    on: {
      "click": _vm.handleExpandableMenu
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('li', [_c('VueMenuItem', {
    staticClass: "root-item",
    attrs: {
      "menuItem": _vm.dashboardMenuItem,
      "isMenuExpanded": _vm.isMenuExpanded,
      "isTopLevel": true,
      "isMobile": _vm.isMobile,
      "companyId": _vm.menuCompanyId
    }
  })], 1), _vm._v(" "), _vm._l(_vm.menuItems, function (menuItem) {
    return _c('li', {
      key: menuItem.id,
      staticClass: "vue-side-menu__root-item"
    }, [menuItem.itemText == 'MyVUE' ? _c('hr', {
      staticClass: "vue-side-menu__divider"
    }) : _vm._e(), _vm._v(" "), _c('VueMenuItem', {
      staticClass: "root-item",
      attrs: {
        "menuItem": menuItem,
        "isMenuExpanded": _vm.isMenuExpanded,
        "isTopLevel": true,
        "topLevelParentId": menuItem.id,
        "parentMenuIds": [menuItem.id],
        "isMobile": _vm.isMobile,
        "companyId": _vm.menuCompanyId
      }
    }), _vm._v(" "), menuItem.itemText == 'Favorites' ? _c('hr', {
      staticClass: "vue-side-menu__divider"
    }) : _vm._e()], 1);
  })], 2)]);
};

var __vue_staticRenderFns__$h = [function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('span', {
    staticClass: "vue-side-menu__expand-icon"
  }, [_c('i', {
    staticClass: "icon icon-arrow-right-circle"
  })]);
}];
/* style */

var __vue_inject_styles__$h = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-7c33f263_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-7c33f263]:export{menubreakpoint:992}[data-v-7c33f263]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-7c33f263]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-7c33f263],body.light[data-v-7c33f263]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}[data-v-7c33f263]{@import url(\"https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap\");}[data-v-7c33f263] *{font-family:Lato,sans-serif}[data-v-7c33f263] *,[data-v-7c33f263] ::after,[data-v-7c33f263] ::before{box-sizing:border-box}[data-v-7c33f263] li{list-style:none}[data-v-7c33f263] li::marker{content:none}[data-v-7c33f263] h1,[data-v-7c33f263] h2,[data-v-7c33f263] h3,[data-v-7c33f263] h4,[data-v-7c33f263] h5{margin:0}[data-v-7c33f263] h1{font-size:30px;line-height:36px}[data-v-7c33f263] h2{font-size:24px;line-height:30px}[data-v-7c33f263] h3{font-size:18px;line-height:23px}[data-v-7c33f263] h4{font-size:16px;line-height:19px}[data-v-7c33f263] h5{font-size:14px;line-height:18px}[data-v-7c33f263] p{font-size:16px;margin-block-start:0;margin-block-end:0}[data-v-7c33f263] img{display:inline-block;max-width:100%;max-height:100%}[data-v-7c33f263] button{background:0 0;border:none;padding:none;padding:0;margin:0;cursor:pointer}[data-v-7c33f263] button:focus{outline:0}[data-v-7c33f263] :-ms-input-placeholder,[data-v-7c33f263] ::-moz-placeholder,[data-v-7c33f263] ::-webkit-input-placeholder,[data-v-7c33f263] ::placeholder,[data-v-7c33f263] input::-webkit-input-placeholder{font-size:14px;line-height:normal;color:var(--placeholder)}[data-v-7c33f263] a{text-decoration:none;outline:0}[data-v-7c33f263] .is-hidden{display:none}[data-v-7c33f263] *,[data-v-7c33f263] ::after,[data-v-7c33f263] ::before{box-sizing:border-box}[data-v-7c33f263] ul{margin:0;margin-block-start:0;margin-block-end:0;padding:0;padding-inline-start:0;box-sizing:border-box}[data-v-7c33f263] a{background-color:transparent;color:inherit}.vue-side-menu[data-v-7c33f263]{display:inline-block;position:fixed;background:var(--layout_bg-0);color:var(--layout_bg-0-fg-4);width:100%;height:calc(100vh - 49px);top:48px;overflow-y:auto;z-index:6000}.vue-side-menu.is-hidden[data-v-7c33f263]{display:none}.vue-side-menu[data-v-7c33f263]::-webkit-scrollbar{display:none}.vue-side-menu__root-menu[data-v-7c33f263]{padding:16px 0}@media (min-width:62em){.vue-side-menu__root-menu[data-v-7c33f263]{padding-top:0}}.vue-side-menu__item[data-v-7c33f263]{position:relative}.vue-side-menu__divider[data-v-7c33f263]{width:92%;margin-block-start:12px;margin-block-end:12px;margin-inline-start:auto;margin-inline-end:auto;border:0;height:1px;background:var(--layout_bg-0-fg-1);transition:80ms all ease}@media (min-width:62em){.vue-side-menu__divider[data-v-7c33f263]{width:28px}}.vue-side-menu__expand-btn[data-v-7c33f263]{display:none}@media (min-width:62em){.vue-side-menu__expand-btn[data-v-7c33f263]{display:flex;justify-content:center}}.vue-side-menu__expand-icon[data-v-7c33f263]{display:inline-flex;font-size:20px;padding:8px;cursor:pointer}.vue-side-menu.is-expanded[data-v-7c33f263]{box-shadow:6px 0 5px -4px #cbcbcb}@media (min-width:62em){.vue-side-menu.is-expanded[data-v-7c33f263]{width:200px}.vue-side-menu.is-expanded .vue-side-menu__expand-btn[data-v-7c33f263]{justify-content:flex-end}.vue-side-menu.is-expanded .vue-side-menu__expand-icon[data-v-7c33f263]{transform:scaleX(-1);padding:8px}.vue-side-menu.is-expanded .item__btn-label[data-v-7c33f263]{display:inline}.vue-side-menu.is-expanded .vue-side-menu__divider[data-v-7c33f263]{width:180px;transition-delay:0}}@media (min-width:36em){.vue-side-menu[data-v-7c33f263]{width:280px;border-right:1px solid #cbcbcb}}@media (min-width:62em){.vue-side-menu[data-v-7c33f263]{overflow-y:initial;width:48px;transition:80ms all ease}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$h = "data-v-7c33f263";
/* module identifier */

var __vue_module_identifier__$h = undefined;
/* functional template */

var __vue_is_functional_template__$h = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, createInjector, undefined, undefined);

//
//
//
//
//
//
//
//

/* DEV NOTE:  The js logic is for testing purpose only. 
              Please complete the logic and make any necesary change. 
              We need to display the tooltip on the middle of the tracked element (for the moment, maybe we will have variants or a position prop).
              Clean all events
              Make sure there is only one instance in the DOM
*/
var script$i = {
  name: 'Tooltip',
  data: function data() {
    return {
      visible: false,
      tooltipPos: {
        top: 0,
        left: 0
      }
    };
  },
  props: {
    track: {
      type: String,
      default: null
    }
  },
  mounted: function mounted() {
    var _this = this;

    var hoverTrackedElement = document.querySelector("#".concat(this.track));
    if (!hoverTrackedElement) return;

    if (hoverTrackedElement) {
      hoverTrackedElement.addEventListener('mouseenter', function () {
        _this.visible = true;
        document.body.appendChild(_this.$el);
        _this.tooltipPos.top = hoverTrackedElement.getBoundingClientRect().top - 32 + 'px';
        _this.tooltipPos.left = hoverTrackedElement.getBoundingClientRect().left - 50 + 'px';
      });
      hoverTrackedElement.addEventListener('mouseleave', function () {
        _this.visible = false;
      });
    }
  }
};

/* script */
var __vue_script__$i = script$i;
/* template */

var __vue_render__$i = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.visible ? _c('span', {
    staticClass: "tooltip",
    style: _vm.tooltipPos
  }, [_vm._t("default")], 2) : _vm._e()]);
};

var __vue_staticRenderFns__$i = [];
/* style */

var __vue_inject_styles__$i = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-18c323dc_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-18c323dc]:export{menubreakpoint:992}[data-v-18c323dc]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-18c323dc]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-18c323dc],body.light[data-v-18c323dc]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}.tooltip[data-v-18c323dc]{position:absolute;display:inline-block;padding:8px 16px;font-size:12px;border-radius:4px;background:var(--layout_tooltip-bg);color:var(--layout_tooltip-fg);white-space:nowrap;z-index:14000}.fade-enter[data-v-18c323dc],.fade-leave-to[data-v-18c323dc]{opacity:0}.fade-enter-active[data-v-18c323dc],.fade-leave-active[data-v-18c323dc]{transition:opacity .1 ease}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$i = "data-v-18c323dc";
/* module identifier */

var __vue_module_identifier__$i = undefined;
/* functional template */

var __vue_is_functional_template__$i = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, createInjector, undefined, undefined);

var script$j = {
  name: 'VersionSwitch',
  components: {
    Tooltip: __vue_component__$i,
    Popover: Popover
  },
  data: function data() {
    return {
      selectedVersion: this.version,
      displaySwitcher: false,
      popoverCloseClicked: false
    };
  },
  props: {
    version: {
      type: Number,
      required: true
    },
    // DEV NOTE: when the user first sees the popover and closes it, this variable will be true.
    alreadyDisplayed: {
      type: Boolean,
      default: false
    },
    setPageVersion: {
      type: Boolean,
      default: false
    },
    popoverOptions: {
      type: Object,
      default: function _default() {
        return {
          container: 'app',
          zIndex: 1000
        };
      }
    }
  },
  created: function created() {
    this.selectedVersion = this.version;

    if (this.setPageVersion) {
      this.setPageVersionConfigKeyId(this.$route);
    }
  },
  methods: _objectSpread2(_objectSpread2({}, mapActions('user', ['switchVersionAction', 'setPageVersionConfigKeyIdAction'])), {}, {
    switchVersion: function switchVersion() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit('startChange', _this.selectedVersion);

                _context.next = 3;
                return _this.switchVersionAction({
                  version: _this.selectedVersion,
                  companyId: getCompanyId(_this.$route),
                  configurationKeyId: _this.configurationKeyId,
                  employeeId: _this.employeeId
                });

              case 3:
                _this.$emit('change', _this.selectedVersion);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    toggleSwitcher: function toggleSwitcher(e) {
      e.stopPropagation();
      this.displaySwitcher = !this.displaySwitcher;
    },
    onPopoverClose: function onPopoverClose() {
      this.setPopoverShown();
      this.popoverCloseClicked = true;
    },
    setPopoverShown: function setPopoverShown() {
      cookies.set(this.popoverShownCookieKey, true, '7d');
    },
    isPopoverShown: function isPopoverShown() {
      var shownVal = cookies.get(this.popoverShownCookieKey);
      var shown = false;

      if (shownVal) {
        shown = shownVal === 'true';
      }

      return shown;
    },
    setPageVersionConfigKeyId: function setPageVersionConfigKeyId(route) {
      var id = 0;

      if (route.meta && route.meta.accessWebRoute && route.meta.configKeyId) {
        id = route.meta.configKeyId;
      }

      this.setPageVersionConfigKeyIdAction(id);
    }
  }),
  computed: _objectSpread2(_objectSpread2({}, mapGetters('user', ['employeeId', 'pageVersionConfigKeyId'])), {}, {
    showTooltip: function showTooltip() {
      return !this.popoverVisible;
    },
    popoverShownCookieKey: function popoverShownCookieKey() {
      return "".concat(this.configurationKeyId, "_shown");
    },
    configurationKeyId: function configurationKeyId() {
      return this.pageVersionConfigKeyId;
    },
    visible: function visible() {
      return this.configurationKeyId > 0;
    },
    popoverVisible: function popoverVisible() {
      var isVisible = this.popoverCloseClicked;

      if (this.pageVersionConfigKeyId > 0) {
        isVisible = !this.isPopoverShown();
      }

      return isVisible;
    }
  }),
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route: function $route(to, from) {
      this.setPageVersionConfigKeyId(to);
    }
  }
};

/* script */
var __vue_script__$j = script$j;
/* template */

var __vue_render__$j = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.visible ? _c('div', {
    staticClass: "vue-version-switch"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.displaySwitcher,
      expression: "!displaySwitcher"
    }],
    ref: "vueVersionSwitch",
    staticClass: "vue-version-switch__display-switcher-btn",
    attrs: {
      "id": "vueVersionSwitch"
    },
    on: {
      "click": _vm.toggleSwitcher
    }
  }, [_c('i', {
    staticClass: "icon icon-swap"
  }), _vm._v(" "), _vm.showTooltip ? _c('Tooltip', [_vm._v("\n\t\t\tChange Screen Layout\n\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('Popover', {
    ref: "popover",
    attrs: {
      "trackedRefName": "vueVersionSwitch",
      "visible": _vm.popoverVisible,
      "placement": "right",
      "positionStrategy": "fixed",
      "container": _vm.popoverOptions.container,
      "zIndex": _vm.popoverOptions.zIndex,
      "offset": [0, 20]
    },
    on: {
      "close": _vm.onPopoverClose
    },
    scopedSlots: _vm._u([{
      key: "popoverTitle",
      fn: function fn() {
        return [_c('div', {
          staticClass: "vue-version-switch__popover-title"
        }, [_c('i', {
          staticClass: "icon icon-warning"
        }), _vm._v(" "), _c('span', {
          staticClass: "vue-version-switch__popover-title-text"
        }, [_vm._v("\n\t\t\t\t\tWe have a new look!\n\t\t\t\t")])])];
      },
      proxy: true
    }, {
      key: "popoverBody",
      fn: function fn() {
        return [_vm._v("\n\t\t\tClick here to enable the updated experience for this screen\n\t\t")];
      },
      proxy: true
    }], null, false, 3300136093)
  }), _vm._v(" "), _vm.displaySwitcher ? _c('div', {
    staticClass: "vue-version-switch__switcher"
  }, [_c('div', {
    staticClass: "vue-version-switch__option2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedVersion,
      expression: "selectedVersion"
    }],
    staticClass: "vue-version-switch__radio",
    attrs: {
      "type": "radio",
      "id": "version-2",
      "name": "versionSelector",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedVersion, "2")
    },
    on: {
      "change": [function ($event) {
        _vm.selectedVersion = "2";
      }, _vm.switchVersion]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "vue-version-switch__label",
    attrs: {
      "for": "version-2"
    }
  }, [_vm._v("\n\t\t\t\tModern\n\t\t\t")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "vue-version-switch__option1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.selectedVersion,
      expression: "selectedVersion"
    }],
    staticClass: "vue-version-switch__radio",
    attrs: {
      "type": "radio",
      "id": "version-1",
      "name": "versionSelector",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.selectedVersion, "1")
    },
    on: {
      "change": [function ($event) {
        _vm.selectedVersion = "1";
      }, _vm.switchVersion]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "vue-version-switch__label",
    attrs: {
      "for": "version-1"
    }
  }, [_vm._v("\n\t\t\t\tClassic\n\t\t\t")])]), _vm._v(" "), _vm.displaySwitcher ? _c('button', {
    staticClass: "vue-version-switch__hide-switcher",
    on: {
      "click": _vm.toggleSwitcher
    }
  }, [_c('i', {
    staticClass: "icon icon-remove"
  })]) : _vm._e()]) : _vm._e()], 1) : _vm._e();
};

var __vue_staticRenderFns__$j = [];
/* style */

var __vue_inject_styles__$j = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-16fbcd66_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-16fbcd66]:export{menubreakpoint:992}[data-v-16fbcd66]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-16fbcd66]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-16fbcd66],body.light[data-v-16fbcd66]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}[data-v-16fbcd66]{@import url(\"https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap\");}[data-v-16fbcd66] *{font-family:Lato,sans-serif}[data-v-16fbcd66] *,[data-v-16fbcd66] ::after,[data-v-16fbcd66] ::before{box-sizing:border-box}[data-v-16fbcd66] li{list-style:none}[data-v-16fbcd66] li::marker{content:none}[data-v-16fbcd66] h1,[data-v-16fbcd66] h2,[data-v-16fbcd66] h3,[data-v-16fbcd66] h4,[data-v-16fbcd66] h5{margin:0}[data-v-16fbcd66] h1{font-size:30px;line-height:36px}[data-v-16fbcd66] h2{font-size:24px;line-height:30px}[data-v-16fbcd66] h3{font-size:18px;line-height:23px}[data-v-16fbcd66] h4{font-size:16px;line-height:19px}[data-v-16fbcd66] h5{font-size:14px;line-height:18px}[data-v-16fbcd66] p{font-size:16px;margin-block-start:0;margin-block-end:0}[data-v-16fbcd66] img{display:inline-block;max-width:100%;max-height:100%}[data-v-16fbcd66] button{background:0 0;border:none;padding:none;padding:0;margin:0;cursor:pointer}[data-v-16fbcd66] button:focus{outline:0}[data-v-16fbcd66] :-ms-input-placeholder,[data-v-16fbcd66] ::-moz-placeholder,[data-v-16fbcd66] ::-webkit-input-placeholder,[data-v-16fbcd66] ::placeholder,[data-v-16fbcd66] input::-webkit-input-placeholder{font-size:14px;line-height:normal;color:var(--placeholder)}[data-v-16fbcd66] a{text-decoration:none;outline:0}[data-v-16fbcd66] .is-hidden{display:none}[data-v-16fbcd66] *,[data-v-16fbcd66] ::after,[data-v-16fbcd66] ::before{box-sizing:border-box}[data-v-16fbcd66] ul{margin:0;margin-block-start:0;margin-block-end:0;padding:0;padding-inline-start:0;box-sizing:border-box}[data-v-16fbcd66] a{background-color:transparent;color:inherit}.vue-version-switch[data-v-16fbcd66]{margin-left:8px}.vue-version-switch__display-switcher-btn[data-v-16fbcd66]{display:flex;background:0 0;border:none;cursor:pointer;font-size:22px;cursor:pointer}.vue-version-switch__hide-switcher[data-v-16fbcd66]{background:0 0;border:none;cursor:pointer;display:inline-flex;margin-left:2px;padding:4px}.vue-version-switch__hide-switcher[data-v-16fbcd66]:active,.vue-version-switch__hide-switcher[data-v-16fbcd66]:focus{outline:2px solid var(--layout_brand-2)}.vue-version-switch__switcher[data-v-16fbcd66]{display:flex;align-items:center;font-size:12px}.vue-version-switch__option1[data-v-16fbcd66],.vue-version-switch__option2[data-v-16fbcd66]{position:relative}.vue-version-switch__radio[data-v-16fbcd66]{appearance:none;-webkit-appearance:none;position:absolute}.vue-version-switch__radio:checked+.vue-version-switch__label[data-v-16fbcd66],.vue-version-switch__radio:focus+.vue-version-switch__label[data-v-16fbcd66],.vue-version-switch__radio:hover+.vue-version-switch__label[data-v-16fbcd66]{position:relative;background:#f1f9f1}.vue-version-switch__radio:checked+.vue-version-switch__label[data-v-16fbcd66]::after,.vue-version-switch__radio:focus+.vue-version-switch__label[data-v-16fbcd66]::after,.vue-version-switch__radio:hover+.vue-version-switch__label[data-v-16fbcd66]::after{content:\"\";position:absolute;left:-1px;position:absolute;top:50%;transform:translateY(-50%);width:calc(100% + 2px);height:calc(100% + 2px);border:2px solid #136a3e;z-index:2200}.vue-version-switch__label[data-v-16fbcd66]{padding:4px 16px;border:1px solid #7e7e7e;border-radius:2px;cursor:pointer}.vue-version-switch__label[data-v-16fbcd66]:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.vue-version-switch__label[data-v-16fbcd66]:last-child{margin-left:-1px;border-top-left-radius:0;border-bottom-left-radius:0}.vue-version-switch__popover-title[data-v-16fbcd66]{display:flex}.vue-version-switch__popover-title .icon.icon-warning[data-v-16fbcd66]{font-size:18px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$j = "data-v-16fbcd66";
/* module identifier */

var __vue_module_identifier__$j = undefined;
/* functional template */

var __vue_is_functional_template__$j = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, createInjector, undefined, undefined);

var script$k = {
  name: 'VueUiTitle',
  components: {
    VueVersionSwitch: __vue_component__$j
  },
  data: function data() {
    return {
      activeMode: 'light'
    };
  },
  props: {
    pageVersion: {
      type: Number,
      default: 1
    },
    setPageVersion: {
      type: Boolean,
      default: false
    },
    popoverOptions: {
      type: Object,
      default: function _default() {
        return {
          container: 'app',
          zIndex: 1000
        };
      }
    }
  },
  computed: _objectSpread2({}, mapGetters('user', ['pageTitle'])),
  methods: {
    onVersionChangeStart: function onVersionChangeStart(version) {
      this.$emit('versionChangeStart', version);
    },
    onVersionChange: function onVersionChange(version) {
      this.$emit('versionChange', version);
    }
  }
};

/* script */
var __vue_script__$k = script$k;
/* template */

var __vue_render__$k = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vue-title",
    attrs: {
      "id": "page_title",
      "mode": _vm.activeMode
    }
  }, [_c('p', {
    staticClass: "vue-title__text",
    attrs: {
      "data-testid": "title"
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.pageTitle) + "\n\t")]), _vm._v(" "), _c('VueVersionSwitch', {
    attrs: {
      "version": _vm.pageVersion,
      "setPageVersion": _vm.setPageVersion,
      "popoverOptions": _vm.popoverOptions
    },
    on: {
      "startChange": _vm.onVersionChangeStart,
      "change": _vm.onVersionChange
    }
  })], 1);
};

var __vue_staticRenderFns__$k = [];
/* style */

var __vue_inject_styles__$k = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-bd7e9d36_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-bd7e9d36]:export{menubreakpoint:992}[data-v-bd7e9d36]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-bd7e9d36]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-bd7e9d36],body.light[data-v-bd7e9d36]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}[data-v-bd7e9d36]{@import url(\"https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap\");}[data-v-bd7e9d36] *{font-family:Lato,sans-serif}[data-v-bd7e9d36] *,[data-v-bd7e9d36] ::after,[data-v-bd7e9d36] ::before{box-sizing:border-box}[data-v-bd7e9d36] li{list-style:none}[data-v-bd7e9d36] li::marker{content:none}[data-v-bd7e9d36] h1,[data-v-bd7e9d36] h2,[data-v-bd7e9d36] h3,[data-v-bd7e9d36] h4,[data-v-bd7e9d36] h5{margin:0}[data-v-bd7e9d36] h1{font-size:30px;line-height:36px}[data-v-bd7e9d36] h2{font-size:24px;line-height:30px}[data-v-bd7e9d36] h3{font-size:18px;line-height:23px}[data-v-bd7e9d36] h4{font-size:16px;line-height:19px}[data-v-bd7e9d36] h5{font-size:14px;line-height:18px}[data-v-bd7e9d36] p{font-size:16px;margin-block-start:0;margin-block-end:0}[data-v-bd7e9d36] img{display:inline-block;max-width:100%;max-height:100%}[data-v-bd7e9d36] button{background:0 0;border:none;padding:none;padding:0;margin:0;cursor:pointer}[data-v-bd7e9d36] button:focus{outline:0}[data-v-bd7e9d36] :-ms-input-placeholder,[data-v-bd7e9d36] ::-moz-placeholder,[data-v-bd7e9d36] ::-webkit-input-placeholder,[data-v-bd7e9d36] ::placeholder,[data-v-bd7e9d36] input::-webkit-input-placeholder{font-size:14px;line-height:normal;color:var(--placeholder)}[data-v-bd7e9d36] a{text-decoration:none;outline:0}[data-v-bd7e9d36] .is-hidden{display:none}[data-v-bd7e9d36] *,[data-v-bd7e9d36] ::after,[data-v-bd7e9d36] ::before{box-sizing:border-box}[data-v-bd7e9d36] ul{margin:0;margin-block-start:0;margin-block-end:0;padding:0;padding-inline-start:0;box-sizing:border-box}[data-v-bd7e9d36] a{background-color:transparent;color:inherit}.vue-title[data-v-bd7e9d36]{position:fixed;display:inline-flex;align-items:center;width:100%;top:48px;margin:0;padding:8px 16px;background-color:var(--layout_bg-0);color:var(--layout_bg-0-fg-4);z-index:4000}@media (min-width:62em){.vue-title[data-v-bd7e9d36]{padding-left:62px}}.vue-title__text[data-v-bd7e9d36]{margin:0;font-size:20px;font-weight:400;color:var(--layout_brand-2)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$k = "data-v-bd7e9d36";
/* module identifier */

var __vue_module_identifier__$k = undefined;
/* functional template */

var __vue_is_functional_template__$k = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, createInjector, undefined, undefined);

var script$l = {
  name: 'VueAlerts',
  mixins: [propsMixin$1],
  data: function data() {
    return {
      connection: undefined,
      username: '',
      checked: false,
      newMessage: '',
      messages: [],
      myConnectionId: '',
      ready: false
    };
  },
  props: {
    hideAfterSeconds: {
      type: Number,
      default: 5
    }
  },
  components: {
    NotificationList: __vue_component__$5,
    Toast: Toast
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.getUnShownNotificationsAction(getCompanyId(_this.$route));

            case 2:
              if (!_this.hubReady) {
                _context.next = 5;
                break;
              }

              _context.next = 5;
              return _this.addMessageHandlerAction({
                target: 'newMessage',
                handler: _this.onNewMessage
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  watch: {
    hubReady: function hubReady(newValue) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!newValue) {
                  _context2.next = 4;
                  break;
                }

                if (!newValue) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return _this2.addMessageHandlerAction({
                  target: 'newMessage',
                  handler: _this2.onNewMessage
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  computed: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, mapGetters('user', ['userToken', 'unShownNotificationItems', 'VUE_APP_SIGNALR_CONNECTION'])), mapGetters('hub', ['hubReady'])), mapGetters('communicationHub', ['activeToasts'])), {}, {
    hasAlerts: function hasAlerts() {
      return this.alerts.length > 0;
    },
    alerts: function alerts() {
      var alertItems = this.unShownNotificationItems;

      if (alertItems.length > 0) {
        this.setShownTimeout(alertItems);
      }

      return alertItems;
    }
  }),
  methods: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, mapActions('user', ['alertsShownAction', 'getUnShownNotificationsAction', 'dismissNotificationAction', 'addAlertAction'])), mapActions('hub', ['addMessageHandlerAction'])), mapActions('logging', ['logEventAction'])), mapActions('communicationHub', ['dismissToastAction'])), {}, {
    setShownTimeout: function setShownTimeout(alertItems) {
      var companyId = getCompanyId(this.$route);
      var timeoutMils = this.hideAfterSeconds * 1000;
      setTimeout(this.alertsShownAction, timeoutMils, {
        notificationItems: alertItems,
        companyId: companyId
      });
    },
    onNewMessage: function onNewMessage(message) {
      var messageObj = JSON.parse(message);
      this.addAlertAction(messageObj);
      this.setShownTimeout([messageObj]);
      this.logEventAction({
        data: {
          event: 'Receive New Alert',
          eventData: messageObj
        },
        route: this.$route,
        target: 'VueAlerts'
      });
    },
    onNotificationDismissed: function onNotificationDismissed(params) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.dismissNotificationAction(params);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  })
};

/* script */
var __vue_script__$l = script$l;
/* template */

var __vue_render__$l = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vue-alerts"
  }, [_vm.hasAlerts ? _c('NotificationList', {
    staticClass: "vue-alerts__items",
    attrs: {
      "items": _vm.alerts
    },
    on: {
      "dismissClick": _vm.onNotificationDismissed,
      "saveClick": _vm.onNotificationDismissed
    }
  }) : _vm._e(), _vm._v(" "), _c('ul', _vm._l(_vm.activeToasts, function (toast) {
    return _c('li', {
      key: toast.id
    }, [_c('Toast', {
      attrs: {
        "visible": true,
        "state": toast.state,
        "iconClassName": toast.iconClassName,
        "dismissibleTime": toast.dismissibleTime,
        "siteLevel": toast.siteLevel
      },
      on: {
        "removed": function removed($event) {
          return _vm.dismissToastAction(toast.id);
        },
        "close": function close($event) {
          return _vm.dismissToastAction(toast.id);
        }
      },
      scopedSlots: _vm._u([{
        key: "bodyMsg",
        fn: function fn() {
          return [_vm._v("\n\t\t\t\t\t" + _vm._s(toast.message) + "\n\t\t\t\t")];
        },
        proxy: true
      }], null, true)
    })], 1);
  }), 0)], 1);
};

var __vue_staticRenderFns__$l = [];
/* style */

var __vue_inject_styles__$l = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-44a226c1_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-44a226c1]:export{menubreakpoint:992}[data-v-44a226c1]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-44a226c1]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-44a226c1],body.light[data-v-44a226c1]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}[data-v-44a226c1]::-webkit-scrollbar{width:14px;background-color:var(--bg-0)}[data-v-44a226c1]::-webkit-scrollbar-track{box-shadow:inset 0 0 2px rgba(0,0,0,.2);background-color:var(--bg-0)}[data-v-44a226c1]::-webkit-scrollbar-thumb{background-color:var(--bg-0-fg-1);border-radius:14px;border:3px solid transparent;background-clip:content-box;min-height:16px}[data-v-44a226c1]::-webkit-scrollbar{width:14px;background-color:transparent}[data-v-44a226c1]::-webkit-scrollbar-track{border-top:1px solid transparent;box-shadow:none;background-color:transparent}[data-v-44a226c1]::-webkit-scrollbar-thumb{background-color:var(--bg-0-fg-1);border-radius:14px;border:3px solid transparent;background-clip:content-box}[data-v-44a226c1]{@import url(\"https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap\");}[data-v-44a226c1] *{font-family:Lato,sans-serif}[data-v-44a226c1] *,[data-v-44a226c1] ::after,[data-v-44a226c1] ::before{box-sizing:border-box}[data-v-44a226c1] li{list-style:none}[data-v-44a226c1] li::marker{content:none}[data-v-44a226c1] h1,[data-v-44a226c1] h2,[data-v-44a226c1] h3,[data-v-44a226c1] h4,[data-v-44a226c1] h5{margin:0}[data-v-44a226c1] h1{font-size:30px;line-height:36px}[data-v-44a226c1] h2{font-size:24px;line-height:30px}[data-v-44a226c1] h3{font-size:18px;line-height:23px}[data-v-44a226c1] h4{font-size:16px;line-height:19px}[data-v-44a226c1] h5{font-size:14px;line-height:18px}[data-v-44a226c1] p{font-size:16px;margin-block-start:0;margin-block-end:0}[data-v-44a226c1] img{display:inline-block;max-width:100%;max-height:100%}[data-v-44a226c1] button{background:0 0;border:none;padding:none;padding:0;margin:0;cursor:pointer}[data-v-44a226c1] button:focus{outline:0}[data-v-44a226c1] :-ms-input-placeholder,[data-v-44a226c1] ::-moz-placeholder,[data-v-44a226c1] ::-webkit-input-placeholder,[data-v-44a226c1] ::placeholder,[data-v-44a226c1] input::-webkit-input-placeholder{font-size:14px;line-height:normal;color:var(--placeholder)}[data-v-44a226c1] a{text-decoration:none;outline:0}[data-v-44a226c1] .is-hidden{display:none}[data-v-44a226c1] *,[data-v-44a226c1] ::after,[data-v-44a226c1] ::before{box-sizing:border-box}[data-v-44a226c1] ul{margin:0;margin-block-start:0;margin-block-end:0;padding:0;padding-inline-start:0;box-sizing:border-box}[data-v-44a226c1] a{background-color:transparent;color:inherit}.vue-alerts[data-v-44a226c1]{position:fixed;display:flex;justify-content:flex-end;top:66px;width:100%;max-width:1402px;z-index:8000;pointer-events:none}@media (max-width:87.625em){.vue-alerts[data-v-44a226c1]{padding-right:16px}}.vue-alerts__items[data-v-44a226c1]{pointer-events:auto;width:320px;height:525px;max-height:calc(100vh - 84px);overflow-y:auto}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$l = "data-v-44a226c1";
/* module identifier */

var __vue_module_identifier__$l = undefined;
/* functional template */

var __vue_is_functional_template__$l = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, createInjector, undefined, undefined);

var script$m = {
  name: 'VueWarning',
  components: {
    Modal: Modal
  },
  data: function data() {
    return {
      dismissed: false,
      message: null,
      description: null,
      interval: null,
      currentDateTime: new Date()
    };
  },
  computed: _objectSpread2(_objectSpread2({}, mapGetters('user', ['zoneWarning'])), {}, {
    isFinalWarning: function isFinalWarning() {
      if (!this.zoneWarning) return false;
      var deadline = new Date(this.zoneWarning.Deadline);
      return this.currentDateTime >= deadline;
    },
    visible: function visible() {
      return !!(this.zoneWarning && this.message && !this.dismissed);
    }
  }),
  methods: _objectSpread2(_objectSpread2({}, mapActions('user', ['setZoneWarning'])), {}, {
    acknowledgeWarning: function acknowledgeWarning() {
      if (this.isFinalWarning) this.refreshPage();

      if (this.zoneWarning && !this.interval) {
        this.interval = setInterval(this.updateWarningMessage, this.zoneWarning.IntervalMinutes * 60 * 1000);
      }

      this.dismissed = true;
    },
    updateWarningMessage: function updateWarningMessage() {
      this.dismissed = false;
      if (!this.zoneWarning) return;
      this.currentDateTime = this.getCurrentDateTime();
      var startTime = new Date(this.zoneWarning.StartTime);
      var deadline = new Date(this.zoneWarning.Deadline);

      if (this.currentDateTime >= startTime && this.currentDateTime < deadline) {
        this.message = this.zoneWarning.InitialMessage;
      } else if (this.currentDateTime >= deadline) {
        this.stopWarningUpdates();
        this.message = this.zoneWarning.FinalMessage;
      }
    },
    stopWarningUpdates: function stopWarningUpdates() {
      clearInterval(this.interval);
      this.interval = null;
    },
    refreshPage: function refreshPage() {
      window.location.reload();
    },
    getCurrentDateTime: function getCurrentDateTime() {
      return new Date();
    }
  }),
  watch: {
    zoneWarning: {
      immediate: true,
      handler: function handler() {
        this.updateWarningMessage();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.stopWarningUpdates();
  }
};

var __vue_script__$m = script$m;
/* template */

var __vue_render__$m = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    staticClass: "vue-warning"
  }, [_c('Modal', {
    staticClass: "vue-warning__modal",
    attrs: {
      "visible": _vm.visible,
      "title": "VUE Update",
      "description": _vm.description,
      "clickClose": _vm.acknowledgeWarning,
      "hasCloseBtn": !_vm.isFinalWarning
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_vm._v("\n\t\t\t" + _vm._s(_vm.message) + "\n\t\t")];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function fn() {
        return [_vm.isFinalWarning ? _c('button', {
          staticClass: "btn btn-default button-small",
          on: {
            "click": _vm.refreshPage
          }
        }, [_vm._v("\n\t\t\t\tRefresh\n\t\t\t")]) : _c('button', {
          staticClass: "btn btn-default button-small",
          on: {
            "click": _vm.acknowledgeWarning
          }
        }, [_vm._v("\n\t\t\t\tOk\n\t\t\t")])];
      },
      proxy: true
    }])
  })], 1);
};

var __vue_staticRenderFns__$m = [];
/* style */

var __vue_inject_styles__$m = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-38c24c32_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-38c24c32]:export{menubreakpoint:992}[data-v-38c24c32]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-38c24c32]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-38c24c32],body.light[data-v-38c24c32]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}[data-v-38c24c32]{@import url(\"https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap\");}[data-v-38c24c32] *{font-family:Lato,sans-serif}[data-v-38c24c32] *,[data-v-38c24c32] ::after,[data-v-38c24c32] ::before{box-sizing:border-box}[data-v-38c24c32] li{list-style:none}[data-v-38c24c32] li::marker{content:none}[data-v-38c24c32] h1,[data-v-38c24c32] h2,[data-v-38c24c32] h3,[data-v-38c24c32] h4,[data-v-38c24c32] h5{margin:0}[data-v-38c24c32] h1{font-size:30px;line-height:36px}[data-v-38c24c32] h2{font-size:24px;line-height:30px}[data-v-38c24c32] h3{font-size:18px;line-height:23px}[data-v-38c24c32] h4{font-size:16px;line-height:19px}[data-v-38c24c32] h5{font-size:14px;line-height:18px}[data-v-38c24c32] p{font-size:16px;margin-block-start:0;margin-block-end:0}[data-v-38c24c32] img{display:inline-block;max-width:100%;max-height:100%}[data-v-38c24c32] button{background:0 0;border:none;padding:none;padding:0;margin:0;cursor:pointer}[data-v-38c24c32] button:focus{outline:0}[data-v-38c24c32] :-ms-input-placeholder,[data-v-38c24c32] ::-moz-placeholder,[data-v-38c24c32] ::-webkit-input-placeholder,[data-v-38c24c32] ::placeholder,[data-v-38c24c32] input::-webkit-input-placeholder{font-size:14px;line-height:normal;color:var(--placeholder)}[data-v-38c24c32] a{text-decoration:none;outline:0}[data-v-38c24c32] .is-hidden{display:none}[data-v-38c24c32] *,[data-v-38c24c32] ::after,[data-v-38c24c32] ::before{box-sizing:border-box}[data-v-38c24c32] ul{margin:0;margin-block-start:0;margin-block-end:0;padding:0;padding-inline-start:0;box-sizing:border-box}[data-v-38c24c32] a{background-color:transparent;color:inherit}.modal__footer>button[data-v-38c24c32]{padding:4px 8px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$m = "data-v-38c24c32";
/* module identifier */

var __vue_module_identifier__$m = undefined;
/* functional template */

var __vue_is_functional_template__$m = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, createInjector, undefined, undefined);

var script$n = {
  name: 'ConcurrentUsers',
  data: function data() {
    return {
      activeMode: 'light',
      listVisible: false,
      showTooltip: false
    };
  },
  props: {
    displayImageCount: {
      type: Number,
      default: 4
    }
  },
  components: {
    ProfileImage: ProfileImage,
    Popover: Popover,
    Badge: Badge
  },
  computed: _objectSpread2(_objectSpread2({}, mapGetters('communicationHub', ['concurrentUsersByGroup', 'displayConcurrentUsers', 'locksEnabled', 'getUserLockByEmployeeId', 'groupName'])), {}, {
    groupConcurrentUsers: function groupConcurrentUsers() {
      return this.concurrentUsersByGroup(this.groupName);
    },
    lockedByUser: function lockedByUser(employeeId) {
      return !!this.getUserLockByEmployeeId(this.groupName, employeeId);
    },
    groupUsersLockDisplayName: function groupUsersLockDisplayName(employeeId) {
      var lock = this.getUserLockByEmployeeId(this.groupName, employeeId);
      return lock ? lock.DisplayName : 'page';
    },
    show: function show() {
      return this.displayConcurrentUsers;
    },
    visibleConcurrentUsers: function visibleConcurrentUsers() {
      //users that will always show above the popover
      var users;

      if (this.groupConcurrentUsers && this.groupConcurrentUsers.length > this.displayImageCount) {
        users = this.groupConcurrentUsers.slice(0, this.displayImageCount);
      } else {
        users = this.groupConcurrentUsers;
      }

      return users;
    },
    activeUserCount: function activeUserCount() {
      var count = 0;

      if (this.groupConcurrentUsers) {
        count = this.groupConcurrentUsers.length;
      }

      return count;
    },
    hiddenUserCount: function hiddenUserCount() {
      var count = 0;

      if (this.groupConcurrentUsers) {
        count = this.groupConcurrentUsers.length - this.displayImageCount;
      }

      return count;
    }
  }),
  methods: {
    onListToggle: function onListToggle() {
      this.listVisible = !this.listVisible;
    },
    nameFromArray: function nameFromArray(name) {
      //the user's name's may be an array of names that come from Employee and Global Employee
      if (Array.isArray(name) && name.length > 0) {
        name = name[0];
      }

      return name;
    },
    onCloseList: function onCloseList() {
      this.listVisible = false;
    }
  }
};

/* script */
var __vue_script__$n = script$n;
/* template */

var __vue_render__$n = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "active-users",
    attrs: {
      "mode": _vm.activeMode
    }
  }, [_c('div', {
    staticClass: "active-users__preview",
    on: {
      "click": _vm.onListToggle
    }
  }, [_c('div', {
    ref: "previewUserImgsRef",
    staticClass: "active-users__preview-profiles"
  }, _vm._l(_vm.visibleConcurrentUsers, function (user) {
    return _c('ProfileImage', {
      key: user.EmployeeId,
      staticClass: "active-users__preview-profiles-item",
      attrs: {
        "imageSrc": user.EmployeeImage,
        "firstName": user.FirstName,
        "lastName": user.LastName
      }
    });
  }), 1), _vm._v(" "), _c('Badge', {
    staticClass: "active-users__preview-count-badge",
    attrs: {
      "text": '+' + _vm.hiddenUserCount,
      "visible": _vm.hiddenUserCount > 0
    }
  }), _vm._v(" "), _vm.hiddenUserCount > 0 ? _c('span', {
    staticClass: "active-users__preview-count-text"
  }, [_vm._v("Active Users")]) : _vm._e()], 1), _vm._v(" "), _c('Popover', {
    attrs: {
      "visible": _vm.listVisible,
      "trackedRefName": "previewUserImgsRef",
      "zIndex": 2500,
      "offset": [0, 16],
      "placement": "bottom"
    },
    on: {
      "close": _vm.onCloseList
    },
    scopedSlots: _vm._u([{
      key: "popoverBody",
      fn: function fn() {
        return [_c('div', {
          staticClass: "active-users__total-users"
        }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.activeUserCount) + " Active Users\n\t\t\t")]), _vm._v(" "), _c('ul', {
          staticClass: "active-users__total-users-list"
        }, _vm._l(_vm.groupConcurrentUsers, function (user) {
          return _c('li', {
            key: user.EmployeeId,
            staticClass: "active-users__total-users-list-item"
          }, [_c('ProfileImage', {
            attrs: {
              "imageSrc": user.EmployeeImage,
              "height": 50,
              "firstName": user.FirstName,
              "lastName": user.LastName
            }
          }), _vm._v(" "), _vm.locksEnabled && _vm.lockedByUser(user.EmployeeId) ? [_c('i', {
            staticClass: "icon icon-lock",
            on: {
              "mouse-over": function mouseOver($event) {
                _vm.showTooltip = true;
              },
              "mouse-leave": function mouseLeave($event) {
                _vm.showTooltip = false;
              }
            }
          }), _vm._v(" "), _vm.showTooltip ? _c('Tooltip', [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.nameFromArray(user.FirstName)) + " " + _vm._s(_vm.nameFromArray(user.LastName)) + " is currently editing the " + _vm._s(_vm.groupUsersLockDisplayName(user.employeeId)) + ".\n\t\t\t\t\t\t")]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('span', {
            staticClass: "active-users__total-users-list-item-name"
          }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.nameFromArray(user.FirstName)) + "\n\t\t\t\t\t\t" + _vm._s(_vm.nameFromArray(user.LastName)) + "\n\t\t\t\t\t")])], 2);
        }), 0)];
      },
      proxy: true
    }])
  })], 1);
};

var __vue_staticRenderFns__$n = [];
/* style */

var __vue_inject_styles__$n = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-760a3e20_0", {
    source: "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap);[data-v-760a3e20]:export{menubreakpoint:992}[data-v-760a3e20]:root{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#009245;--layout_brand-2:#136a3e;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:0,146,69;--layout_brand-2_rgb:19,106,62;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#7e7e7e;--layout_bg-0-fg-3:#585554;--layout_bg-0-fg-4:#0d0d0d;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#585554;--layout_bg-1-fg-3:#0d0d0d;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#585554;--layout_bg-2-fg-3:#0d0d0d;--layout_bg-brand-1:#009245;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#0d0d0d;--layout_bg-brand-1-fg-3:#f9f9f9;--layout_bg-brand-2:#136a3e;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#0d0d0d;--layout_link:#0088cc;--layout_link-hover:#005580;--layout_placeholder:#7e7e7e;--layout_field-bg:#fff;--layout_field-fg:#0d0d0d;--layout_field-fg-extras:#7e7e7e;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#0d0d0d;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#0d0d0d;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#0d0d0d;--layout_tooltip-bg:#585554;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#585554;--layout_popover-border:#cbcbcb}:root [mode=dark][data-v-760a3e20]{--layout_off-white:#f9f9f9;--layout_neutral-1:#ebebeb;--layout_brand-1:#a8f2c1;--layout_brand-2:#05f3d3;--layout_brand-2-tint:#b3ccbf;--layout_brand-1_rgb:168,242,193;--layout_brand-2_rgb:5,243,211;--layout_bg-0:#fff;--layout_bg-0-fg-1:#cbcbcb;--layout_bg-0-fg-2:#4d4d4d;--layout_bg-0-fg-3:#5f5f5f;--layout_bg-0-fg-4:#151515;--layout_bg-1:#f9f9f9;--layout_bg-1-fg-1:#cbcbcb;--layout_bg-1-fg-2:#5f5f5f;--layout_bg-1-fg-3:#151515;--layout_bg-2:#ebebeb;--layout_bg-2-fg-1:#cbcbcb;--layout_bg-2-fg-2:#5f5f5f;--layout_bg-2-fg-3:#151515;--layout_bg-brand-1:#a8f2c1;--layout_bg-brand-1-fg-1:#cbcbcb;--layout_bg-brand-1-fg-2:#f9f9f9;--layout_bg-brand-1-fg-3:#151515;--layout_bg-brand-2:#05f3d3;--layout_bg-brand-2-fg-1:#cbcbcb;--layout_bg-brand-2-fg-2:#f9f9f9;--layout_bg-brand-2-tint:#b3ccbf;--layout_bg-brand-2-tint-fg-1:#cbcbcb;--layout_bg-brand-2-tint-fg-2:#151515;--layout_link:#a8f2c1;--layout_link-hover:#05f3d3;--layout_placeholder:#4d4d4d;--layout_field-bg:#fff;--layout_field-fg:#151515;--layout_field-fg-extras:#4d4d4d;--layout_menu-list-border:#cbcbcb;--layout_menu-list-bg:#fff;--layout_menu-list-fg:#151515;--layout_menu-list-bg-hover:#cbcbcb;--layout_menu-list-fg-hover:#151515;--layout_menu-list-bg-active:#ebebeb;--layout_menu-list-fg-active:#151515;--layout_tooltip-bg:#5f5f5f;--layout_tooltip-fg:#fff;--layout_popover-bg:#fff;--layout_popover-fg:#5f5f5f;--layout_popover-border:#cbcbcb}:root [mode=light][data-v-760a3e20],body.light[data-v-760a3e20]{--ui-negative:#cf2f2d;--ui-negative-light:#fbefee;--ui-warning:#ef9855;--ui-warning-light:#fdf6ec;--ui-positive:#5cb85c;--ui-positive-light:#f1f9f1;--ui-neutral:#5bc0de;--ui-neutral-light:#eef8fc;--ui-purple:#b367f5;--ui-purple-light:#f5ebfd;--ui-indigo:#3f33f5;--ui-indigo-light:#e7e5fd;--ui-yellow:#dbc20c;--ui-yellow-light:#fcf8dd;--ui-magenta:#db18ce;--ui-magenta-light:#faddf8;--brand-1:#ebebeb;--brand-2:#585554;--brand-2_rgb:88,85,84;--brand-2-tint:#cbcbcb;--neutral-0:#f9f9f9;--neutral-1:#ebebeb;--neutral-2:#cbcbcb;--neutral-3:#7e7e7e;--neutral-4:#585554;--neutral-5:#0d0d0d;--bg-0:#fff;--bg-0-fg-1:#cbcbcb;--bg-0-fg-2:#7e7e7e;--bg-0-fg-3:#585554;--bg-0-fg-4:#0d0d0d;--bg-1:#f9f9f9;--bg-1-fg-1:#cbcbcb;--bg-1-fg-2:#585554;--bg-1-fg-3:#0d0d0d;--bg-2:#ebebeb;--bg-2-fg-1:#cbcbcb;--bg-2-fg-2:#585554;--bg-2-fg-3:#0d0d0d;--bg-brand-1:#ebebeb;--bg-brand-1-fg-1:#cbcbcb;--bg-brand-1-fg-2:#0d0d0d;--bg-brand-2:#585554;--bg-brand-2-fg-1:#cbcbcb;--bg-brand-2-fg-2:#f9f9f9;--bg-brand-2-tint:#cbcbcb;--bg-brand-2-tint-fg-1:#585554;--bg-brand-2-tint-fg-2:#0d0d0d;--link:#0088cc;--link-hover:#005580;--link-bg-brand-1:#005580;--link-bg-brand-2:#f9f9f9;--link-bg-brand-2-tint:#005580;--placeholder:#7e7e7e;--backdrop-bg:rgba(0, 0, 0, 0.3);--field-bg:#fff;--field-fg:#0d0d0d;--field-fg-2:#585554;--tooltip-bg:#585554;--tooltip-fg:#f9f9f9;--shadow-color:#0d0d0d;--popover-bg:#fff;--popover-fg:#0d0d0d;--popover-border:#cbcbcb;--draggable-icon-color:#009245;--draggable-border-color:#cbcbcb;--stepper-brand-color:#009245;--stepper-badge-color:#f9f9f9;--btn-progress-bg_rgb:203,203,203;--btn-progress-bg:#cbcbcb;--ui-indictor-bg-light:rgba(255, 255, 255, 0);--hour-selector-bg:#136a3e;--border-hour-selector-hover:#136a3e;--minute-selector-bg:#009245;--border-minute-selector-hover:#009245}[data-v-760a3e20]{@import url(\"https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400;1,700&display=swap\");}[data-v-760a3e20] *{font-family:Lato,sans-serif}[data-v-760a3e20] *,[data-v-760a3e20] ::after,[data-v-760a3e20] ::before{box-sizing:border-box}[data-v-760a3e20] li{list-style:none}[data-v-760a3e20] li::marker{content:none}[data-v-760a3e20] h1,[data-v-760a3e20] h2,[data-v-760a3e20] h3,[data-v-760a3e20] h4,[data-v-760a3e20] h5{margin:0}[data-v-760a3e20] h1{font-size:30px;line-height:36px}[data-v-760a3e20] h2{font-size:24px;line-height:30px}[data-v-760a3e20] h3{font-size:18px;line-height:23px}[data-v-760a3e20] h4{font-size:16px;line-height:19px}[data-v-760a3e20] h5{font-size:14px;line-height:18px}[data-v-760a3e20] p{font-size:16px;margin-block-start:0;margin-block-end:0}[data-v-760a3e20] img{display:inline-block;max-width:100%;max-height:100%}[data-v-760a3e20] button{background:0 0;border:none;padding:none;padding:0;margin:0;cursor:pointer}[data-v-760a3e20] button:focus{outline:0}[data-v-760a3e20] :-ms-input-placeholder,[data-v-760a3e20] ::-moz-placeholder,[data-v-760a3e20] ::-webkit-input-placeholder,[data-v-760a3e20] ::placeholder,[data-v-760a3e20] input::-webkit-input-placeholder{font-size:14px;line-height:normal;color:var(--placeholder)}[data-v-760a3e20] a{text-decoration:none;outline:0}[data-v-760a3e20] .is-hidden{display:none}[data-v-760a3e20] *,[data-v-760a3e20] ::after,[data-v-760a3e20] ::before{box-sizing:border-box}[data-v-760a3e20] ul{margin:0;margin-block-start:0;margin-block-end:0;padding:0;padding-inline-start:0;box-sizing:border-box}[data-v-760a3e20] a{background-color:transparent;color:inherit}.active-users[data-v-760a3e20]{position:absolute;right:0;top:-33px;z-index:6000}.active-users__preview[data-v-760a3e20]{display:flex;flex-direction:row;align-items:center;cursor:pointer}.active-users__preview-count-badge[data-v-760a3e20]{padding:0;margin-left:-9px}.active-users__preview-count-badge[data-v-760a3e20]:deep(.badge__pill){height:24px;width:24px;max-width:24px;border-radius:50%}.active-users__preview-count-text[data-v-760a3e20]{margin-left:4px}.active-users__preview-profiles[data-v-760a3e20]{display:flex;flex-direction:row}.active-users__preview-profiles-item[data-v-760a3e20]:not(:first-child){margin-left:-9px}.active-users__total-users[data-v-760a3e20]{font-weight:700;font-size:14px;line-height:22px;cursor:default;white-space:nowrap}.active-users__total-users-list[data-v-760a3e20]{cursor:default}.active-users__total-users-list-item[data-v-760a3e20]{display:flex;flex-direction:row;align-items:center;margin-top:8px;white-space:nowrap}.active-users__total-users-list-item-name[data-v-760a3e20]{margin-left:8px;font-size:14px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__$n = "data-v-760a3e20";
/* module identifier */

var __vue_module_identifier__$n = undefined;
/* functional template */

var __vue_is_functional_template__$n = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, createInjector, undefined, undefined);

// Import vue component

var installVueUiHeader = function installVueUiHeader(Vue) {
  if (installVueUiHeader.installed) return;
  installVueUiHeader.installed = true;
  Vue.component('VueUiHeader', __vue_component__$e);
};

var installVueUiMenu = function installVueUiMenu(Vue) {
  if (installVueUiMenu.installed) return;
  installVueUiMenu.installed = true;
  Vue.component('VueUiMenu', __vue_component__$h);
};

var installVueUiTitle = function installVueUiTitle(Vue) {
  if (installVueUiTitle.installed) return;
  installVueUiTitle.installed = true;
  Vue.component('VueUiTitle', __vue_component__$k);
};

var installVueUiVersionSwitch = function installVueUiVersionSwitch(Vue) {
  if (installVueUiVersionSwitch.installed) return;
  installVueUiVersionSwitch.installed = true;
  Vue.component('VueUiVersionSwitch', __vue_component__$j);
};

var installVueUiAlerts = function installVueUiAlerts(Vue) {
  if (installVueUiAlerts.installed) return;
  installVueUiAlerts.installed = true;
  Vue.component('VueUiAlerts', __vue_component__$l);
};

var installVueUiWarning = function installVueUiWarning(Vue) {
  if (installVueUiWarning.installed) return;
  installVueUiWarning.installed = true;
  Vue.component('VueUiWarning', __vue_component__$m);
};

var installVueConcurrentUsers = function installVueConcurrentUsers(Vue) {
  if (installVueConcurrentUsers.installed) return;
  installVueConcurrentUsers.installed = true;
  Vue.component('VueConcurrentUsers', __vue_component__$n);
}; // Create module definition for Vue.use()
// to be registered via Vue.use() as well as Vue.component()


__vue_component__$e.install = installVueUiHeader;
__vue_component__$h.install = installVueUiMenu;
__vue_component__$k.install = installVueUiTitle;
__vue_component__$j.install = installVueUiVersionSwitch;
__vue_component__$l.install = installVueUiAlerts;
__vue_component__$m.install = installVueUiWarning;
__vue_component__$n.install = installVueConcurrentUsers; // Export component by default
// export default {
// 	VueUiHeader: header,
// 	VueUiMenu: menu
// };
// It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = component;

var VueUiHeader = __vue_component__$e;
var VueUiMenu = __vue_component__$h;
var VueUiTitle = __vue_component__$k;
var UserInfoModule = userInfoModule;
var UserInfoPlugins = userInfoPlugins;
var HubModule = hubModule;
var VueUiVersionSwitch = __vue_component__$j;
var VueUiAlerts = __vue_component__$l;
var VueConcurrentUsers = __vue_component__$n;
var LoggingModule = loggingModule;
var LoggingMixin = loggingMixin;
var VueUiWarning = __vue_component__$m;
var CommunicationHubModule = communicationHubModule;
var CommunicationHubMutationTypes = communicationHubMutationTypes;
var CommunicationHubMethods = communicationHubMethods;

export { CommunicationHubMethods, CommunicationHubModule, CommunicationHubMutationTypes, HubModule, LoggingMixin, LoggingModule, UserInfoModule, UserInfoPlugins, VueConcurrentUsers, VueUiAlerts, VueUiHeader, VueUiMenu, VueUiTitle, VueUiVersionSwitch, VueUiWarning };
